(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("BrowserFS"));
	else if(typeof define === 'function' && define.amd)
		define(["BrowserFS"], factory);
	else if(typeof exports === 'object')
		exports["Doppio"] = factory(require("BrowserFS"));
	else
		root["Doppio"] = factory(root["BrowserFS"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var doppiojvm=__webpack_require__(1);module.exports=doppiojvm;


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var Testing=__webpack_require__(2);exports.Testing=Testing;var Heap=__webpack_require__(30);exports.Heap=Heap;var VM=__webpack_require__(46);exports.VM=VM;var Debug=__webpack_require__(51);exports.Debug=Debug;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";function makeTestingError(a,b,c){var d=new Error(a);return d.originalError=b,d.fatal=c,d}function findTestClasses(a,b){var c=path.resolve(a,path.join("classes","test"));fs.readdir(c,function(a,c){b(a?[]:c.filter(function(a){return".java"===path.extname(a)}).map(function(a){return path.join("classes","test",path.basename(a,".java"))}))})}function getTests(a,b){var c=a.testClasses;null==c||0===c.length?findTestClasses(a.doppioHomePath,function(c){a.testClasses=c,getTests(a,b)}):b(c.map(function(b){return new DoppioTest(a,b)}))}function diff(a,b){var c=a.split(/\n/),d=b.split(/\n/),e=difflib.text_diff(c,d,2);return e.length>0?"Doppio | Java\n"+e.join("\n"):null}function runTests(a,b,c,d,e,f){function g(a){b||process.stdout.write(a)}getTests(a,function(a){util.asyncForEach(a,function(a,b){g("["+a.cls+"]: Running... "),a.run(e,function(e,f,h,i){e&&!d&&i&&(e.message+="\n"+i),e?(g("fail.\n	"+e.message+"\n"),e.originalError&&e.originalError.stack&&g(e.stack+"\n"),!c||e.fatal?(e.message="Failed "+a.cls+": "+e.message,b(e)):b()):(g("pass.\n"),b())})},f)})}var JVM=__webpack_require__(5),util=__webpack_require__(6),difflib=__webpack_require__(45),path=__webpack_require__(28),fs=__webpack_require__(27),OutputCapturer=function(){function a(){this._stdoutWrite=process.stdout.write,this._stderrWrite=process.stderr.write,this._data="",this._isCapturing=!1}return a.prototype.debugWrite=function(a){this._stdoutWrite.apply(process.stdout,[a,"utf8"])},a.prototype.start=function(a){var b=this;if(this._isCapturing)throw new Error("Already capturing.");this._isCapturing=!0,a&&(this._data=""),process.stderr.write=process.stdout.write=function(a,c,d){return"string"!=typeof a&&(a=a.toString()),b._data+=a,!0}},a.prototype.stop=function(){this._isCapturing&&(this._isCapturing=!1,process.stderr.write=this._stderrWrite,process.stdout.write=this._stdoutWrite)},a.prototype.getOutput=function(a){var b=this._data;return a&&(this._data=""),b},a}(),DoppioTest=function(){function a(a,b){this.outputCapturer=new OutputCapturer,this.opts=a,-1!==b.indexOf(".")&&(b=util.descriptor2typestr(util.int_classname(b))),this.cls=b,this.outFile=path.resolve(a.doppioHomePath,b)+".runout"}return a.prototype.constructJVM=function(a){new JVM(util.merge(JVM.getDefaultOptions(this.opts.doppioHomePath),this.opts,{classpath:[this.opts.doppioHomePath],enableAssertions:!0,enableSystemAssertions:!0}),a)},a.prototype.run=function(a,b){var c=this,d=this.outputCapturer,e=null,f=!1,g=!1,h=!1;a(function(a){if(e)try{e.halt(1)}catch(c){a.message+="\n\nAdditionally, test runner received the following error while trying to halt the JVM: "+c+(c.stack?"\n\n"+c.stack:"")+"\n\nOriginal error's stack trace:"}d.stop(),b(makeTestingError("Uncaught error. Aborting further tests.\n	"+a+(a.stack?"\n\n"+a.stack:""),a,!0))}),this.constructJVM(function(a,i){if(e=i,!f){if(g)return b(makeTestingError("constructJVM returned twice. Aborting further tests.",null,!0));g=!0,a?b(makeTestingError("Could not construct JVM:\n"+a,a)):(d.start(!0),i.runClass(c.cls,[],function(a){if(!f){if(d.stop(),h)return b(makeTestingError("JVM triggered completion callback twice. Aborting further tests.",null,!0));h=!0;var e=d.getOutput(!0);fs.readFile(c.outFile,{encoding:"utf8"},function(a,c){if(a)b(makeTestingError("Could not read runout file:\n"+a,a));else{var d=diff(e,c),f=null;null!==d&&(f="Output does not match native JVM."),b(f?makeTestingError(f):null,e,c,d)}})}}))}})},a}();exports.DoppioTest=DoppioTest,exports.getTests=getTests,exports.diff=diff,exports.runTests=runTests;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var BrowserFS = __webpack_require__(4);module.exports=BrowserFS.BFSRequire('process');


/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(process) {"use strict";var util=__webpack_require__(6),SafeMap=__webpack_require__(10),methods=__webpack_require__(11),ClassLoader=__webpack_require__(20),fs=__webpack_require__(27),path=__webpack_require__(28),buffer=__webpack_require__(29),threading_1=__webpack_require__(15),enums_1=__webpack_require__(9),Heap=__webpack_require__(30),assert=__webpack_require__(13),Parker=__webpack_require__(31),threadpool_1=__webpack_require__(32),JDKInfo=__webpack_require__(33),BrowserFS=__webpack_require__(4),deflate=__webpack_require__(34),inflate=__webpack_require__(40),zstream=__webpack_require__(43),crc32=__webpack_require__(38),adler32=__webpack_require__(37),pkg;pkg=util.are_in_browser()?__webpack_require__(44):__webpack_require__(44);var coreClasses=["Ljava/lang/String;","Ljava/lang/Class;","Ljava/lang/ClassLoader;","Ljava/lang/reflect/Constructor;","Ljava/lang/reflect/Field;","Ljava/lang/reflect/Method;","Ljava/lang/Error;","Ljava/lang/StackTraceElement;","Ljava/lang/System;","Ljava/lang/Thread;","Ljava/lang/ThreadGroup;","Ljava/lang/Throwable;","Ljava/nio/ByteOrder;","Lsun/misc/VM;","Lsun/reflect/ConstantPool;","Ljava/lang/Byte;","Ljava/lang/Character;","Ljava/lang/Double;","Ljava/lang/Float;","Ljava/lang/Integer;","Ljava/lang/Long;","Ljava/lang/Short;","Ljava/lang/Void;","Ljava/io/FileDescriptor;","Ljava/lang/Boolean;","[Lsun/management/MemoryManagerImpl;","[Lsun/management/MemoryPoolImpl;","Lsun/nio/fs/UnixConstants;"],JVM=function(){function JVM(a,b){var c=this;if(this.systemProperties=null,this.internedStrings=new SafeMap,this.bsCl=null,this.threadPool=null,this.natives={},this.heap=new Heap(20971520),this.nativeClasspath=null,this.startupTime=new Date,this.terminationCb=null,this.firstThread=null,this.responsiveness=null,this.enableSystemAssertions=!1,this.enabledAssertions=!1,this.disabledAssertions=[],this.printJITCompilation=!1,this.systemClassLoader=null,this.nextRef=0,this.vtraceMethods={},this.dumpCompiledCodeDir=null,this.parker=new Parker,this.status=enums_1.JVMStatus.BOOTING,this.exitCode=0,this.jitDisabled=!1,this.dumpJITStats=!1,"string"!=typeof a.doppioHomePath)throw new TypeError("opts.doppioHomePath *must* be specified.");a=util.merge(JVM.getDefaultOptions(a.doppioHomePath),a),this.jitDisabled=a.intMode,this.dumpJITStats=a.dumpJITStats;var d,e,f=a.bootstrapClasspath.map(function(a){return path.resolve(a)}),g=[];if(!Array.isArray(a.bootstrapClasspath)||0===a.bootstrapClasspath.length)throw new TypeError("opts.bootstrapClasspath must be specified as an array of file paths.");if(!Array.isArray(a.classpath))throw new TypeError("opts.classpath must be specified as an array of file paths.");if("string"!=typeof a.javaHomePath)throw new TypeError("opts.javaHomePath must be specified.");if(!Array.isArray(a.nativeClasspath)||0===a.nativeClasspath.length)throw new TypeError("opts.nativeClasspath must be specified as an array of file paths.");this.nativeClasspath=a.nativeClasspath,a.enableSystemAssertions&&(this.enableSystemAssertions=a.enableSystemAssertions),a.enableAssertions&&(this.enabledAssertions=a.enableAssertions),a.disableAssertions&&(this.disabledAssertions=a.disableAssertions),this.responsiveness=a.responsiveness,this._initSystemProperties(f,a.classpath.map(function(a){return path.resolve(a)}),path.resolve(a.javaHomePath),path.resolve(a.tmpDir),a.properties),g.push(function(a){c.initializeNatives(a)}),g.push(function(a){c.bsCl=new ClassLoader.BootstrapClassLoader(c.systemProperties["java.home"],f,a)}),g.push(function(a){c.threadPool=new threadpool_1["default"](function(){return c.threadPoolIsEmpty()}),c.bsCl.resolveClass(null,"Ljava/lang/Thread;",function(b){null==b?a("Failed to resolve java/lang/Thread."):(e=new(b.getConstructor(null))(null),e.$thread=d=c.firstThread=new threading_1.JVMThread(c,c.threadPool,e),e.ref=1,e["java/lang/Thread/priority"]=5,e["java/lang/Thread/name"]=util.initCarr(c.bsCl,"main"),e["java/lang/Thread/blockerLock"]=new(c.bsCl.getResolvedClass("Ljava/lang/Object;").getConstructor(d))(d),a())})}),g.push(function(a){util.asyncForEach(coreClasses,function(a,b){c.bsCl.initializeClass(d,a,function(c){if(null==c)b("Failed to initialize "+a);else if("Ljava/lang/ThreadGroup;"===a){var f=c.getConstructor(d),g=new f(d);g["<init>()V"](d,null,function(a){e["java/lang/Thread/group"]=g,b(a)})}else b()})},a)}),g.push(function(a){var b=c.bsCl.getInitializedClass(d,"Ljava/lang/System;").getConstructor(d);b["java/lang/System/initializeSystemClass()V"](d,null,a)}),g.push(function(a){var b=c.bsCl.getInitializedClass(d,"Ljava/lang/ClassLoader;").getConstructor(d);b["java/lang/ClassLoader/getSystemClassLoader()Ljava/lang/ClassLoader;"](d,null,function(b,f){if(b)a(b);else{c.systemClassLoader=f.$loader,e["java/lang/Thread/contextClassLoader"]=f;var g=c.enabledAssertions===!0?1:0;f["java/lang/ClassLoader/setDefaultAssertionStatus(Z)V"](d,[g],a)}})}),g.push(function(a){c.bsCl.initializeClass(d,"Ldoppio/security/DoppioProvider;",function(b){a(b?null:new Error("Failed to initialize DoppioProvider."))})}),util.asyncSeries(g,function(a){setImmediate(function(){a?(c.status=enums_1.JVMStatus.TERMINATED,b(a)):(c.status=enums_1.JVMStatus.BOOTED,b(null,c))})})}return JVM.prototype.getResponsiveness=function(){var a=this.responsiveness;return"number"==typeof a?a:"function"==typeof a?a():void 0},JVM.getDefaultOptions=function(a){var b=path.join(a,"vendor","java_home");return{doppioHomePath:a,classpath:["."],bootstrapClasspath:JDKInfo.classpath.map(function(a){return path.join(b,a)}),javaHomePath:b,nativeClasspath:[path.join(a,"natives")],enableSystemAssertions:!1,enableAssertions:!1,disableAssertions:null,properties:{},tmpDir:"/tmp",responsiveness:1e3,intMode:!1,dumpJITStats:!1}},JVM.getCompiledJDKURL=function(){return JDKInfo.url},JVM.getJDKInfo=function(){return JDKInfo},JVM.prototype.getSystemClassLoader=function(){return this.systemClassLoader},JVM.isReleaseBuild=function(){return!0},JVM.prototype.getNextRef=function(){return this.nextRef++},JVM.prototype.getParker=function(){return this.parker},JVM.prototype.runClass=function(a,b,c){var d=this;if(this.status!==enums_1.JVMStatus.BOOTED)switch(this.status){case enums_1.JVMStatus.BOOTING:throw new Error("JVM is currently booting up. Please wait for it to call the bootup callback, which you passed to the constructor.");case enums_1.JVMStatus.RUNNING:throw new Error("JVM is already running.");case enums_1.JVMStatus.TERMINATED:throw new Error("This JVM has already terminated. Please create a new JVM.");case enums_1.JVMStatus.TERMINATING:throw new Error("This JVM is currently terminating. You should create a new JVM for each class you wish to run.")}this.terminationCb=c;var e=this.firstThread;a=util.int_classname(a),this.systemClassLoader.initializeClass(e,a,function(c){if(null!=c){var f,g=d.bsCl.getInitializedClass(e,"[Ljava/lang/String;").getConstructor(e),h=new g(e,b.length);for(f=0;f<b.length;f++)h.array[f]=util.initString(d.bsCl,b[f]);d.status=enums_1.JVMStatus.RUNNING;var i=c.getConstructor(e);i["main([Ljava/lang/String;)V"]?i["main([Ljava/lang/String;)V"](e,[h]):e.throwNewException("Ljava/lang/NoSuchMethodError;","Could not find main method in class "+c.getExternalName()+".")}else process.stdout.write("Error: Could not find or load main class "+util.ext_classname(a)+"\n"),d.terminationCb(1)})},JVM.prototype.isJITDisabled=function(){return this.jitDisabled},JVM.prototype.shouldVtrace=function(a){return this.vtraceMethods[a]===!0},JVM.prototype.vtraceMethod=function(a){this.vtraceMethods[a]=!0},JVM.prototype.runJar=function(a,b){this.runClass("doppio.JarLauncher",a,b)},JVM.prototype.threadPoolIsEmpty=function(){var a,b;switch(this.status){case enums_1.JVMStatus.BOOTING:return!1;case enums_1.JVMStatus.BOOTED:return!1;case enums_1.JVMStatus.RUNNING:return this.status=enums_1.JVMStatus.TERMINATING,a=this.bsCl.getInitializedClass(this.firstThread,"Ljava/lang/System;"),b=a.getConstructor(this.firstThread),b["java/lang/System/exit(I)V"](this.firstThread,[0]),!1;case enums_1.JVMStatus.TERMINATED:return!1;case enums_1.JVMStatus.TERMINATING:return this.status=enums_1.JVMStatus.TERMINATED,this.terminationCb&&this.terminationCb(this.exitCode),this.firstThread.close(),!0}},JVM.prototype.hasVMBooted=function(){return!(this.status===enums_1.JVMStatus.BOOTING||this.status===enums_1.JVMStatus.BOOTED)},JVM.prototype.halt=function(a){this.exitCode=a,this.status=enums_1.JVMStatus.TERMINATING,this.threadPool.getThreads().forEach(function(a){a.setStatus(enums_1.ThreadStatus.TERMINATED)})},JVM.prototype.getSystemProperty=function(a){return this.systemProperties[a]},JVM.prototype.getSystemPropertyNames=function(){return Object.keys(this.systemProperties)},JVM.prototype.getHeap=function(){return this.heap},JVM.prototype.internString=function(a,b){return this.internedStrings.has(a)?this.internedStrings.get(a):(b||(b=util.initString(this.bsCl,a)),this.internedStrings.set(a,b),b)},JVM.prototype.evalNativeModule=function(mod){var rv,DoppioJVM=__webpack_require__(1),Buffer=buffer.Buffer,process2=process,savedRequire="undefined"!=typeof require?require:function(a){throw new Error("Cannot find module "+a)};return function(){function registerNatives(a){rv=a}eval("\nvar process = process2;\nfunction require(name) {\n  switch(name) {\n    case 'doppiojvm':\n    case '../doppiojvm':\n      return DoppioJVM;\n    case 'fs':\n      return fs;\n    case 'path':\n      return path;\n    case 'buffer':\n      return buffer;\n    case 'browserfs':\n      return BrowserFS;\n    case 'pako/lib/zlib/zstream':\n      return zstream;\n    case 'pako/lib/zlib/inflate':\n      return inflate;\n    case 'pako/lib/zlib/deflate':\n      return deflate;\n    case 'pako/lib/zlib/crc32':\n      return crc32;\n    case 'pako/lib/zlib/adler32':\n      return adler32;\n    case 'crypto':\n      return util.are_in_browser() ? null : savedRequire('crypto');\n    default:\n      return savedRequire(name);\n  }\n}\n/**\n * Emulate AMD module 'define' function for natives compiled as AMD modules.\n */\nfunction define(resources, module) {\n  var args = [];\n  resources.forEach(function(resource) {\n    switch (resource) {\n      case 'require':\n        args.push(require);\n        break;\n      case 'exports':\n        args.push({});\n        break;\n      default:\n        args.push(require(resource));\n        break;\n    }\n  });\n  module.apply(null, args);\n}\neval(mod);\n")}(),rv},JVM.prototype.registerNatives=function(a){var b,c;for(b in a)if(a.hasOwnProperty(b)){this.natives.hasOwnProperty(b)||(this.natives[b]={});var d=a[b];for(c in d)d.hasOwnProperty(c)&&(this.natives[b][c]=d[c])}},JVM.prototype.registerNative=function(a,b,c){this.registerNatives({clsName:{methSig:c}})},JVM.prototype.getNative=function(a,b){if(a=util.descriptor2typestr(a),this.natives.hasOwnProperty(a)){var c=this.natives[a];if(c.hasOwnProperty(b))return c[b]}return null},JVM.prototype.getNatives=function(){return this.natives},JVM.prototype.initializeNatives=function(a){var b=this,c=function(){if(d===b.nativeClasspath.length){var f=e.length;e.forEach(function(c){fs.readFile(c,function(c,d){c||b.registerNatives(b.evalNativeModule(d.toString())),0===--f&&a()})})}else{var g=b.nativeClasspath[d++];fs.readdir(g,function(b,d){if(b)return a();var f,h;for(f=0;f<d.length;f++)h=d[f],".js"===h.substring(h.length-3,h.length)&&e.push(path.join(g,h));c()})}},d=0,e=[];c()},JVM.prototype._initSystemProperties=function(a,b,c,d,e){this.systemProperties=util.merge({"java.class.path":b.join(":"),"java.home":c,"java.ext.dirs":path.join(c,"lib","ext"),"java.io.tmpdir":d,"sun.boot.class.path":a.join(":"),"file.encoding":"UTF-8","java.vendor":"Doppio","java.version":"1.8","java.vendor.url":"https://github.com/plasma-umass/doppio","java.class.version":"52.0","java.specification.version":"1.8","line.separator":"\n","file.separator":path.sep,"path.separator":":","user.dir":path.resolve("."),"user.home":".","user.name":"DoppioUser","os.name":"doppio","os.arch":"js","os.version":"0","java.vm.name":"DoppioJVM 32-bit VM","java.vm.version":pkg.version,"java.vm.vendor":"PLASMA@UMass","java.awt.headless":util.are_in_browser().toString(),"java.awt.graphicsenv":"classes.awt.CanvasGraphicsEnvironment","jline.terminal":"jline.UnsupportedTerminal","sun.arch.data.model":"32","sun.jnu.encoding":"UTF-8"},e)},JVM.prototype.getBootstrapClassLoader=function(){return this.bsCl},JVM.prototype.getStartupTime=function(){return this.startupTime},JVM.prototype.areSystemAssertionsEnabled=function(){return this.enableSystemAssertions},JVM.prototype.getEnabledAssertions=function(){return this.enabledAssertions},JVM.prototype.getDisabledAssertions=function(){return this.disabledAssertions},JVM.prototype.setPrintJITCompilation=function(a){this.printJITCompilation=a},JVM.prototype.shouldPrintJITCompilation=function(){return this.printJITCompilation},JVM.prototype.dumpCompiledCode=function(a){this.dumpCompiledCodeDir=a},JVM.prototype.shouldDumpCompiledCode=function(){return null!==this.dumpCompiledCodeDir},JVM.prototype.dumpObjectDefinition=function(a,b){this.shouldDumpCompiledCode()&&fs.writeFile(path.resolve(this.dumpCompiledCodeDir,a.getExternalName()+"_object.dump"),b,function(){})},JVM.prototype.dumpBridgeMethod=function(a,b){this.shouldDumpCompiledCode()&&fs.appendFile(path.resolve(this.dumpCompiledCodeDir,"vmtarget_bridge_methods.dump"),a+":\n"+b+"\n\n",function(){})},JVM.prototype.dumpState=function(a,b){fs.appendFile(a,this.threadPool.getThreads().map(function(a){return"Thread "+a.getRef()+":\n"+a.getPrintableStackTrace()}).join("\n\n"),b)},JVM}();module.exports=JVM;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {"use strict";function merge(){for(var a=[],b=0;b<arguments.length;b++)a[b-0]=arguments[b];var c={};return a.forEach(function(a){Object.keys(a).forEach(function(b){c[b]=a[b]})}),c}function are_in_browser(){return"browser"===process.platform}function jvmName2JSName(a){switch(a[0]){case"L":return a.slice(1,a.length-1).replace(/_/g,"__").replace(/[\/.;$<>\[\]:\\=^-]/g,"_");case"[":return"ARR_"+jvmName2JSName(a.slice(1));default:return a}}function reescapeJVMName(a){return a.replace(/\\/g,"\\\\")}function asyncForEach(a,b,c){function d(f){f?c(f):(e++,e<a.length?b(a[e],d):c())}var e=-1;d()}function asyncSeries(a,b){function c(e){e?b(e):(d++,d<a.length?a[d](c):b())}var d=-1;c()}function asyncFind(a,b,c){function d(f){f?c(a[e]):(e++,e<a.length?b(a[e],d):c())}var e=-1;d(!1)}function checkAccess(a,b,c){return c.isPublic()?!0:c.isProtected()?a.getPackageName()===b.getPackageName()||a.isSubclass(b):c.isPrivate()?a===b:a.getPackageName()===b.getPackageName()}function float2int(a){return a>enums.Constants.INT_MAX?enums.Constants.INT_MAX:a<enums.Constants.INT_MIN?enums.Constants.INT_MIN:0|a}function byteArray2Buffer(a,b,c){if(void 0===b&&(b=0),void 0===c&&(c=a.length),supportsArrayBuffers&&ArrayBuffer.isView(a)){var d=a.byteOffset;return new Buffer(a.buffer.slice(d,d+a.length))}var e,f=new Buffer(c);for(e=0;c>e;e++)f.writeInt8(a[b+e],e);return f}function isUint8Array(a){return!!(a&&"undefined"!=typeof Uint8Array&&a instanceof Uint8Array)}function isInt8Array(a){return!!(a&&"undefined"!=typeof Int8Array&&a instanceof Int8Array)}function i82u8(a,b,c){if(isInt8Array(a))return new Uint8Array(a.buffer,a.byteOffset+b,c);if(Array.isArray(a)){if("undefined"!=typeof Uint8Array){var d=new Int8Array(c);return 0===b&&c===a.length?d.set(a,0):d.set(a.slice(b,b+c),0),new Uint8Array(d.buffer)}for(var e=new Array(c),f=0;c>f;f++)e[f]=255&a[b+f];return e}throw new TypeError("Invalid array.")}function u82i8(a,b,c){if(isUint8Array(a))return new Int8Array(a.buffer,a.byteOffset+b,c);if(Array.isArray(a)){if("undefined"!=typeof Int8Array){var d=new Uint8Array(c);return 0===b&&c===a.length?d.set(a,0):d.set(a.slice(b,b+c),0),new Int8Array(d.buffer)}for(var e=new Array(c),f=0;c>f;f++)e[f]=a[b+f],e[f]>127&&(e[f]|=4294967168);return e}throw new TypeError("Invalid array.")}function buff2i8(a){var b=BFSUtils.buffer2Arrayish(a);return u82i8(b,0,b.length)}function wrapFloat(a){return a>3.4028234663852886e38?Number.POSITIVE_INFINITY:a>0&&1.401298464324817e-45>a?0:-3.4028234663852886e38>a?Number.NEGATIVE_INFINITY:0>a&&a>-1.401298464324817e-45?0:a}function chars2jsStr(a,b,c){void 0===b&&(b=0),void 0===c&&(c=a.array.length);var d,e=a.array,f="",g=b+c;for(d=b;g>d;d++)f+=String.fromCharCode(e[d]);return f}function bytestr2Array(a){for(var b=[],c=0;c<a.length;c++)b.push(a.charCodeAt(c));return b}function array2bytestr(a){for(var b="",c=0;c<a.length;c++)b+=String.fromCharCode(a[c]);return b}function initialValue(a){if("J"===a)return gLong.ZERO;var b=a[0];return"["===b||"L"===b?null:0}function ext_classname(a){return descriptor2typestr(a).replace(/\//g,".")}function int_classname(a){return typestr2descriptor(a.replace(/\./g,"/"))}function verify_int_classname(a){var b=a.match(/^\[*/)[0].length;if(b>255)return!1;if(b>0&&(a=a.slice(b)),"L"===a[0]){if(";"!==a[a.length-1])return!1;a=a.slice(1,-1)}if(a in exports.internal2external)return!0;if(a.match(/\/{2,}/))return!1;for(var c=a.split("/"),d=0;d<c.length;d++)if(c[d].match(/[^$_a-z0-9]/i))return!1;return!0}function getTypes(a){var b,c=0,d=[];for(c=0;c<a.length;c++)switch(a.charAt(c)){case"(":case")":break;case"L":b=a.indexOf(";",c),d.push(a.slice(c,b+1)),c=b;break;case"[":for(b=c+1;"["===a.charAt(b);)b++;"L"===a.charAt(b)?(b=a.indexOf(";",b),d.push(a.slice(c,b+1))):d.push(a.slice(c,b+1)),c=b;break;default:d.push(a.charAt(c))}return d}function get_component_type(a){return a.slice(1)}function is_array_type(a){return"["===a[0]}function is_primitive_type(a){return a in exports.internal2external}function is_reference_type(a){return"L"===a[0]}function descriptor2typestr(a){var b=a[0];if(b in exports.internal2external)return exports.internal2external[b];if("L"===b)return a.slice(1,-1);if("["===b)return a;throw new Error("Unrecognized type string: "+a)}function carr2descriptor(a){var b=a.shift();if(null==b)return null;if(void 0!==exports.internal2external[b])return b;if("L"===b){for(var c="L";";"!==(b=a.shift());)c+=b;return c+";"}if("["===b)return"["+carr2descriptor(a);throw a.unshift(b),new Error("Unrecognized descriptor: "+a.join(""))}function typestr2descriptor(a){return void 0!==exports.external2internal[a]?exports.external2internal[a]:"["===a[0]?a:"L"+a+";"}function unboxArguments(a,b,c){var d,e,f,g=[];for(d=0;d<b.length;d++)e=b[d],f=c[d],is_primitive_type(e)?(g.push(f.unbox()),"J"!==e&&"D"!==e||g.push(null)):g.push(f);return g}function createMethodType(a,b,c,d){b.initializeClass(a,"Ljava/lang/invoke/MethodHandleNatives;",function(e){if(null!==e){var f=e.getConstructor(a),g=getTypes(c);g.push("[Ljava/lang/Class;"),b.resolveClasses(a,g,function(b){var c=g.map(function(c){return b[c].getClassObject(a)});c.pop();var e=c.pop(),h=b["[Ljava/lang/Class;"].getConstructor(a),i=new h(a,c.length);i.array=c,f["java/lang/invoke/MethodHandleNatives/findMethodHandleType(Ljava/lang/Class;[Ljava/lang/Class;)Ljava/lang/invoke/MethodType;"](a,[e,i],d)})}})}function getMethodDescriptorWordSize(a){var b,c,d=getTypes(a),e=d.length-1;for(d.pop(),b=0;b<d.length;b++)c=d[b],"D"!==c&&"J"!==c||e++;return e}function getDescriptorString(a,b){var c="(";return void 0!==b&&null!==b&&b.array.forEach(function(a){c+=a.$cls.getInternalName()}),c+=")"+a.$cls.getInternalName()}function getLoader(a,b){return null!=b&&null!=b.$loader?b.$loader:a.getBsCl()}function arraycopyNoCheck(a,b,c,d,e){for(var f=d,g=b+e,h=b;g>h;h++)c.array[f++]=a.array[h]}function arraycopyCheck(a,b,c,d,e,f){for(var g=e,h=c+f,i=d.getClass().getComponentClass(),j=c;h>j;j++){if(null!==b.array[j]&&!b.array[j].getClass().isCastable(i))return void a.throwNewException("Ljava/lang/ArrayStoreException;","Array element in src cannot be cast to dest array type.");d.array[g]=b.array[j],g++}}function initString(a,b){var c=initCarr(a,b),d=a.getResolvedClass("Ljava/lang/String;").getConstructor(null),e=new d(null);return e["java/lang/String/value"]=c,e}function initCarr(a,b){for(var c=a.getInitializedClass(null,"[C").getConstructor(null),d=new c(null,b.length),e=d.array,f=0;f<b.length;f++)e[f]=b.charCodeAt(f);return d}function newArrayFromClass(a,b,c){return new(b.getConstructor(a))(a,c)}function newArray(a,b,c,d){var e=b.getInitializedClass(a,c);return newArrayFromClass(a,e,d)}function multiNewArray(a,b,c,d){var e=b.getInitializedClass(a,c);return new(e.getConstructor(a))(a,d)}function newObjectFromClass(a,b){return new(b.getConstructor(a))(a)}function newObject(a,b,c){var d=b.getInitializedClass(a,c);return newObjectFromClass(a,d)}function getStaticFields(a,b,c){return b.getInitializedClass(a,c).getConstructor(a)}function newArrayFromDataWithClass(a,b,c){var d=newArrayFromClass(a,b,0);return d.array=c,d}function newArrayFromData(a,b,c,d){var e=newArray(a,b,c,0);return e.array=d,e}function boxClassName(a){switch(a){case"B":return"Ljava/lang/Byte;";case"C":return"Ljava/lang/Character;";case"D":return"Ljava/lang/Double;";case"F":return"Ljava/lang/Float;";case"I":return"Ljava/lang/Integer;";case"J":return"Ljava/lang/Long;";case"S":return"Ljava/lang/Short;";case"Z":return"Ljava/lang/Boolean;";case"V":return"Ljava/lang/Void;";default:throw new Error("Tried to box a non-primitive class: "+this.className)}}function boxPrimitiveValue(a,b,c){var d=a.getBsCl().getInitializedClass(a,boxClassName(b)),e=d.getConstructor(a);return e.box(c)}function boxArguments(a,b,c,d,e,f){void 0===f&&(f=0);var g,h,i=getTypes(c),j=newArrayFromClass(a,b,i.length-(e?1:2)-f),k=0,l=j.array;for(i.pop(),e||i.shift(),f>0&&(i=i.slice(f),d=d.slice(f)),g=0;g<i.length;g++){switch(h=i[g],h[0]){case"[":case"L":l[g]=d[k];break;case"J":case"D":l[g]=boxPrimitiveValue(a,h,d[k]),k++;break;default:l[g]=boxPrimitiveValue(a,h,d[k])}k++}return j}function forwardResult(a){return function(b,c){b?a.throwException(b):a.asyncReturn(c)}}var gLong=__webpack_require__(8),enums=__webpack_require__(9),BrowserFS=__webpack_require__(4),BFSUtils=BrowserFS.BFSRequire("bfs_utils");exports.merge=merge,exports.are_in_browser=are_in_browser,exports.typedArraysSupported="undefined"!=typeof ArrayBuffer,exports.jvmName2JSName=jvmName2JSName,exports.reescapeJVMName=reescapeJVMName,exports.asyncForEach=asyncForEach,exports.asyncSeries=asyncSeries,exports.asyncFind=asyncFind,Math.imul||(Math.imul=function(a,b){var c=a>>>16&65535,d=65535&a,e=b>>>16&65535,f=65535&b;return d*f+(c*f+d*e<<16>>>0)|0}),Math.expm1||(Math.expm1=function(a){return Math.abs(a)<1e-5?a+.5*a*a:Math.exp(a)-1}),Math.sinh||(Math.sinh=function(a){var b=Math.exp(a);return(b-1/b)/2}),Array.prototype.indexOf||(Array.prototype.indexOf=function(a,b){if(null==this)throw new TypeError;var c=Object(this),d=c.length>>>0;if(0===d)return-1;var e=0;if(void 0!==b&&(e=Number(b),e!=e?e=0:0!=e&&e!=1/0&&e!=-(1/0)&&(e=((e>0?1:0)||-1)*Math.floor(Math.abs(e)))),e>=d)return-1;for(var f=e>=0?e:Math.max(d-Math.abs(e),0);d>f;f++)if(f in c&&c[f]===a)return f;return-1}),exports.checkAccess=checkAccess,exports.float2int=float2int;var supportsArrayBuffers="undefined"!=typeof ArrayBuffer;exports.byteArray2Buffer=byteArray2Buffer,exports.isUint8Array=isUint8Array,exports.isInt8Array=isInt8Array,exports.i82u8=i82u8,exports.u82i8=u82i8,exports.buff2i8=buff2i8,exports.wrapFloat=wrapFloat,exports.chars2jsStr=chars2jsStr,exports.bytestr2Array=bytestr2Array,exports.array2bytestr=array2bytestr,function(a){a[a.PUBLIC=1]="PUBLIC",a[a.PRIVATE=2]="PRIVATE",a[a.PROTECTED=4]="PROTECTED",a[a.STATIC=8]="STATIC",a[a.FINAL=16]="FINAL",a[a.SYNCHRONIZED=32]="SYNCHRONIZED",a[a.SUPER=32]="SUPER",a[a.VOLATILE=64]="VOLATILE",a[a.TRANSIENT=128]="TRANSIENT",a[a.VARARGS=128]="VARARGS",a[a.NATIVE=256]="NATIVE",a[a.INTERFACE=512]="INTERFACE",a[a.ABSTRACT=1024]="ABSTRACT",a[a.STRICT=2048]="STRICT"}(exports.FlagMasks||(exports.FlagMasks={}));var FlagMasks=exports.FlagMasks,Flags=function(){function a(a){this["byte"]=a}return a.prototype.isPublic=function(){return(this["byte"]&FlagMasks.PUBLIC)>0},a.prototype.isPrivate=function(){return(this["byte"]&FlagMasks.PRIVATE)>0},a.prototype.isProtected=function(){return(this["byte"]&FlagMasks.PROTECTED)>0},a.prototype.isStatic=function(){return(this["byte"]&FlagMasks.STATIC)>0},a.prototype.isFinal=function(){return(this["byte"]&FlagMasks.FINAL)>0},a.prototype.isSynchronized=function(){return(this["byte"]&FlagMasks.SYNCHRONIZED)>0},a.prototype.isSuper=function(){return(this["byte"]&FlagMasks.SUPER)>0},a.prototype.isVolatile=function(){return(this["byte"]&FlagMasks.VOLATILE)>0},a.prototype.isTransient=function(){return(this["byte"]&FlagMasks.TRANSIENT)>0},a.prototype.isNative=function(){return(this["byte"]&FlagMasks.NATIVE)>0},a.prototype.isInterface=function(){return(this["byte"]&FlagMasks.INTERFACE)>0},a.prototype.isAbstract=function(){return(this["byte"]&FlagMasks.ABSTRACT)>0},a.prototype.isStrict=function(){return(this["byte"]&FlagMasks.STRICT)>0},a.prototype.setNative=function(a){a?this["byte"]=this["byte"]|FlagMasks.NATIVE:this["byte"]=this["byte"]&~FlagMasks.NATIVE},a.prototype.isVarArgs=function(){return(this["byte"]&FlagMasks.VARARGS)>0},a.prototype.getRawByte=function(){return this["byte"]},a}();exports.Flags=Flags,exports.initialValue=initialValue,exports.ext_classname=ext_classname,exports.int_classname=int_classname,exports.verify_int_classname=verify_int_classname,exports.internal2external={B:"byte",C:"char",D:"double",F:"float",I:"int",J:"long",S:"short",V:"void",Z:"boolean"},exports.external2internal={};for(var k in exports.internal2external)exports.external2internal[exports.internal2external[k]]=k;exports.getTypes=getTypes,exports.get_component_type=get_component_type,exports.is_array_type=is_array_type,exports.is_primitive_type=is_primitive_type,exports.is_reference_type=is_reference_type,exports.descriptor2typestr=descriptor2typestr,exports.carr2descriptor=carr2descriptor,exports.typestr2descriptor=typestr2descriptor,exports.unboxArguments=unboxArguments,exports.createMethodType=createMethodType,exports.getMethodDescriptorWordSize=getMethodDescriptorWordSize,exports.getDescriptorString=getDescriptorString,exports.getLoader=getLoader,exports.arraycopyNoCheck=arraycopyNoCheck,exports.arraycopyCheck=arraycopyCheck,exports.initString=initString,exports.initCarr=initCarr,exports.newArrayFromClass=newArrayFromClass,exports.newArray=newArray,exports.multiNewArray=multiNewArray,exports.newObjectFromClass=newObjectFromClass,exports.newObject=newObject,exports.getStaticFields=getStaticFields,exports.newArrayFromDataWithClass=newArrayFromDataWithClass,exports.newArrayFromData=newArrayFromData,exports.boxClassName=boxClassName,exports.boxPrimitiveValue=boxPrimitiveValue,exports.boxArguments=boxArguments,exports.forwardResult=forwardResult;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3), __webpack_require__(7)))

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var BrowserFS = __webpack_require__(4);module.exports=BrowserFS.BFSRequire('buffer').Buffer;

/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";var gLong=function(){function a(a,b){this.low_=0|a,this.high_=0|b}return a.fromInt=function(b){if(b>=-128&&128>b){var c=a.IntCache_[b];if(c)return c}var d=new a(b,0>b?-1:0);return b>=-128&&128>b&&(a.IntCache_[b]=d),d},a.fromNumber=function(b){return isNaN(b)||!isFinite(b)?a.ZERO:b<=-a.TWO_PWR_63_DBL_?a.MIN_VALUE:b+1>=a.TWO_PWR_63_DBL_?a.MAX_VALUE:0>b?a.fromNumber(-b).negate():new a(b%a.TWO_PWR_32_DBL_|0,b/a.TWO_PWR_32_DBL_|0)},a.fromBits=function(b,c){return new a(b,c)},a.fromString=function(b,c){if(0==b.length)throw Error("number format error: empty string");var d=c||10;if(2>d||d>36)throw Error("radix out of range: "+d);if("-"==b.charAt(0))return a.fromString(b.substring(1),d).negate();if(b.indexOf("-")>=0)throw Error('number format error: interior "-" character: '+b);for(var e=a.fromNumber(Math.pow(d,8)),f=a.ZERO,g=0;g<b.length;g+=8){var h=Math.min(8,b.length-g),i=parseInt(b.substring(g,g+h),d);if(8>h){var j=a.fromNumber(Math.pow(d,h));f=f.multiply(j).add(a.fromNumber(i))}else f=f.multiply(e),f=f.add(a.fromNumber(i))}return f},a.prototype.toInt=function(){return this.low_},a.prototype.toNumber=function(){return this.high_*a.TWO_PWR_32_DBL_+this.getLowBitsUnsigned()},a.prototype.toString=function(b){var c=b||10;if(2>c||c>36)throw Error("radix out of range: "+c);if(this.isZero())return"0";if(this.isNegative()){if(this.equals(a.MIN_VALUE)){var d=a.fromNumber(c),e=this.div(d),f=e.multiply(d).subtract(this);return e.toString(c)+f.toInt().toString(c)}return"-"+this.negate().toString(c)}for(var g=a.fromNumber(Math.pow(c,6)),f=this,h="";;){var i=f.div(g),j=f.subtract(i.multiply(g)).toInt(),k=j.toString(c);if(f=i,f.isZero())return k+h;for(;k.length<6;)k="0"+k;h=""+k+h}},a.prototype.getHighBits=function(){return this.high_},a.prototype.getLowBits=function(){return this.low_},a.prototype.getLowBitsUnsigned=function(){return this.low_>=0?this.low_:a.TWO_PWR_32_DBL_+this.low_},a.prototype.getNumBitsAbs=function(){if(this.isNegative())return this.equals(a.MIN_VALUE)?64:this.negate().getNumBitsAbs();for(var b=0!=this.high_?this.high_:this.low_,c=31;c>0&&0==(b&1<<c);c--);return 0!=this.high_?c+33:c+1},a.prototype.isZero=function(){return 0==this.high_&&0==this.low_},a.prototype.isNegative=function(){return this.high_<0},a.prototype.isOdd=function(){return 1==(1&this.low_)},a.prototype.equals=function(a){return this.high_==a.high_&&this.low_==a.low_},a.prototype.notEquals=function(a){return this.high_!=a.high_||this.low_!=a.low_},a.prototype.lessThan=function(a){return this.compare(a)<0},a.prototype.lessThanOrEqual=function(a){return this.compare(a)<=0},a.prototype.greaterThan=function(a){return this.compare(a)>0},a.prototype.greaterThanOrEqual=function(a){return this.compare(a)>=0},a.prototype.compare=function(a){if(this.equals(a))return 0;var b=this.isNegative(),c=a.isNegative();return b&&!c?-1:!b&&c?1:this.subtract(a).isNegative()?-1:1},a.prototype.negate=function(){return this.equals(a.MIN_VALUE)?a.MIN_VALUE:this.not().add(a.ONE)},a.prototype.add=function(b){var c=this.high_>>>16,d=65535&this.high_,e=this.low_>>>16,f=65535&this.low_,g=b.high_>>>16,h=65535&b.high_,i=b.low_>>>16,j=65535&b.low_,k=0,l=0,m=0,n=0;return n+=f+j,m+=n>>>16,n&=65535,m+=e+i,l+=m>>>16,m&=65535,l+=d+h,k+=l>>>16,l&=65535,k+=c+g,k&=65535,a.fromBits(m<<16|n,k<<16|l)},a.prototype.subtract=function(a){return this.add(a.negate())},a.prototype.multiply=function(b){if(this.isZero())return a.ZERO;if(b.isZero())return a.ZERO;if(this.equals(a.MIN_VALUE))return b.isOdd()?a.MIN_VALUE:a.ZERO;if(b.equals(a.MIN_VALUE))return this.isOdd()?a.MIN_VALUE:a.ZERO;if(this.isNegative())return b.isNegative()?this.negate().multiply(b.negate()):this.negate().multiply(b).negate();if(b.isNegative())return this.multiply(b.negate()).negate();if(this.lessThan(a.TWO_PWR_24_)&&b.lessThan(a.TWO_PWR_24_))return a.fromNumber(this.toNumber()*b.toNumber());var c=this.high_>>>16,d=65535&this.high_,e=this.low_>>>16,f=65535&this.low_,g=b.high_>>>16,h=65535&b.high_,i=b.low_>>>16,j=65535&b.low_,k=0,l=0,m=0,n=0;return n+=f*j,m+=n>>>16,n&=65535,m+=e*j,l+=m>>>16,m&=65535,m+=f*i,l+=m>>>16,m&=65535,l+=d*j,k+=l>>>16,l&=65535,l+=e*i,k+=l>>>16,l&=65535,l+=f*h,k+=l>>>16,l&=65535,k+=c*j+d*i+e*h+f*g,k&=65535,a.fromBits(m<<16|n,k<<16|l)},a.prototype.div=function(b){if(b.isZero())throw Error("division by zero");if(this.isZero())return a.ZERO;if(this.equals(a.MIN_VALUE)){if(b.equals(a.ONE)||b.equals(a.NEG_ONE))return a.MIN_VALUE;if(b.equals(a.MIN_VALUE))return a.ONE;var c=this.shiftRight(1),d=c.div(b).shiftLeft(1);if(d.equals(a.ZERO))return b.isNegative()?a.ONE:a.NEG_ONE;var e=this.subtract(b.multiply(d)),f=d.add(e.div(b));return f}if(b.equals(a.MIN_VALUE))return a.ZERO;if(this.isNegative())return b.isNegative()?this.negate().div(b.negate()):this.negate().div(b).negate();if(b.isNegative())return this.div(b.negate()).negate();for(var g=a.ZERO,e=this;e.greaterThanOrEqual(b);){var h=Math.max(1,Math.floor(e.toNumber()/b.toNumber())),i=Math.ceil(Math.log(h)/Math.LN2),j=1;i>48&&(j=Math.pow(2,i-48));for(var k=a.fromNumber(h),l=k.multiply(b);l.isNegative()||l.greaterThan(e);)h-=j,k=a.fromNumber(h),l=k.multiply(b);k.isZero()&&(k=a.ONE),g=g.add(k),e=e.subtract(l)}return g},a.prototype.modulo=function(a){return this.subtract(this.div(a).multiply(a))},a.prototype.not=function(){return a.fromBits(~this.low_,~this.high_)},a.prototype.and=function(b){return a.fromBits(this.low_&b.low_,this.high_&b.high_)},a.prototype.or=function(b){return a.fromBits(this.low_|b.low_,this.high_|b.high_)},a.prototype.xor=function(b){return a.fromBits(this.low_^b.low_,this.high_^b.high_)},a.prototype.shiftLeft=function(b){if(b&=63,0==b)return this;var c=this.low_;if(32>b){var d=this.high_;return a.fromBits(c<<b,d<<b|c>>>32-b)}return a.fromBits(0,c<<b-32)},a.prototype.shiftRight=function(b){if(b&=63,0==b)return this;var c=this.high_;if(32>b){var d=this.low_;return a.fromBits(d>>>b|c<<32-b,c>>b)}return a.fromBits(c>>b-32,c>=0?0:-1)},a.prototype.shiftRightUnsigned=function(b){if(b&=63,0==b)return this;var c=this.high_;if(32>b){var d=this.low_;return a.fromBits(d>>>b|c<<32-b,c>>>b)}return 32==b?a.fromBits(c,0):a.fromBits(c>>>b-32,0)},a.IntCache_={},a.TWO_PWR_16_DBL_=65536,a.TWO_PWR_24_DBL_=1<<24,a.TWO_PWR_32_DBL_=a.TWO_PWR_16_DBL_*a.TWO_PWR_16_DBL_,a.TWO_PWR_31_DBL_=a.TWO_PWR_32_DBL_/2,a.TWO_PWR_48_DBL_=a.TWO_PWR_32_DBL_*a.TWO_PWR_16_DBL_,a.TWO_PWR_64_DBL_=a.TWO_PWR_32_DBL_*a.TWO_PWR_32_DBL_,a.TWO_PWR_63_DBL_=a.TWO_PWR_64_DBL_/2,a.ZERO=a.fromInt(0),a.ONE=a.fromInt(1),a.NEG_ONE=a.fromInt(-1),a.MAX_VALUE=a.fromBits(4294967295,2147483647),a.MIN_VALUE=a.fromBits(0,2147483648),a.TWO_PWR_24_=a.fromInt(a.TWO_PWR_24_DBL_),a}();module.exports=gLong;


/***/ },
/* 9 */
/***/ function(module, exports) {

	"use strict";function assignOpcodeLayout(a,b){b.forEach(function(b){olt[b]=a})}!function(a){a[a.NOT_LOADED=0]="NOT_LOADED",a[a.LOADED=1]="LOADED",a[a.RESOLVED=2]="RESOLVED",a[a.INITIALIZED=3]="INITIALIZED"}(exports.ClassState||(exports.ClassState={}));var ClassState=exports.ClassState;!function(a){a[a.NEW=0]="NEW",a[a.RUNNABLE=1]="RUNNABLE",a[a.BLOCKED=2]="BLOCKED",a[a.UNINTERRUPTABLY_BLOCKED=3]="UNINTERRUPTABLY_BLOCKED",a[a.WAITING=4]="WAITING",a[a.TIMED_WAITING=5]="TIMED_WAITING",a[a.ASYNC_WAITING=6]="ASYNC_WAITING",a[a.PARKED=7]="PARKED",a[a.TERMINATED=8]="TERMINATED"}(exports.ThreadStatus||(exports.ThreadStatus={}));var ThreadStatus=exports.ThreadStatus;!function(a){a[a.ALIVE=1]="ALIVE",a[a.TERMINATED=2]="TERMINATED",a[a.RUNNABLE=4]="RUNNABLE",a[a.BLOCKED_ON_MONITOR_ENTER=1024]="BLOCKED_ON_MONITOR_ENTER",a[a.WAITING_INDEFINITELY=16]="WAITING_INDEFINITELY",a[a.WAITING_WITH_TIMEOUT=32]="WAITING_WITH_TIMEOUT"}(exports.JVMTIThreadState||(exports.JVMTIThreadState={}));var JVMTIThreadState=exports.JVMTIThreadState;!function(a){a[a.TRUE=0]="TRUE",a[a.FALSE=1]="FALSE",a[a.INDETERMINATE=2]="INDETERMINATE"}(exports.TriState||(exports.TriState={}));var TriState=exports.TriState;!function(a){a[a.BOOTING=0]="BOOTING",a[a.BOOTED=1]="BOOTED",a[a.RUNNING=2]="RUNNING",a[a.TERMINATING=3]="TERMINATING",a[a.TERMINATED=4]="TERMINATED"}(exports.JVMStatus||(exports.JVMStatus={}));var JVMStatus=exports.JVMStatus;!function(a){a[a.INTERNAL=0]="INTERNAL",a[a.BYTECODE=1]="BYTECODE",a[a.NATIVE=2]="NATIVE"}(exports.StackFrameType||(exports.StackFrameType={}));var StackFrameType=exports.StackFrameType;!function(a){a[a.INT_MAX=Math.pow(2,31)-1]="INT_MAX",a[a.INT_MIN=-a.INT_MAX-1]="INT_MIN",a[a.FLOAT_POS_INFINITY=Math.pow(2,128)]="FLOAT_POS_INFINITY",a[a.FLOAT_NEG_INFINITY=-1*a.FLOAT_POS_INFINITY]="FLOAT_NEG_INFINITY",a[a.FLOAT_POS_INFINITY_AS_INT=2139095040]="FLOAT_POS_INFINITY_AS_INT",a[a.FLOAT_NEG_INFINITY_AS_INT=-8388608]="FLOAT_NEG_INFINITY_AS_INT",a[a.FLOAT_NaN_AS_INT=2143289344]="FLOAT_NaN_AS_INT"}(exports.Constants||(exports.Constants={}));var Constants=exports.Constants;!function(a){a[a.CLASS=7]="CLASS",a[a.FIELDREF=9]="FIELDREF",a[a.METHODREF=10]="METHODREF",a[a.INTERFACE_METHODREF=11]="INTERFACE_METHODREF",a[a.STRING=8]="STRING",a[a.INTEGER=3]="INTEGER",a[a.FLOAT=4]="FLOAT",a[a.LONG=5]="LONG",a[a.DOUBLE=6]="DOUBLE",a[a.NAME_AND_TYPE=12]="NAME_AND_TYPE",a[a.UTF8=1]="UTF8",a[a.METHOD_HANDLE=15]="METHOD_HANDLE",a[a.METHOD_TYPE=16]="METHOD_TYPE",a[a.INVOKE_DYNAMIC=18]="INVOKE_DYNAMIC"}(exports.ConstantPoolItemType||(exports.ConstantPoolItemType={}));var ConstantPoolItemType=exports.ConstantPoolItemType;!function(a){a[a.SAME_FRAME=0]="SAME_FRAME",a[a.SAME_LOCALS_1_STACK_ITEM_FRAME=1]="SAME_LOCALS_1_STACK_ITEM_FRAME",a[a.SAME_LOCALS_1_STACK_ITEM_FRAME_EXTENDED=2]="SAME_LOCALS_1_STACK_ITEM_FRAME_EXTENDED",a[a.CHOP_FRAME=3]="CHOP_FRAME",a[a.SAME_FRAME_EXTENDED=4]="SAME_FRAME_EXTENDED",a[a.APPEND_FRAME=5]="APPEND_FRAME",a[a.FULL_FRAME=6]="FULL_FRAME"}(exports.StackMapTableEntryType||(exports.StackMapTableEntryType={}));var StackMapTableEntryType=exports.StackMapTableEntryType;!function(a){a[a.GETFIELD=1]="GETFIELD",a[a.GETSTATIC=2]="GETSTATIC",a[a.PUTFIELD=3]="PUTFIELD",a[a.PUTSTATIC=4]="PUTSTATIC",a[a.INVOKEVIRTUAL=5]="INVOKEVIRTUAL",a[a.INVOKESTATIC=6]="INVOKESTATIC",a[a.INVOKESPECIAL=7]="INVOKESPECIAL",a[a.NEWINVOKESPECIAL=8]="NEWINVOKESPECIAL",a[a.INVOKEINTERFACE=9]="INVOKEINTERFACE"}(exports.MethodHandleReferenceKind||(exports.MethodHandleReferenceKind={}));var MethodHandleReferenceKind=exports.MethodHandleReferenceKind;!function(a){a[a.AALOAD=50]="AALOAD",a[a.AASTORE=83]="AASTORE",a[a.ACONST_NULL=1]="ACONST_NULL",a[a.ALOAD=25]="ALOAD",a[a.ALOAD_0=42]="ALOAD_0",a[a.ALOAD_1=43]="ALOAD_1",a[a.ALOAD_2=44]="ALOAD_2",a[a.ALOAD_3=45]="ALOAD_3",a[a.ANEWARRAY=189]="ANEWARRAY",a[a.ARETURN=176]="ARETURN",a[a.ARRAYLENGTH=190]="ARRAYLENGTH",a[a.ASTORE=58]="ASTORE",a[a.ASTORE_0=75]="ASTORE_0",a[a.ASTORE_1=76]="ASTORE_1",a[a.ASTORE_2=77]="ASTORE_2",a[a.ASTORE_3=78]="ASTORE_3",a[a.ATHROW=191]="ATHROW",a[a.BALOAD=51]="BALOAD",a[a.BASTORE=84]="BASTORE",a[a.BIPUSH=16]="BIPUSH",a[a.BREAKPOINT=202]="BREAKPOINT",a[a.CALOAD=52]="CALOAD",a[a.CASTORE=85]="CASTORE",a[a.CHECKCAST=192]="CHECKCAST",a[a.D2F=144]="D2F",a[a.D2I=142]="D2I",a[a.D2L=143]="D2L",a[a.DADD=99]="DADD",a[a.DALOAD=49]="DALOAD",a[a.DASTORE=82]="DASTORE",a[a.DCMPG=152]="DCMPG",a[a.DCMPL=151]="DCMPL",a[a.DCONST_0=14]="DCONST_0",a[a.DCONST_1=15]="DCONST_1",a[a.DDIV=111]="DDIV",a[a.DLOAD=24]="DLOAD",a[a.DLOAD_0=38]="DLOAD_0",a[a.DLOAD_1=39]="DLOAD_1",a[a.DLOAD_2=40]="DLOAD_2",a[a.DLOAD_3=41]="DLOAD_3",a[a.DMUL=107]="DMUL",a[a.DNEG=119]="DNEG",a[a.DREM=115]="DREM",a[a.DRETURN=175]="DRETURN",a[a.DSTORE=57]="DSTORE",a[a.DSTORE_0=71]="DSTORE_0",a[a.DSTORE_1=72]="DSTORE_1",a[a.DSTORE_2=73]="DSTORE_2",a[a.DSTORE_3=74]="DSTORE_3",a[a.DSUB=103]="DSUB",a[a.DUP=89]="DUP",a[a.DUP_X1=90]="DUP_X1",a[a.DUP_X2=91]="DUP_X2",a[a.DUP2=92]="DUP2",a[a.DUP2_X1=93]="DUP2_X1",a[a.DUP2_X2=94]="DUP2_X2",a[a.F2D=141]="F2D",a[a.F2I=139]="F2I",a[a.F2L=140]="F2L",a[a.FADD=98]="FADD",a[a.FALOAD=48]="FALOAD",a[a.FASTORE=81]="FASTORE",a[a.FCMPG=150]="FCMPG",a[a.FCMPL=149]="FCMPL",a[a.FCONST_0=11]="FCONST_0",a[a.FCONST_1=12]="FCONST_1",a[a.FCONST_2=13]="FCONST_2",a[a.FDIV=110]="FDIV",a[a.FLOAD=23]="FLOAD",a[a.FLOAD_0=34]="FLOAD_0",a[a.FLOAD_1=35]="FLOAD_1",a[a.FLOAD_2=36]="FLOAD_2",a[a.FLOAD_3=37]="FLOAD_3",a[a.FMUL=106]="FMUL",a[a.FNEG=118]="FNEG",a[a.FREM=114]="FREM",a[a.FRETURN=174]="FRETURN",a[a.FSTORE=56]="FSTORE",a[a.FSTORE_0=67]="FSTORE_0",a[a.FSTORE_1=68]="FSTORE_1",a[a.FSTORE_2=69]="FSTORE_2",a[a.FSTORE_3=70]="FSTORE_3",a[a.FSUB=102]="FSUB",a[a.GETFIELD=180]="GETFIELD",a[a.GETSTATIC=178]="GETSTATIC",a[a.GOTO=167]="GOTO",a[a.GOTO_W=200]="GOTO_W",a[a.I2B=145]="I2B",a[a.I2C=146]="I2C",a[a.I2D=135]="I2D",a[a.I2F=134]="I2F",a[a.I2L=133]="I2L",a[a.I2S=147]="I2S",a[a.IADD=96]="IADD",a[a.IALOAD=46]="IALOAD",a[a.IAND=126]="IAND",a[a.IASTORE=79]="IASTORE",a[a.ICONST_M1=2]="ICONST_M1",a[a.ICONST_0=3]="ICONST_0",a[a.ICONST_1=4]="ICONST_1",a[a.ICONST_2=5]="ICONST_2",a[a.ICONST_3=6]="ICONST_3",a[a.ICONST_4=7]="ICONST_4",a[a.ICONST_5=8]="ICONST_5",a[a.IDIV=108]="IDIV",a[a.IF_ACMPEQ=165]="IF_ACMPEQ",a[a.IF_ACMPNE=166]="IF_ACMPNE",a[a.IF_ICMPEQ=159]="IF_ICMPEQ",a[a.IF_ICMPGE=162]="IF_ICMPGE",a[a.IF_ICMPGT=163]="IF_ICMPGT",a[a.IF_ICMPLE=164]="IF_ICMPLE",a[a.IF_ICMPLT=161]="IF_ICMPLT",a[a.IF_ICMPNE=160]="IF_ICMPNE",a[a.IFEQ=153]="IFEQ",a[a.IFGE=156]="IFGE",a[a.IFGT=157]="IFGT",a[a.IFLE=158]="IFLE",a[a.IFLT=155]="IFLT",a[a.IFNE=154]="IFNE",a[a.IFNONNULL=199]="IFNONNULL",a[a.IFNULL=198]="IFNULL",a[a.IINC=132]="IINC",a[a.ILOAD=21]="ILOAD",a[a.ILOAD_0=26]="ILOAD_0",a[a.ILOAD_1=27]="ILOAD_1",a[a.ILOAD_2=28]="ILOAD_2",a[a.ILOAD_3=29]="ILOAD_3",a[a.IMUL=104]="IMUL",a[a.INEG=116]="INEG",a[a.INSTANCEOF=193]="INSTANCEOF",a[a.INVOKEDYNAMIC=186]="INVOKEDYNAMIC",a[a.INVOKEINTERFACE=185]="INVOKEINTERFACE",a[a.INVOKESPECIAL=183]="INVOKESPECIAL",a[a.INVOKESTATIC=184]="INVOKESTATIC",a[a.INVOKEVIRTUAL=182]="INVOKEVIRTUAL",a[a.IOR=128]="IOR",a[a.IREM=112]="IREM",a[a.IRETURN=172]="IRETURN",a[a.ISHL=120]="ISHL",a[a.ISHR=122]="ISHR",a[a.ISTORE=54]="ISTORE",a[a.ISTORE_0=59]="ISTORE_0",a[a.ISTORE_1=60]="ISTORE_1",a[a.ISTORE_2=61]="ISTORE_2",a[a.ISTORE_3=62]="ISTORE_3",a[a.ISUB=100]="ISUB",a[a.IUSHR=124]="IUSHR",a[a.IXOR=130]="IXOR",a[a.JSR=168]="JSR",a[a.JSR_W=201]="JSR_W",a[a.L2D=138]="L2D",a[a.L2F=137]="L2F",a[a.L2I=136]="L2I",a[a.LADD=97]="LADD",a[a.LALOAD=47]="LALOAD",a[a.LAND=127]="LAND",a[a.LASTORE=80]="LASTORE",a[a.LCMP=148]="LCMP",a[a.LCONST_0=9]="LCONST_0",a[a.LCONST_1=10]="LCONST_1",a[a.LDC=18]="LDC",a[a.LDC_W=19]="LDC_W",a[a.LDC2_W=20]="LDC2_W",a[a.LDIV=109]="LDIV",a[a.LLOAD=22]="LLOAD",a[a.LLOAD_0=30]="LLOAD_0",a[a.LLOAD_1=31]="LLOAD_1",a[a.LLOAD_2=32]="LLOAD_2",a[a.LLOAD_3=33]="LLOAD_3",a[a.LMUL=105]="LMUL",a[a.LNEG=117]="LNEG",a[a.LOOKUPSWITCH=171]="LOOKUPSWITCH",a[a.LOR=129]="LOR",a[a.LREM=113]="LREM",a[a.LRETURN=173]="LRETURN",a[a.LSHL=121]="LSHL",a[a.LSHR=123]="LSHR",a[a.LSTORE=55]="LSTORE",a[a.LSTORE_0=63]="LSTORE_0",a[a.LSTORE_1=64]="LSTORE_1",a[a.LSTORE_2=65]="LSTORE_2",a[a.LSTORE_3=66]="LSTORE_3",a[a.LSUB=101]="LSUB",a[a.LUSHR=125]="LUSHR",a[a.LXOR=131]="LXOR",a[a.MONITORENTER=194]="MONITORENTER",a[a.MONITOREXIT=195]="MONITOREXIT",a[a.MULTIANEWARRAY=197]="MULTIANEWARRAY",a[a.NEW=187]="NEW",a[a.NEWARRAY=188]="NEWARRAY",a[a.NOP=0]="NOP",a[a.POP=87]="POP",a[a.POP2=88]="POP2",a[a.PUTFIELD=181]="PUTFIELD",a[a.PUTSTATIC=179]="PUTSTATIC",a[a.RET=169]="RET",a[a.RETURN=177]="RETURN",a[a.SALOAD=53]="SALOAD",a[a.SASTORE=86]="SASTORE",a[a.SIPUSH=17]="SIPUSH",a[a.SWAP=95]="SWAP",a[a.TABLESWITCH=170]="TABLESWITCH",a[a.WIDE=196]="WIDE",a[a.GETSTATIC_FAST32=208]="GETSTATIC_FAST32",a[a.GETSTATIC_FAST64=209]="GETSTATIC_FAST64",a[a.NEW_FAST=210]="NEW_FAST",a[a.ANEWARRAY_FAST=213]="ANEWARRAY_FAST",a[a.CHECKCAST_FAST=214]="CHECKCAST_FAST",a[a.INSTANCEOF_FAST=215]="INSTANCEOF_FAST",a[a.MULTIANEWARRAY_FAST=216]="MULTIANEWARRAY_FAST",a[a.PUTSTATIC_FAST32=217]="PUTSTATIC_FAST32",a[a.PUTSTATIC_FAST64=218]="PUTSTATIC_FAST64",a[a.GETFIELD_FAST32=219]="GETFIELD_FAST32",a[a.GETFIELD_FAST64=220]="GETFIELD_FAST64",a[a.PUTFIELD_FAST32=221]="PUTFIELD_FAST32",a[a.PUTFIELD_FAST64=222]="PUTFIELD_FAST64",a[a.INVOKENONVIRTUAL_FAST=223]="INVOKENONVIRTUAL_FAST",a[a.INVOKESTATIC_FAST=240]="INVOKESTATIC_FAST",a[a.INVOKEVIRTUAL_FAST=241]="INVOKEVIRTUAL_FAST",a[a.INVOKEINTERFACE_FAST=242]="INVOKEINTERFACE_FAST",a[a.INVOKEHANDLE=243]="INVOKEHANDLE",a[a.INVOKEBASIC=244]="INVOKEBASIC",a[a.LINKTOSPECIAL=245]="LINKTOSPECIAL",a[a.LINKTOVIRTUAL=247]="LINKTOVIRTUAL",a[a.INVOKEDYNAMIC_FAST=248]="INVOKEDYNAMIC_FAST"}(exports.OpCode||(exports.OpCode={}));var OpCode=exports.OpCode;!function(a){a[a.OPCODE_ONLY=0]="OPCODE_ONLY",a[a.CONSTANT_POOL_UINT8=1]="CONSTANT_POOL_UINT8",a[a.CONSTANT_POOL=2]="CONSTANT_POOL",a[a.CONSTANT_POOL_AND_UINT8_VALUE=3]="CONSTANT_POOL_AND_UINT8_VALUE",a[a.UINT8_VALUE=4]="UINT8_VALUE",a[a.UINT8_AND_INT8_VALUE=5]="UINT8_AND_INT8_VALUE",a[a.INT8_VALUE=6]="INT8_VALUE",a[a.INT16_VALUE=7]="INT16_VALUE",a[a.INT32_VALUE=8]="INT32_VALUE",a[a.ARRAY_TYPE=9]="ARRAY_TYPE",a[a.WIDE=10]="WIDE"}(exports.OpcodeLayoutType||(exports.OpcodeLayoutType={}));var OpcodeLayoutType=exports.OpcodeLayoutType,olt=new Array(255);!function(){for(var a=0;255>a;a++)olt[a]=OpcodeLayoutType.OPCODE_ONLY}(),assignOpcodeLayout(OpcodeLayoutType.UINT8_VALUE,[OpCode.ALOAD,OpCode.ASTORE,OpCode.DLOAD,OpCode.DSTORE,OpCode.FLOAD,OpCode.FSTORE,OpCode.ILOAD,OpCode.ISTORE,OpCode.LLOAD,OpCode.LSTORE,OpCode.RET]),assignOpcodeLayout(OpcodeLayoutType.CONSTANT_POOL_UINT8,[OpCode.LDC]),assignOpcodeLayout(OpcodeLayoutType.CONSTANT_POOL,[OpCode.LDC_W,OpCode.LDC2_W,OpCode.ANEWARRAY,OpCode.CHECKCAST,OpCode.GETFIELD,OpCode.GETSTATIC,OpCode.INSTANCEOF,OpCode.INVOKEDYNAMIC,OpCode.INVOKESPECIAL,OpCode.INVOKESTATIC,OpCode.INVOKEVIRTUAL,OpCode.NEW,OpCode.PUTFIELD,OpCode.PUTSTATIC,OpCode.MULTIANEWARRAY_FAST,OpCode.INVOKENONVIRTUAL_FAST,OpCode.INVOKESTATIC_FAST,OpCode.CHECKCAST_FAST,OpCode.NEW_FAST,OpCode.ANEWARRAY_FAST,OpCode.INSTANCEOF_FAST,OpCode.GETSTATIC_FAST32,OpCode.GETSTATIC_FAST64,OpCode.PUTSTATIC_FAST32,OpCode.PUTSTATIC_FAST64,OpCode.PUTFIELD_FAST32,OpCode.PUTFIELD_FAST64,OpCode.GETFIELD_FAST32,OpCode.GETFIELD_FAST64,OpCode.INVOKEVIRTUAL_FAST]),assignOpcodeLayout(OpcodeLayoutType.CONSTANT_POOL_AND_UINT8_VALUE,[OpCode.INVOKEINTERFACE,OpCode.INVOKEINTERFACE_FAST,OpCode.MULTIANEWARRAY]),assignOpcodeLayout(OpcodeLayoutType.INT8_VALUE,[OpCode.BIPUSH]),assignOpcodeLayout(OpcodeLayoutType.INT16_VALUE,[OpCode.SIPUSH,OpCode.GOTO,OpCode.IFGT,OpCode.IFEQ,OpCode.IFGE,OpCode.IFLE,OpCode.IFLT,OpCode.IFNE,OpCode.IFNULL,OpCode.IFNONNULL,OpCode.IF_ICMPLE,OpCode.IF_ACMPEQ,OpCode.IF_ACMPNE,OpCode.IF_ICMPEQ,OpCode.IF_ICMPGE,OpCode.IF_ICMPGT,OpCode.IF_ICMPLT,OpCode.IF_ICMPNE,OpCode.JSR]),assignOpcodeLayout(OpcodeLayoutType.INT32_VALUE,[OpCode.GOTO_W,OpCode.JSR_W]),assignOpcodeLayout(OpcodeLayoutType.UINT8_AND_INT8_VALUE,[OpCode.IINC]),assignOpcodeLayout(OpcodeLayoutType.ARRAY_TYPE,[OpCode.NEWARRAY]),exports.OpcodeLayouts=olt;


/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";var SafeMap=function(){function a(){this.cache=Object.create(null)}return a.prototype.fixKey=function(a){return";"+a},a.prototype.get=function(a){return a=this.fixKey(a),void 0!==this.cache[a]?this.cache[a]:void 0},a.prototype.has=function(a){return void 0!==this.get(a)},a.prototype.set=function(a,b){this.cache[this.fixKey(a)]=b},a}();module.exports=SafeMap;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function getTrappedMethod(a,b){return a=util.descriptor2typestr(a),trapped_methods.hasOwnProperty(a)&&trapped_methods[a].hasOwnProperty(b)?trapped_methods[a][b]:null}function makeOnError(a){return a.length>0?"f.opStack.pushAll("+a.join(",")+");":""}function dumpStats(){for(var a=new Array(256),b=0;256>b;b++)a[b]=b;a.sort(function(a,b){return statTraceCloser[b]-statTraceCloser[a]});var c=a.slice(0,24);console.log("Opcodes that closed a trace (number of times encountered):");for(var b=0;b<c.length;b++){var d=c[b];statTraceCloser[d]>0&&console.log(enums.OpCode[d],statTraceCloser[d])}}var __extends=this&&this.__extends||function(a,b){function c(){this.constructor=a}for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d]);a.prototype=null===b?Object.create(b):(c.prototype=b.prototype,new c)},util=__webpack_require__(6),attributes=__webpack_require__(12),threading=__webpack_require__(15),assert=__webpack_require__(13),enums=__webpack_require__(9),StringOutputStream=__webpack_require__(18),global=__webpack_require__(14),jit_1=__webpack_require__(19),trapped_methods={"java/lang/ref/Reference":{"<clinit>()V":function(a){}},"java/lang/System":{"loadLibrary(Ljava/lang/String;)V":function(a,b){var c=b.toString();switch(c){case"zip":case"net":case"nio":case"awt":case"fontmanager":case"management":return;default:a.throwNewException("Ljava/lang/UnsatisfiedLinkError;","no "+c+" in java.library.path")}}},"java/lang/Terminator":{"setup()V":function(a){}},"java/nio/charset/Charset$3":{"run()Ljava/lang/Object;":function(a,b){return null}},"sun/nio/fs/DefaultFileSystemProvider":{"create()Ljava/nio/file/spi/FileSystemProvider;":function(a){a.setStatus(enums.ThreadStatus.ASYNC_WAITING);var b=a.getBsCl().getInitializedClass(a,"Lsun/nio/fs/DefaultFileSystemProvider;"),c=b.getConstructor(a);c["createProvider(Ljava/lang/String;)Ljava/nio/file/spi/FileSystemProvider;"](a,[a.getJVM().internString("sun.nio.fs.LinuxFileSystemProvider")],util.forwardResult(a))}}},AbstractMethodField=function(){function a(a,b,c,d){this.cls=a,this.slot=c,this.accessFlags=new util.Flags(d.getUint16()),this.name=b.get(d.getUint16()).value,this.rawDescriptor=b.get(d.getUint16()).value,this.attrs=attributes.makeAttributes(d,b)}return a.prototype.getAttribute=function(a){for(var b=0;b<this.attrs.length;b++){var c=this.attrs[b];if(c.getName()===a)return c}return null},a.prototype.getAttributes=function(a){return this.attrs.filter(function(b){return b.getName()===a})},a.prototype.getAnnotationType=function(a,b){var c=this.getAttribute(b);if(null===c)return null;var d,e=a.getBsCl().getInitializedClass(a,"[B").getConstructor(a),f=new e(a,0),g=c.rawBytes.length,h=new Array(g);for(d=0;g>d;d++)h[d]=c.rawBytes.readInt8(d);return f.array=h,f},a.prototype.parseDescriptor=function(a){throw new Error("Unimplemented error.")},a}();exports.AbstractMethodField=AbstractMethodField;var Field=function(a){function b(b,c,d,e){a.call(this,b,c,d,e),this.fullName=util.descriptor2typestr(b.getInternalName())+"/"+this.name}return __extends(b,a),b.prototype.reflector=function(a,b){var c=this,d=this.getAttribute("Signature"),e=a.getJVM(),f=a.getBsCl(),g=function(b){var g=f.getInitializedClass(a,"Ljava/lang/reflect/Field;"),h=new(g.getConstructor(a))(a);return h["java/lang/reflect/Field/clazz"]=c.cls.getClassObject(a),h["java/lang/reflect/Field/name"]=e.internString(c.name),h["java/lang/reflect/Field/type"]=b,h["java/lang/reflect/Field/modifiers"]=c.accessFlags.getRawByte(),h["java/lang/reflect/Field/slot"]=c.slot,h["java/lang/reflect/Field/signature"]=null!==d?util.initString(f,d.sig):null,h["java/lang/reflect/Field/annotations"]=c.getAnnotationType(a,"RuntimeVisibleAnnotations"),h};this.cls.getLoader().resolveClass(a,this.rawDescriptor,function(c){b(null!=c?g(c.getClassObject(a)):null)})},b.prototype.getDefaultFieldValue=function(){var a=this.rawDescriptor;if("J"===a)return"gLongZero";var b=a[0];return"["===b||"L"===b?"null":"0"},b.prototype.outputJavaScriptField=function(a,b){this.accessFlags.isStatic()?b.write(a+'["'+util.reescapeJVMName(this.fullName)+'"] = cls._getInitialStaticFieldValue(thread, "'+util.reescapeJVMName(this.name)+'");\n'):b.write('this["'+util.reescapeJVMName(this.fullName)+'"] = '+this.getDefaultFieldValue()+";\n")},b}(AbstractMethodField);exports.Field=Field;var opcodeSize=function(){var a=[],b=enums.OpcodeLayoutType;return a[b.OPCODE_ONLY]=1,a[b.CONSTANT_POOL_UINT8]=2,a[b.CONSTANT_POOL]=3,a[b.CONSTANT_POOL_AND_UINT8_VALUE]=4,a[b.UINT8_VALUE]=2,a[b.UINT8_AND_INT8_VALUE]=3,a[b.INT8_VALUE]=2,a[b.INT16_VALUE]=3,a[b.INT32_VALUE]=5,a[b.ARRAY_TYPE]=2,a[b.WIDE]=1,a}(),TraceInfo=function(){function a(a,b){this.pc=a,this.jitInfo=b,this.pops=[],this.pushes=[],this.prefixEmit=""}return a}(),Trace=function(){function a(a,b,c){this.startPC=a,this.code=b,this.method=c,this.infos=[],this.endPc=-1}return a.prototype.emitEndPC=function(a){this.endPc=a},a.prototype.addOp=function(a,b){this.infos.push(new TraceInfo(a,b))},a.prototype.close=function(a){if(this.infos.length>1){for(var b=[],c=0,d=this.endPc>-1?"f.pc="+this.endPc+";":"",e=0;e<this.infos.length;e++){for(var f=this.infos[e],g=f.jitInfo,h=f.pops,i=g.pops<0?Math.min(-g.pops,b.length):g.pops,j=0;i>j;j++)if(b.length>0)h.push(b.pop());else{var k="s"+c++;f.prefixEmit+="var "+k+" = f.opStack.pop();",h.push(k)}f.onErrorPushes=b.slice();for(var l=f.pushes,j=0;j<g.pushes;j++){var k="s"+c++;b.push(k),l.push(k)}}1===b.length?d+="f.opStack.push("+b[0]+");":b.length>1&&(d+="f.opStack.pushAll("+b.join(",")+");");for(var e=this.infos.length-1;e>=0;e--){var f=this.infos[e],g=f.jitInfo;d=f.prefixEmit+g.emit(f.pops,f.pushes,""+e,d,this.code,f.pc,f.onErrorPushes,this.method)}return new Function("f","t","u",d)}return null},a}(),Method=function(a){function b(b,c,d,e){a.call(this,b,c,d,e),this.numBBEntries=0,this.compiledFunctions=[],this.failedCompile=[];var f,g,h=util.getTypes(this.rawDescriptor);for(this.signature=this.name+this.rawDescriptor,this.fullSignature=util.descriptor2typestr(this.cls.getInternalName())+"/"+this.signature,this.returnType=h.pop(),this.parameterTypes=h,this.parameterWords=h.length,f=0;f<this.parameterTypes.length;f++)g=this.parameterTypes[f],"D"!==g&&"J"!==g||this.parameterWords++;var i=this.cls.getInternalName();if(null!==getTrappedMethod(i,this.signature))this.code=getTrappedMethod(i,this.signature),this.accessFlags.setNative(!0);else if(this.accessFlags.isNative())if(this.signature.indexOf("registerNatives()V",0)<0&&this.signature.indexOf("initIDs()V",0)<0){var j=this;this.code=function(a){var b=a.getJVM(),c=b.getNative(i,j.signature);return null!=c?(j.code=c,c.apply(j,arguments)):void a.throwNewException("Ljava/lang/UnsatisfiedLinkError;","Native method '"+j.getFullSignature()+"' not implemented.\nPlease fix or file a bug at https://github.com/plasma-umass/doppio/issues")}}else this.code=function(){};else if(!this.accessFlags.isAbstract()){this.code=this.getAttribute("Code");var k=this.code.code.length;this.numBBEntries=k>3?200:1e3*k}}return __extends(b,a),b.prototype.incrBBEntries=function(){this.numBBEntries--},b.prototype.isDefault=function(){return this.accessFlags.isPublic()&&!this.accessFlags.isAbstract()&&!this.accessFlags.isStatic()&&this.cls.accessFlags.isInterface()},b.prototype.getFullSignature=function(){return this.cls.getExternalName()+"."+this.name+this.rawDescriptor},b.prototype.isHidden=function(){var a=this.getAttribute("RuntimeVisibleAnnotations");return null!==a&&a.isHidden},b.prototype.isCallerSensitive=function(){var a=this.getAttribute("RuntimeVisibleAnnotations");return null!==a&&a.isCallerSensitive},b.prototype.getParamWordSize=function(){return this.parameterWords},b.prototype.getCodeAttribute=function(){return this.code},b.prototype.getOp=function(a,b,c){if(this.numBBEntries<=0&&!this.failedCompile[a]){var d=this.compiledFunctions[a];if(d)return d;var e=this.jitCompileFrom(a,c);if(e)return e;this.failedCompile[a]=!0}return b.readUInt8(a)},b.prototype.makeInvokeStaticJitInfo=function(a,b){var c=a.readUInt16BE(b+1),d=this.cls.constantPool.get(c),e=d.paramWordSize;d.jsConstructor[d.fullSignature];return{hasBranch:!0,pops:-e,pushes:0,emit:function(a,d,f,g){var h=e>a.length?"f.opStack.sliceAndDropFromTop("+(e-a.length)+");":"["+a.reduce(function(a,b){return b+","+a},"")+"];",i="var args"+f+"="+h;return e>a.length&&a.length>0&&(i+="args"+f+".push("+a.slice().reverse().join(",")+");"),i+("\nvar methodReference"+f+"=f.method.cls.constantPool.get("+c+");\nf.pc="+b+";\nmethodReference"+f+".jsConstructor[methodReference"+f+".fullSignature](t,args"+f+");\nf.returnToThreadLoop=true;\n"+g)}}},b.prototype.makeInvokeVirtualJitInfo=function(a,b){var c=a.readUInt16BE(b+1),d=this.cls.constantPool.get(c),e=d.paramWordSize;return{hasBranch:!0,pops:-(e+1),pushes:0,emit:function(a,b,c,f,g,h,i){var j=makeOnError(i),k=e>a.length?"f.opStack.sliceAndDropFromTop("+(e-a.length)+");":"["+a.slice(0,e).reduce(function(a,b){return b+","+a},"")+"];",l="var args"+c+"="+k;return e>a.length&&a.length>0&&(l+="args"+c+".push("+a.slice().reverse().join(",")+");"),l+("var obj"+c+"="+(e+1===a.length?a[e]:"f.opStack.pop()")+";f.pc="+h+";\nif(!u.isNull(t,f,obj"+c+")){obj"+c+"['"+d.signature+"'](t,args"+c+");f.returnToThreadLoop=true;"+f+"}else{"+j+"}")}}},b.prototype.makeInvokeNonVirtualJitInfo=function(a,b){var c=a.readUInt16BE(b+1),d=this.cls.constantPool.get(c),e=d.paramWordSize;return{hasBranch:!0,pops:-(e+1),pushes:0,emit:function(a,b,c,f,g,h,i){var j=makeOnError(i),k=e>a.length?"f.opStack.sliceAndDropFromTop("+(e-a.length)+");":"["+a.slice(0,e).reduce(function(a,b){return b+","+a},"")+"];",l="var args"+c+"="+k;return e>a.length&&a.length>0&&(l+="args"+c+".push("+a.slice().reverse().join(",")+");"),l+("var obj"+c+"="+(e+1===a.length?a[e]:"f.opStack.pop()")+";f.pc="+h+";\nif(!u.isNull(t,f,obj"+c+")){obj"+c+"['"+d.fullSignature+"'](t, args"+c+");f.returnToThreadLoop=true;"+f+"}else{"+j+"}")}}},b.prototype.jitCompileFrom=function(a,b){function c(){if(null!==e){var a=e.close(b);a&&(f.compiledFunctions[e.startPC]=a),e=null}g=!0}for(var d=this.getCodeAttribute().getCode(),e=null,f=this,g=!1,h=a;h<d.length&&!g;){var i=d.readUInt8(h),j=jit_1.opJitInfo[i];if(j)null===e&&(e=new Trace(h,d,f)),e.addOp(h,j),j.hasBranch&&(this.failedCompile[h]=!0,c());else if(i===enums.OpCode.INVOKESTATIC_FAST&&null!==e){var k=this.makeInvokeStaticJitInfo(d,h);e.addOp(h,k),this.failedCompile[h]=!0,c()}else if(i!==enums.OpCode.INVOKEVIRTUAL_FAST&&i!==enums.OpCode.INVOKEINTERFACE_FAST||null===e)if(i===enums.OpCode.INVOKENONVIRTUAL_FAST&&null!==e){var k=this.makeInvokeNonVirtualJitInfo(d,h);e.addOp(h,k),this.failedCompile[h]=!0,c()}else this.failedCompile[h]=!0,e&&e.emitEndPC(h),c();else{var k=this.makeInvokeVirtualJitInfo(d,h);e.addOp(h,k),this.failedCompile[h]=!0,c()}h+=opcodeSize[enums.OpcodeLayouts[i]]}return f.compiledFunctions[a]},b.prototype.getNativeFunction=function(){return this.code},b.prototype._resolveReferencedClasses=function(a,b){var c=this.parameterTypes.concat(this.returnType),d=this.code,e=this.getAttribute("Exceptions");!this.accessFlags.isNative()&&!this.accessFlags.isAbstract()&&d.exceptionHandlers.length>0&&(c.push("Ljava/lang/Throwable;"),c=c.concat(d.exceptionHandlers.filter(function(a){return"<any>"!==a.catchType}).map(function(a){return a.catchType}))),null!==e&&(c=c.concat(e.exceptions)),this.cls.getLoader().resolveClasses(a,c,function(c){a.getBsCl().resolveClasses(a,["Ljava/lang/reflect/Method;","Ljava/lang/reflect/Constructor;"],function(a){null===c||null===a?b(null):(c["Ljava/lang/reflect/Method;"]=a["Ljava/lang/reflect/Method;"],c["Ljava/lang/reflect/Constructor;"]=a["Ljava/lang/reflect/Constructor;"],b(c))})})},b.prototype.reflector=function(a,b){var c=this,d=a.getBsCl(),e=d.getInitializedClass(a,"[Ljava/lang/Class;").getConstructor(a),f=a.getJVM(),g=this.getAttribute("Signature"),h=this.getAttribute("Exceptions");this._resolveReferencedClasses(a,function(d){if(null===d)return b(null);var i=c.cls.getClassObject(a),j=f.internString(c.name),k=new e(a,0),l=d[c.returnType].getClassObject(a),m=new e(a,0),n=c.accessFlags.getRawByte(),o=null!==g?f.internString(g.sig):null;if(k.array=c.parameterTypes.map(function(b){return d[b].getClassObject(a)}),null!==h&&(m.array=h.exceptions.map(function(b){return d[b].getClassObject(a)})),"<init>"===c.name){var p=d["Ljava/lang/reflect/Constructor;"].getConstructor(a),q=new p(a);q["java/lang/reflect/Constructor/clazz"]=i,q["java/lang/reflect/Constructor/parameterTypes"]=k,q["java/lang/reflect/Constructor/exceptionTypes"]=m,q["java/lang/reflect/Constructor/modifiers"]=n,q["java/lang/reflect/Constructor/slot"]=c.slot,q["java/lang/reflect/Constructor/signature"]=o,q["java/lang/reflect/Constructor/annotations"]=c.getAnnotationType(a,"RuntimeVisibleAnnotations"),q["java/lang/reflect/Constructor/parameterAnnotations"]=c.getAnnotationType(a,"RuntimeVisibleParameterAnnotations"),b(q)}else{var r=d["Ljava/lang/reflect/Method;"].getConstructor(a),s=new r(a);s["java/lang/reflect/Method/clazz"]=i,s["java/lang/reflect/Method/name"]=j,s["java/lang/reflect/Method/parameterTypes"]=k,s["java/lang/reflect/Method/returnType"]=l,s["java/lang/reflect/Method/exceptionTypes"]=m,s["java/lang/reflect/Method/modifiers"]=n,s["java/lang/reflect/Method/slot"]=c.slot,s["java/lang/reflect/Method/signature"]=o,s["java/lang/reflect/Method/annotations"]=c.getAnnotationType(a,"RuntimeVisibleAnnotations"),s["java/lang/reflect/Method/annotationDefault"]=c.getAnnotationType(a,"AnnotationDefault"),s["java/lang/reflect/Method/parameterAnnotations"]=c.getAnnotationType(a,"RuntimeVisibleParameterAnnotations"),b(s)}})},b.prototype.convertArgs=function(a,b){if(this.isSignaturePolymorphic())return b.unshift(a),b;var c,d=[a],e=0;for(this.accessFlags.isStatic()||(d.push(b[0]),e=1),c=0;c<this.parameterTypes.length;c++){var f=this.parameterTypes[c];d.push(b[e]),e+="J"===f||"D"===f?2:1}return d},b.prototype.methodLock=function(a,b){return this.accessFlags.isStatic()?this.cls.getClassObject(a).getMonitor():b.locals[0].getMonitor()},b.prototype.isSignaturePolymorphic=function(){return"Ljava/lang/invoke/MethodHandle;"===this.cls.getInternalName()&&this.accessFlags.isNative()&&this.accessFlags.isVarArgs()&&"([Ljava/lang/Object;)Ljava/lang/Object;"===this.rawDescriptor},b.prototype.getVMTargetBridgeMethod=function(a,b){var c=new StringOutputStream,d=!(b===enums.MethodHandleReferenceKind.INVOKESTATIC||b===enums.MethodHandleReferenceKind.INVOKESPECIAL);this.accessFlags.isStatic()&&c.write("var jsCons = cls.getConstructor(thread);\n"),c.write("function bridgeMethod(thread, descriptor, args, cb) {\n"),this.accessFlags.isStatic()?c.write('  jsCons["'+util.reescapeJVMName(this.fullSignature)+'"](thread, '):(c.write("  var obj = args.shift();\n"),c.write("  if (obj === null) { return thread.throwNewException('Ljava/lang/NullPointerException;', ''); }\n"),c.write('  obj["'+util.reescapeJVMName(d?this.signature:this.fullSignature)+'"](thread, ')),c.write("args"),c.write(", cb);\n  }\n  return bridgeMethod;");var e=c.flush();return new Function("thread","cls","util",e)(a,this.cls,util)},b.prototype.outputJavaScriptFunction=function(a,b,c){void 0===c&&(c=!1);var d;if(this.accessFlags.isStatic()?b.write(a+'["'+util.reescapeJVMName(this.fullSignature)+'"] = '+a+'["'+util.reescapeJVMName(this.signature)+'"] = '):(c||b.write(a+'.prototype["'+util.reescapeJVMName(this.signature)+'"] = '),b.write(a+'.prototype["'+util.reescapeJVMName(this.fullSignature)+'"] = ')),b.write("(function(method) {\n  return function(thread, args, cb) {\n    if (typeof cb === 'function') {\n      thread.stack.push(new InternalStackFrame(cb));\n    }\n    thread.stack.push(new "+(this.accessFlags.isNative()?"NativeStackFrame":"BytecodeStackFrame")+"(method, "),this.accessFlags.isStatic())this.parameterWords>0?b.write("args"):b.write("[]");else{for(b.write("[this"),d=0;d<this.parameterWords;d++)b.write(", args["+d+"]");b.write("]")}b.write("));\n    thread.setStatus("+enums.ThreadStatus.RUNNABLE+');\n  };\n})(cls.getSpecificMethod("'+util.reescapeJVMName(this.cls.getInternalName())+'", "'+util.reescapeJVMName(this.signature)+'"));\n')},b}(AbstractMethodField);exports.Method=Method;var statTraceCloser=new Array(256),i;exports.dumpStats=dumpStats;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function makeAttributes(a,b){for(var c={Code:Code,LineNumberTable:LineNumberTable,SourceFile:SourceFile,StackMapTable:StackMapTable,LocalVariableTable:LocalVariableTable,LocalVariableTypeTable:LocalVariableTypeTable,ConstantValue:ConstantValue,Exceptions:Exceptions,InnerClasses:InnerClasses,Synthetic:Synthetic,Deprecated:Deprecated,Signature:Signature,RuntimeVisibleAnnotations:RuntimeVisibleAnnotations,AnnotationDefault:AnnotationDefault,EnclosingMethod:EnclosingMethod,BootstrapMethods:BootstrapMethods,RuntimeVisibleParameterAnnotations:RuntimeVisibleParameterAnnotations},d=a.getUint16(),e=[],f=0;d>f;f++){var g=b.get(a.getUint16()).value,h=a.getUint32();if(null!=c[g]){var i=a.size(),j=c[g].parse(a,b,h,g),k=a.size();i-k!==h&&a.skip(h-i+k),e.push(j)}else a.skip(h)}return e}var util=__webpack_require__(6),enums=__webpack_require__(9),assert=__webpack_require__(13),global=__webpack_require__(14),ExceptionHandler=function(){function a(a,b,c,d){this.startPC=a,this.endPC=b,this.handlerPC=c,this.catchType=d}return a.prototype.getName=function(){return"ExceptionHandler"},a.parse=function(a,b){var c=a.getUint16(),d=a.getUint16(),e=a.getUint16(),f=a.getUint16(),g=0===f?"<any>":b.get(f).name;return new this(c,d,e,g)},a}();exports.ExceptionHandler=ExceptionHandler;var Code=function(){function a(a,b,c,d,e){this.maxStack=a,this.maxLocals=b,this.exceptionHandlers=c,this.attrs=d,this.code=e}return a.prototype.getName=function(){return"Code"},a.prototype.getMaxStack=function(){return this.maxStack},a.parse=function(a,b){var c=a.getUint16(),d=a.getUint16(),e=a.getUint32();if(0===e)throw"Error parsing code: Code length is zero";for(var f=a.slice(e).getBuffer(),g=a.getUint16(),h=[],i=0;g>i;i++)h.push(ExceptionHandler.parse(a,b));var j=makeAttributes(a,b);return new this(c,d,h,j,f)},a.prototype.getCode=function(){return this.code},a.prototype.getAttribute=function(a){for(var b=0;b<this.attrs.length;b++){var c=this.attrs[b];if(c.getName()===a)return c}return null},a}();exports.Code=Code;var LineNumberTable=function(){function a(a){this.entries=a}return a.prototype.getName=function(){return"LineNumberTable"},a.prototype.getLineNumber=function(a){var b,c=-1;for(b=0;b<this.entries.length;b++){var d=this.entries[b];if(!(d.startPC<=a))break;c=d.lineNumber}return c},a.parse=function(a,b){for(var c=[],d=a.getUint16(),e=0;d>e;e++){var f=a.getUint16(),g=a.getUint16();c.push({startPC:f,lineNumber:g})}return new this(c)},a}();exports.LineNumberTable=LineNumberTable;var SourceFile=function(){function a(a){this.filename=a}return a.prototype.getName=function(){return"SourceFile"},a.parse=function(a,b){return new this(b.get(a.getUint16()).value)},a}();exports.SourceFile=SourceFile;var StackMapTable=function(){function a(a){this.entries=a}return a.prototype.getName=function(){return"StackMapTable"},a.parse=function(a,b){for(var c=a.getUint16(),d=[],e=0;c>e;e++)d.push(this.parseEntry(a,b));return new this(d)},a.parseEntry=function(a,b){var c,d,e,f=a.getUint8();if(64>f)return{type:enums.StackMapTableEntryType.SAME_FRAME,offsetDelta:f};if(128>f)return{type:enums.StackMapTableEntryType.SAME_LOCALS_1_STACK_ITEM_FRAME,offsetDelta:f-64,stack:[this.parseVerificationTypeInfo(a,b)]};if(247>f);else{if(247===f)return{type:enums.StackMapTableEntryType.SAME_LOCALS_1_STACK_ITEM_FRAME_EXTENDED,offsetDelta:a.getUint16(),stack:[this.parseVerificationTypeInfo(a,b)]};if(251>f)return{type:enums.StackMapTableEntryType.CHOP_FRAME,offsetDelta:a.getUint16(),k:251-f};if(251===f)return{type:enums.StackMapTableEntryType.SAME_FRAME_EXTENDED,offsetDelta:a.getUint16()};if(255>f){for(d=a.getUint16(),c=[],e=0;f-251>e;e++)c.push(this.parseVerificationTypeInfo(a,b));return{type:enums.StackMapTableEntryType.APPEND_FRAME,offsetDelta:d,locals:c}}if(255===f){d=a.getUint16();var g=a.getUint16();for(c=[],e=0;g>e;e++)c.push(this.parseVerificationTypeInfo(a,b));var h=a.getUint16(),i=[];for(e=0;h>e;e++)i.push(this.parseVerificationTypeInfo(a,b));return{type:enums.StackMapTableEntryType.FULL_FRAME,offsetDelta:d,numLocals:g,locals:c,numStackItems:h,stack:i}}}},a.parseVerificationTypeInfo=function(a,b){var c=a.getUint8();if(7===c){var d=b.get(a.getUint16()).name;return"class "+(/\w/.test(d[0])?util.descriptor2typestr(d):'"'+d+'"')}if(8===c)return"uninitialized "+a.getUint16();var e=["bogus","int","float","double","long","null","this","object","uninitialized"];return e[c]},a}();exports.StackMapTable=StackMapTable;var LocalVariableTable=function(){function a(a){this.entries=a}return a.prototype.getName=function(){return"LocalVariableTable"},a.parse=function(a,b){for(var c=a.getUint16(),d=[],e=0;c>e;e++)d.push(this.parseEntries(a,b));return new this(d)},a.parseEntries=function(a,b){return{startPC:a.getUint16(),length:a.getUint16(),name:b.get(a.getUint16()).value,descriptor:b.get(a.getUint16()).value,ref:a.getUint16()}},a}();exports.LocalVariableTable=LocalVariableTable;var LocalVariableTypeTable=function(){function a(a){this.entries=a}return a.prototype.getName=function(){return"LocalVariableTypeTable"},a.parse=function(a,b){var c,d=a.getUint16(),e=[];for(c=0;d>c;c++)e.push(this.parseTableEntry(a,b));return new this(e)},a.parseTableEntry=function(a,b){return{startPC:a.getUint16(),length:a.getUint16(),name:b.get(a.getUint16()).value,signature:b.get(a.getUint16()).value,index:a.getUint16()}},a}();exports.LocalVariableTypeTable=LocalVariableTypeTable;var Exceptions=function(){function a(a){this.exceptions=a}return a.prototype.getName=function(){return"Exceptions"},a.parse=function(a,b){for(var c=a.getUint16(),d=[],e=0;c>e;e++)d.push(a.getUint16());return new this(d.map(function(a){return b.get(a).name}))},a}();exports.Exceptions=Exceptions;var InnerClasses=function(){function a(a){this.classes=a}return a.prototype.getName=function(){return"InnerClasses"},a.parse=function(a,b){for(var c=a.getUint16(),d=[],e=0;c>e;e++)d.push(this.parseClass(a,b));return new this(d)},a.parseClass=function(a,b){return{innerInfoIndex:a.getUint16(),outerInfoIndex:a.getUint16(),innerNameIndex:a.getUint16(),innerAccessFlags:a.getUint16()}},a}();exports.InnerClasses=InnerClasses;var ConstantValue=function(){function a(a){this.value=a}return a.prototype.getName=function(){return"ConstantValue"},a.parse=function(a,b){var c=a.getUint16();return new this(b.get(c))},a}();exports.ConstantValue=ConstantValue;var Synthetic=function(){function a(){}return a.prototype.getName=function(){return"Synthetic"},a.parse=function(a,b){return new this},a}();exports.Synthetic=Synthetic;var Deprecated=function(){function a(){}return a.prototype.getName=function(){return"Deprecated"},a.parse=function(a,b){return new this},a}();exports.Deprecated=Deprecated;var Signature=function(){function a(a){this.sig=a}return a.prototype.getName=function(){return"Signature"},a.parse=function(a,b){return new this(b.get(a.getUint16()).value)},a}();exports.Signature=Signature;var RuntimeVisibleAnnotations=function(){function a(a,b,c,d){this.rawBytes=a,this.isHidden=b,this.isCallerSensitive=c,this.isCompiled=d}return a.prototype.getName=function(){return"RuntimeVisibleAnnotations"},a.parse=function(a,b,c){function d(){a.skip(2);var b,c=a.getUint16();for(b=0;c>b;b++)a.skip(2),e()}function e(){var b=String.fromCharCode(a.getUint8());switch(b){case"e":a.skip(2);case"Z":case"B":case"C":case"S":case"I":case"F":case"J":case"D":case"s":case"c":a.skip(2);break;case"@":d();break;case"[":var c,f=a.getUint16();for(c=0;f>c;c++)e()}}var f=a.read(c),g=!1,h=!1,i=!1;a.seek(a.pos()-f.length);var j,k=a.getUint16();for(j=0;k>j;j++){var l=b.get(a.getUint16());switch(a.seek(a.pos()-2),d(),l.value){case"Ljava/lang/invoke/LambdaForm$Hidden;":g=!0;break;case"Lsig/sun/reflect/CallerSensitive;":i=!0;break;case"Lsig/java/lang/invoke/LambdaForm$Compiled":h=!0}}return new this(f,g,i,h)},a}();exports.RuntimeVisibleAnnotations=RuntimeVisibleAnnotations;var AnnotationDefault=function(){function a(a){this.rawBytes=a}return a.prototype.getName=function(){return"AnnotationDefault"},a.parse=function(a,b,c){return new this(a.read(c))},a}();exports.AnnotationDefault=AnnotationDefault;var EnclosingMethod=function(){function a(a,b){this.encClass=a,this.encMethod=b}return a.prototype.getName=function(){return"EnclosingMethod"},a.parse=function(a,b){var c=b.get(a.getUint16()),d=a.getUint16(),e=null;return d>0&&(e=b.get(d)),new this(c,e)},a}();exports.EnclosingMethod=EnclosingMethod;var BootstrapMethods=function(){function a(a){this.bootstrapMethods=a}return a.prototype.getName=function(){return"BootstrapMethods"},a.parse=function(a,b){for(var c=a.getUint16(),d=[],e=0;c>e;e++){for(var f=b.get(a.getUint16()),g=a.getUint16(),h=[],i=0;g>i;i++)h.push(b.get(a.getUint16()));d.push([f,h])}return new this(d)},a}();exports.BootstrapMethods=BootstrapMethods;var RuntimeVisibleParameterAnnotations=function(){function a(a){this.rawBytes=a}return a.prototype.getName=function(){return"RuntimeVisibleParameterAnnotations"},a.parse=function(a,b,c){return new this(a.read(c))},a}();exports.RuntimeVisibleParameterAnnotations=RuntimeVisibleParameterAnnotations,exports.makeAttributes=makeAttributes;


/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";function assert(a,b,c){if(!a)throw new Error("Assertion failed: "+b+"\n"+(c?c.getPrintableStackTrace():""))}module.exports=assert;


/***/ },
/* 14 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";var toExport;toExport="undefined"!=typeof window?window:"undefined"!=typeof self?self:global,module.exports=toExport;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function validateThreadTransition(a,b){var c=exports.validTransitions.hasOwnProperty(""+a)&&exports.validTransitions[a].hasOwnProperty(""+b);return c}function validateReturnValue(a,b,c,d,e,f,g){if("java/lang/invoke/MethodHandle/invokeBasic([Ljava/lang/Object;)Ljava/lang/Object;"===b.fullSignature)return!0;var h;if(util.is_primitive_type(c))switch(c){case"Z":break;case"B":break;case"C":break;case"S":break;case"I":break;case"J":break;case"F":break;case"D":break;case"V":}else util.is_array_type(c)?null!=f&&(h=assertClassInitializedOrResolved(a,e,c,!0)):null!=f&&(h=assertClassInitializedOrResolved(a,e,c,!1),h.accessFlags.isInterface()||assertClassInitializedOrResolved(a,e,c,!0));return!0}function assertClassInitializedOrResolved(a,b,c,d){for(var e=null;null===e;)e=d?b.getInitializedClass(a,c):b.getResolvedClass(c),null!==b.getLoaderObject()&&(b=null===b.getLoaderObject()["java/lang/ClassLoader/parent"]?a.getBsCl():b.getLoaderObject()["java/lang/ClassLoader/parent"].$loader);return e}function printConstantPoolItem(a){switch(a.getType()){case enums.ConstantPoolItemType.METHODREF:var b=a;return util.ext_classname(b.classInfo.name)+"."+b.signature;case enums.ConstantPoolItemType.INTERFACE_METHODREF:var c=a;return util.ext_classname(c.classInfo.name)+"."+c.signature;case enums.ConstantPoolItemType.FIELDREF:var d=a;return util.ext_classname(d.classInfo.name)+"."+d.nameAndTypeInfo.name+":"+util.ext_classname(d.nameAndTypeInfo.descriptor);case enums.ConstantPoolItemType.NAME_AND_TYPE:var e=a;return e.name+":"+e.descriptor;case enums.ConstantPoolItemType.CLASS:var f=a;return util.ext_classname(f.name);default:return logging.debug_var(a.value)}}function annotateOpcode(a,b,c,d){return exports.OpcodeLayoutPrinters[enums.OpcodeLayouts[a]](b,c,d)}var enums=__webpack_require__(9),assert=__webpack_require__(13),gLong=__webpack_require__(8),opcodes=__webpack_require__(16),logging=__webpack_require__(17),util=__webpack_require__(6),ThreadStatus=enums.ThreadStatus,global=__webpack_require__(14),debug=logging.debug,vtrace=logging.vtrace,trace=logging.trace,maxMethodResumes=1e4,methodResumesLeft=maxMethodResumes,numSamples=1,PreAllocatedStack=function(){function a(a){this.curr=0,this.store=new Array(a)}return a.prototype.push=function(a){this.store[this.curr++]=a},a.prototype.pushAll=function(){for(var a=arguments.length,b=0;a>b;b++)this.store[this.curr++]=arguments[b]},a.prototype.pushWithNull=function(a){this.store[this.curr]=a,this.curr+=2},a.prototype.push6=function(a,b,c,d,e,f){this.store[this.curr++]=a,this.store[this.curr++]=b,this.store[this.curr++]=c,this.store[this.curr++]=d,this.store[this.curr++]=e,this.store[this.curr++]=f},a.prototype.swap=function(){var a=this.store[this.curr-1];this.store[this.curr-1]=this.store[this.curr-2],this.store[this.curr-2]=a},a.prototype.dup=function(){this.store[this.curr]=this.store[this.curr-1],this.curr++},a.prototype.dup2=function(){this.store[this.curr]=this.store[this.curr-2],this.store[this.curr+1]=this.store[this.curr-1],this.curr+=2},a.prototype.dup_x1=function(){var a=this.store[this.curr-1];this.store[this.curr-1]=this.store[this.curr-2],this.store[this.curr]=a,this.store[this.curr-2]=a,this.curr++},a.prototype.dup_x2=function(){var a=this.store[this.curr-1];this.store[this.curr-1]=this.store[this.curr-2],this.store[this.curr-2]=this.store[this.curr-3],this.store[this.curr]=a,this.store[this.curr-3]=a,this.curr++},a.prototype.dup2_x1=function(){var a=this.store[this.curr-1],b=this.store[this.curr-2];this.store[this.curr]=b,this.store[this.curr+1]=a,this.store[this.curr-1]=this.store[this.curr-3],this.store[this.curr-2]=a,this.store[this.curr-3]=b,this.curr+=2},a.prototype.pop=function(){return this.store[--this.curr]},a.prototype.pop2=function(){return this.curr-=2,this.store[this.curr]},a.prototype.bottom=function(){return this.store[0]},a.prototype.top=function(){return this.store[this.curr-1]},a.prototype.fromTop=function(a){return this.store[this.curr-(a+1)]},a.prototype.sliceFromBottom=function(a){return this.store.slice(a,this.curr)},a.prototype.sliceFromTop=function(a){return this.store.slice(this.curr-a,this.curr)},a.prototype.dropFromTop=function(a){this.curr-=a},a.prototype.sliceAndDropFromTop=function(a){var b=this.curr;return this.curr-=a,this.store.slice(b-a,b)},a.prototype.getRaw=function(){return this.store.slice(0,this.curr)},a.prototype.clear=function(){this.curr=0},a}();exports.PreAllocatedStack=PreAllocatedStack;var jitUtil={isNull:opcodes.isNull,resolveCPItem:opcodes.resolveCPItem,throwException:opcodes.throwException,gLong:gLong,float2int:util.float2int,wrapFloat:util.wrapFloat,Constants:enums.Constants},BytecodeStackFrame=function(){function a(a,b){this.pc=0,this.returnToThreadLoop=!1,this.lockedMethodLock=!1,this.type=enums.StackFrameType.BYTECODE,this.method=a,a.incrBBEntries(),this.locals=b,this.opStack=new PreAllocatedStack(a.getCodeAttribute().getMaxStack())}return a.prototype.run=function(a){var b=this,c=this.method,d=this.method.getCodeAttribute().getCode(),e=opcodes.LookupTable;if(!c.accessFlags.isSynchronized()||this.lockedMethodLock||(this.lockedMethodLock=c.methodLock(a,this).enter(a,function(){b.lockedMethodLock=!0}),this.lockedMethodLock))if(this.returnToThreadLoop=!1,a.getJVM().isJITDisabled())for(;!this.returnToThreadLoop;){var f=d.readUInt8(this.pc);e[f](a,this,d)}else for(;!this.returnToThreadLoop;){var g=c.getOp(this.pc,d,a);"function"==typeof g?g(this,a,jitUtil):e[g](a,this,d)}},a.prototype.scheduleResume=function(a,b,c){var d=this.method.getCodeAttribute().getCode().readUInt8(this.pc);switch(d){case enums.OpCode.INVOKEINTERFACE:case enums.OpCode.INVOKEINTERFACE_FAST:this.pc+=5;break;case enums.OpCode.INVOKESPECIAL:case enums.OpCode.INVOKESTATIC:case enums.OpCode.INVOKEVIRTUAL:case enums.OpCode.INVOKESTATIC_FAST:case enums.OpCode.INVOKENONVIRTUAL_FAST:case enums.OpCode.INVOKEVIRTUAL_FAST:case enums.OpCode.INVOKEHANDLE:case enums.OpCode.INVOKEBASIC:case enums.OpCode.LINKTOSPECIAL:case enums.OpCode.LINKTOVIRTUAL:case enums.OpCode.INVOKEDYNAMIC:case enums.OpCode.INVOKEDYNAMIC_FAST:this.pc+=3}void 0!==b&&this.opStack.push(b),void 0!==c&&this.opStack.push(c)},a.prototype.scheduleException=function(a,b){for(var c,d=this.method.getCodeAttribute(),e=this.pc,f=this.method,g=d.exceptionHandlers,h=b.getClass(),i=0;i<g.length;i++){var j=g[i];if(j.startPC<=e&&e<j.endPC){if("<any>"===j.catchType){c=j;break}var k=f.cls.getLoader().getResolvedClass(j.catchType);if(null==k){for(var l=[],m=0;m<g.length;m++){var n=g[m];"<any>"!==n.catchType&&l.push(n.catchType)}return a.setStatus(ThreadStatus.ASYNC_WAITING),f.cls.getLoader().resolveClasses(a,l,function(c){null!==c&&a.throwException(b)}),!0}if(h.isCastable(k)){c=j;break}}}return null!=c?(this.opStack.clear(),this.opStack.push(b),this.pc=c.handlerPC,!0):(f.accessFlags.isSynchronized()&&f.methodLock(a,this).exit(a),!1)},a.prototype.getLoader=function(){return this.method.cls.getLoader()},a.prototype.getStackTraceFrame=function(){return{method:this.method,pc:this.pc,stack:this.opStack.sliceFromBottom(0),locals:this.locals.slice(0)}},a}();exports.BytecodeStackFrame=BytecodeStackFrame;var NativeStackFrame=function(){function a(a,b){this.type=enums.StackFrameType.NATIVE,this.method=a,this.args=b,this.nativeMethod=a.getNativeFunction()}return a.prototype.run=function(a){var b=this.nativeMethod.apply(null,this.method.convertArgs(a,this.args));if(a.getStatus()===ThreadStatus.RUNNABLE&&a.currentMethod()===this.method){var c=this.method.returnType;switch(c){case"J":case"D":a.asyncReturn(b,null);break;case"Z":a.asyncReturn(b?1:0);break;default:a.asyncReturn(b)}}},a.prototype.scheduleResume=function(a,b,c){},a.prototype.scheduleException=function(a,b){return!1},a.prototype.getStackTraceFrame=function(){return{method:this.method,pc:-1,stack:[],locals:[]}},a.prototype.getLoader=function(){return this.method.cls.getLoader()},a}();exports.NativeStackFrame=NativeStackFrame;var InternalStackFrame=function(){function a(a){this.isException=!1,this.type=enums.StackFrameType.INTERNAL,this.cb=a}return a.prototype.run=function(a){a.framePop(),a.setStatus(ThreadStatus.ASYNC_WAITING),this.isException?this.cb(this.val):this.cb(null,this.val)},a.prototype.scheduleResume=function(a,b){this.isException=!1,this.val=b},a.prototype.scheduleException=function(a,b){return this.isException=!0,this.val=b,!0},a.prototype.getStackTraceFrame=function(){return null},a.prototype.getLoader=function(){throw new Error("Internal stack frames have no loader.")},a}();exports.InternalStackFrame=InternalStackFrame;var JVMThread=function(){function a(a,b,c){this.status=ThreadStatus.NEW,this.stack=[],this.interrupted=!1,this.monitor=null,this.jvm=a,this.bsCl=a.getBootstrapClassLoader(),this.tpool=b,this.jvmThreadObj=c}return a.prototype.getJVMObject=function(){return this.jvmThreadObj},a.prototype.isDaemon=function(){return 0!==this.jvmThreadObj["java/lang/Thread/daemon"]},a.prototype.getPriority=function(){return this.jvmThreadObj["java/lang/Thread/priority"]},a.prototype.setJVMObject=function(a){a["java/lang/Thread/threadStatus"]=this.jvmThreadObj["java/lang/Thread/threadStatus"],this.jvmThreadObj=a},a.prototype.getRef=function(){return this.jvmThreadObj.ref},a.prototype.isInterrupted=function(){return this.interrupted},a.prototype.currentMethod=function(){for(var a,b=this.stack,c=b.length;--c>=0;)if(a=b[c].getStackTraceFrame().method,null!==a)return a;return null},a.prototype.setInterrupted=function(a){this.interrupted=a},a.prototype.getBsCl=function(){return this.bsCl},a.prototype.getLoader=function(){var a=this.stack[this.stack.length-1].getLoader();if(a)return a;for(var b=this.stack.length,c=2;b>=c;c++)if(a=this.stack[b-c].getLoader())return a;throw new Error("Unable to find loader.")},a.prototype["import"]=function(a,b,c){var d=this;void 0===c&&(c=!0);var e=this.getLoader();if(this.setStatus(ThreadStatus.ASYNC_WAITING),Array.isArray(a)){var f=[];util.asyncForEach(a,function(a,b){d._import(a,e,function(a){f.push(a),b()},c)},function(a){b(f)})}else this._import(a,e,b,c)},a.prototype._import=function(a,b,c,d){var e=this,f=b.getInitializedClass(this,a);f?setImmediate(function(){return c(f.getConstructor(e))}):b.initializeClass(this,a,function(a){a&&c(a.getConstructor(e))},d)},a.prototype.getJVM=function(){return this.jvm},a.prototype.getThreadPool=function(){return this.tpool},a.prototype.getStackTrace=function(){var a,b,c=[];for(a=0;a<this.stack.length;a++)b=this.stack[a].getStackTraceFrame(),null!=b&&c.push(b);return c},a.prototype.getPrintableStackTrace=function(){var a="";return this.getStackTrace().reverse().forEach(function(b){if(a+="	at "+util.ext_classname(b.method.cls.getInternalName())+"::"+b.method.name+"(",b.pc>=0){var c=b.method.getCodeAttribute(),d=c.getAttribute("LineNumberTable"),e=b.method.cls.getAttribute("SourceFile");if(a+=null!=e?e.filename:"unknown",null!=d){var f=d.getLineNumber(b.pc);a+=":"+f,a+=" Bytecode offset: "+b.pc}}else a+="native";a+=")\n"}),a},a.prototype.run=function(){var a=this.stack,b=(new Date).getTime();for(methodResumesLeft=maxMethodResumes;this.status===ThreadStatus.RUNNABLE&&a.length>0;){var c=a[a.length-1];if(c.run(this),0===--methodResumesLeft){var d=(new Date).getTime(),e=d-b,f=maxMethodResumes/e*this.jvm.getResponsiveness()|0;maxMethodResumes=(f+numSamples*maxMethodResumes)/(numSamples+1)|0,0>=maxMethodResumes&&(maxMethodResumes=10),numSamples++,this.tpool.quantumOver(this);break}}0===a.length&&this.setStatus(ThreadStatus.TERMINATED)},a.prototype.sanityCheck=function(){switch(this.status){case ThreadStatus.NEW:return!0;case ThreadStatus.RUNNABLE:return!0;case ThreadStatus.TIMED_WAITING:return!0;case ThreadStatus.WAITING:return!0;case ThreadStatus.BLOCKED:case ThreadStatus.UNINTERRUPTABLY_BLOCKED:return!0;case ThreadStatus.ASYNC_WAITING:return!0;case ThreadStatus.TERMINATED:return!0;case ThreadStatus.PARKED:return!0;default:return!1}},a.prototype.rawSetStatus=function(a){var b=0,c=this.status;switch(logging.log_level===logging.VTRACE,this.status=a,a){case ThreadStatus.NEW:b|=enums.JVMTIThreadState.ALIVE;break;case ThreadStatus.RUNNABLE:b|=enums.JVMTIThreadState.RUNNABLE;break;case ThreadStatus.BLOCKED:case ThreadStatus.UNINTERRUPTABLY_BLOCKED:b|=enums.JVMTIThreadState.BLOCKED_ON_MONITOR_ENTER;break;case ThreadStatus.WAITING:case ThreadStatus.ASYNC_WAITING:case ThreadStatus.PARKED:b|=enums.JVMTIThreadState.WAITING_INDEFINITELY;break;case ThreadStatus.TIMED_WAITING:b|=enums.JVMTIThreadState.WAITING_WITH_TIMEOUT;break;case ThreadStatus.TERMINATED:b|=enums.JVMTIThreadState.TERMINATED;break;default:b=enums.JVMTIThreadState.RUNNABLE}this.jvmThreadObj["java/lang/Thread/threadStatus"]=b,this.tpool.statusChange(this,c,this.status)},a.prototype.setStatus=function(a,b){if(void 0===b&&(b=null),this.status!==a){this.status;this.monitor=b,a!==ThreadStatus.TERMINATED?this.rawSetStatus(a):this.exit()}},a.prototype.exit=function(){var a=this,b=this.jvmThreadObj.getMonitor();if(!b.isBlocked(this)&&b.getOwner()!==this&&this.status!==ThreadStatus.TERMINATED)if(0===this.stack.length){if(this.setStatus(ThreadStatus.ASYNC_WAITING),this.jvm.hasVMBooted()){var c=function(){a.jvmThreadObj["exit()V"](a,null,function(c){b.notifyAll(a),b.exit(a),a.rawSetStatus(ThreadStatus.TERMINATED)})};b.enter(this,c)&&c()}}else{for(;this.stack.length>0;)this.stack.pop();this.rawSetStatus(ThreadStatus.TERMINATED)}},a.prototype.signalPriorityChange=function(){this.tpool.priorityChange(this)},a.prototype.getMonitorBlock=function(){return this.monitor},a.prototype.getStatus=function(){return this.status},a.prototype.asyncReturn=function(a,b){var c=this.stack,d=c.pop();if(d.type!=enums.StackFrameType.INTERNAL){d.type===enums.StackFrameType.BYTECODE}var e=c.length-1;e>=0&&c[e].scheduleResume(this,a,b),this.setStatus(ThreadStatus.RUNNABLE)},a.prototype.framePop=function(){this.stack.pop()},a.prototype.throwException=function(a){var b=this.stack,c=b.length-1;if(c>=0)for(b[c].type===enums.StackFrameType.INTERNAL&&(b.pop(),c--),this.setStatus(ThreadStatus.RUNNABLE);b.length>0&&!b[c].scheduleException(this,a);)b.pop(),c--;0===b.length&&this.handleUncaughtException(a)},a.prototype.throwNewException=function(a,b){var c=this,d=this.getLoader().getInitializedClass(this,a),e=function(){var a=d.getConstructor(c),e=new a(c);e["<init>(Ljava/lang/String;)V"](c,[util.initString(c.bsCl,b)],function(a){a?c.throwException(a):c.throwException(e)})};null!=d?e():(this.setStatus(ThreadStatus.ASYNC_WAITING),this.getLoader().initializeClass(this,a,function(a){null!=a&&(d=a,e())},!1))},a.prototype.handleUncaughtException=function(a){this.jvmThreadObj["dispatchUncaughtException(Ljava/lang/Throwable;)V"](this,[a])},a.prototype.close=function(){this.jvm=null},a}();exports.JVMThread=JVMThread,exports.validTransitions={},exports.validTransitions[ThreadStatus.NEW]={},exports.validTransitions[ThreadStatus.NEW][ThreadStatus.RUNNABLE]="RunMethod invoked on new thread",exports.validTransitions[ThreadStatus.NEW][ThreadStatus.ASYNC_WAITING]="[JVM bootup only] Internal operation occurs on new thread",exports.validTransitions[ThreadStatus.NEW][ThreadStatus.TERMINATED]="[JVM halt0 only] When the JVM shuts down, it terminates all threads, including those that have never been run.",exports.validTransitions[ThreadStatus.ASYNC_WAITING]={},exports.validTransitions[ThreadStatus.ASYNC_WAITING][ThreadStatus.RUNNABLE]="Async operation completes",exports.validTransitions[ThreadStatus.ASYNC_WAITING][ThreadStatus.TERMINATED]="RunMethod completes and callstack is empty",exports.validTransitions[ThreadStatus.BLOCKED]={},exports.validTransitions[ThreadStatus.BLOCKED][ThreadStatus.RUNNABLE]="Acquires monitor, or is interrupted",exports.validTransitions[ThreadStatus.BLOCKED][ThreadStatus.TERMINATED]="Thread is terminated whilst blocked.",exports.validTransitions[ThreadStatus.PARKED]={},exports.validTransitions[ThreadStatus.PARKED][ThreadStatus.ASYNC_WAITING]="Balancing unpark, or is interrupted",exports.validTransitions[ThreadStatus.PARKED][ThreadStatus.TERMINATED]="Thread is terminated whilst parked.",exports.validTransitions[ThreadStatus.RUNNABLE]={},exports.validTransitions[ThreadStatus.RUNNABLE][ThreadStatus.ASYNC_WAITING]="Thread performs an asynchronous JavaScript operation",exports.validTransitions[ThreadStatus.RUNNABLE][ThreadStatus.TERMINATED]="Callstack is empty",exports.validTransitions[ThreadStatus.RUNNABLE][ThreadStatus.BLOCKED]="Thread waits to acquire monitor",exports.validTransitions[ThreadStatus.RUNNABLE][ThreadStatus.WAITING]="Thread waits on monitor (Object.wait)",exports.validTransitions[ThreadStatus.RUNNABLE][ThreadStatus.TIMED_WAITING]="Thread waits on monitor with timeout (Object.wait)",exports.validTransitions[ThreadStatus.RUNNABLE][ThreadStatus.PARKED]="Thread parks itself",exports.validTransitions[ThreadStatus.TERMINATED]={},exports.validTransitions[ThreadStatus.TERMINATED][ThreadStatus.NEW]="Thread is resurrected for re-use",exports.validTransitions[ThreadStatus.TERMINATED][ThreadStatus.RUNNABLE]="Thread is resurrected for re-use",exports.validTransitions[ThreadStatus.TERMINATED][ThreadStatus.ASYNC_WAITING]="[JVM Bootup] Thread is resurrected for internal operation",exports.validTransitions[ThreadStatus.TIMED_WAITING]={},exports.validTransitions[ThreadStatus.TIMED_WAITING][ThreadStatus.RUNNABLE]="Timer expires, or thread is interrupted, and thread immediately acquires lock",exports.validTransitions[ThreadStatus.TIMED_WAITING][ThreadStatus.UNINTERRUPTABLY_BLOCKED]="Thread is interrupted or notified, or timer expires, and lock already owned",exports.validTransitions[ThreadStatus.TIMED_WAITING][ThreadStatus.TERMINATED]="Thread is terminated whilst waiting.",exports.validTransitions[ThreadStatus.UNINTERRUPTABLY_BLOCKED]={},exports.validTransitions[ThreadStatus.UNINTERRUPTABLY_BLOCKED][ThreadStatus.RUNNABLE]="Thread acquires monitor",exports.validTransitions[ThreadStatus.UNINTERRUPTABLY_BLOCKED][ThreadStatus.TERMINATED]="Thread is terminated whilst blocked.",exports.validTransitions[ThreadStatus.WAITING]={},exports.validTransitions[ThreadStatus.WAITING][ThreadStatus.RUNNABLE]="Thread is interrupted, and immediately acquires lock",exports.validTransitions[ThreadStatus.WAITING][ThreadStatus.UNINTERRUPTABLY_BLOCKED]="Thread is notified or interrupted, and does not immediately acquire lock",exports.validTransitions[ThreadStatus.WAITING][ThreadStatus.TERMINATED]="Thread is terminated whilst waiting.",exports.OpcodeLayoutPrinters={},exports.OpcodeLayoutPrinters[enums.OpcodeLayoutType.OPCODE_ONLY]=function(a,b,c){return enums.OpCode[b.readUInt8(c)].toLowerCase()},exports.OpcodeLayoutPrinters[enums.OpcodeLayoutType.CONSTANT_POOL]=function(a,b,c){return enums.OpCode[b.readUInt8(c)].toLowerCase()+" "+printConstantPoolItem(a.cls.constantPool.get(b.readUInt16BE(c+1)))},exports.OpcodeLayoutPrinters[enums.OpcodeLayoutType.CONSTANT_POOL_UINT8]=function(a,b,c){return enums.OpCode[b.readUInt8(c)].toLowerCase()+" "+printConstantPoolItem(a.cls.constantPool.get(b.readUInt8(c+1)))},exports.OpcodeLayoutPrinters[enums.OpcodeLayoutType.CONSTANT_POOL_AND_UINT8_VALUE]=function(a,b,c){return enums.OpCode[b.readUInt8(c)].toLowerCase()+" "+printConstantPoolItem(a.cls.constantPool.get(b.readUInt16BE(c+1)))+" "+b.readUInt8(c+3)},exports.OpcodeLayoutPrinters[enums.OpcodeLayoutType.UINT8_VALUE]=function(a,b,c){return enums.OpCode[b.readUInt8(c)].toLowerCase()+" "+b.readUInt8(c+1)},exports.OpcodeLayoutPrinters[enums.OpcodeLayoutType.UINT8_AND_INT8_VALUE]=function(a,b,c){return enums.OpCode[b.readUInt8(c)].toLowerCase()+" "+b.readUInt8(c+1)+" "+b.readInt8(c+2)},exports.OpcodeLayoutPrinters[enums.OpcodeLayoutType.INT8_VALUE]=function(a,b,c){return enums.OpCode[b.readUInt8(c)].toLowerCase()+" "+b.readInt8(c+1)},exports.OpcodeLayoutPrinters[enums.OpcodeLayoutType.INT16_VALUE]=function(a,b,c){return enums.OpCode[b.readUInt8(c)].toLowerCase()+" "+b.readInt16BE(c+1)},exports.OpcodeLayoutPrinters[enums.OpcodeLayoutType.INT32_VALUE]=function(a,b,c){return enums.OpCode[b.readUInt8(c)].toLowerCase()+" "+b.readInt32BE(c+1)},exports.OpcodeLayoutPrinters[enums.OpcodeLayoutType.ARRAY_TYPE]=function(a,b,c){return enums.OpCode[b.readUInt8(c)].toLowerCase()+" "+opcodes.ArrayTypes[b.readUInt8(c+1)]},exports.OpcodeLayoutPrinters[enums.OpcodeLayoutType.WIDE]=function(a,b,c){return enums.OpCode[b.readUInt8(c)].toLowerCase()},exports.annotateOpcode=annotateOpcode;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function isNull(a,b,c){return null==c?(throwException(a,b,"Ljava/lang/NullPointerException;",""),!0):!1}function pop2(a){return a.pop(),a.pop()}function resolveCPItem(a,b,c){a.setStatus(enums.ThreadStatus.ASYNC_WAITING),c.resolve(a,b.getLoader(),b.method.cls,function(b){b&&a.setStatus(enums.ThreadStatus.RUNNABLE)},!1),b.returnToThreadLoop=!0}function initializeClassFromClass(a,b,c){a.setStatus(enums.ThreadStatus.ASYNC_WAITING),c.initialize(a,function(b){null!=b&&a.setStatus(enums.ThreadStatus.RUNNABLE)},!1),b.returnToThreadLoop=!0}function initializeClass(a,b,c){function d(b){b.initialize(a,function(b){null!=b&&a.setStatus(enums.ThreadStatus.RUNNABLE)})}a.setStatus(enums.ThreadStatus.ASYNC_WAITING),c.isResolved()?d(c.cls):c.resolve(a,b.getLoader(),b.method.cls,function(a){a&&d(c.cls)},!1),b.returnToThreadLoop=!0}function throwException(a,b,c,d){a.throwNewException(c,d),b.returnToThreadLoop=!0}var gLong=__webpack_require__(8),util=__webpack_require__(6),enums=__webpack_require__(9),assert=__webpack_require__(13);exports.isNull=isNull,exports.pop2=pop2,exports.resolveCPItem=resolveCPItem,exports.initializeClassFromClass=initializeClassFromClass,exports.initializeClass=initializeClass,exports.throwException=throwException,exports.ArrayTypes={4:"Z",5:"C",6:"F",7:"D",8:"B",9:"S",10:"I",11:"J"};var Opcodes=function(){function a(){}return a._aload_32=function(a,b){var c=b.opStack,d=c.pop(),e=c.pop();if(!isNull(a,b,e)){var f=e.array.length;0>d||d>=f?throwException(a,b,"Ljava/lang/ArrayIndexOutOfBoundsException;",d+" not in length "+f+" array of type "+e.getClass().getInternalName()):(c.push(e.array[d]),b.pc++)}},a._aload_64=function(a,b){var c=b.opStack,d=c.pop(),e=c.pop();if(!isNull(a,b,e)){var f=e.array.length;0>d||d>=f?throwException(a,b,"Ljava/lang/ArrayIndexOutOfBoundsException;",d+" not in length "+f+" array of type "+e.getClass().getInternalName()):(c.push(e.array[d]),c.push(null),b.pc++)}},a._astore_32=function(a,b){var c=b.opStack,d=c.pop(),e=c.pop(),f=c.pop();if(!isNull(a,b,f)){var g=f.array.length;0>e||e>=g?throwException(a,b,"Ljava/lang/ArrayIndexOutOfBoundsException;",e+" not in length "+g+" array of type "+f.getClass().getInternalName()):(f.array[e]=d,b.pc++)}},a._astore_64=function(a,b){var c=b.opStack,d=c.pop2(),e=c.pop(),f=c.pop();if(!isNull(a,b,f)){var g=f.array.length;0>e||e>=g?throwException(a,b,"Ljava/lang/ArrayIndexOutOfBoundsException;",e+" not in length "+g+" array of type "+f.getClass().getInternalName()):(f.array[e]=d,b.pc++)}},a.aconst_null=function(a,b){b.opStack.push(null),b.pc++},a._const_0_32=function(a,b){b.opStack.push(0),b.pc++},a._const_1_32=function(a,b){b.opStack.push(1),b.pc++},a._const_2_32=function(a,b){b.opStack.push(2),b.pc++},a.iconst_m1=function(a,b){b.opStack.push(-1),b.pc++},a.iconst_3=function(a,b){b.opStack.push(3),b.pc++},a.iconst_4=function(a,b){b.opStack.push(4),b.pc++},a.iconst_5=function(a,b){b.opStack.push(5),b.pc++},a.lconst_0=function(a,b){b.opStack.pushWithNull(gLong.ZERO),b.pc++},a.lconst_1=function(a,b){b.opStack.pushWithNull(gLong.ONE),b.pc++},a.dconst_0=function(a,b){b.opStack.pushWithNull(0),b.pc++},a.dconst_1=function(a,b){b.opStack.pushWithNull(1),b.pc++},a._load_32=function(a,b,c){var d=b.pc;b.opStack.push(b.locals[c.readUInt8(d+1)]),b.pc+=2},a._load_0_32=function(a,b){b.opStack.push(b.locals[0]),b.pc++},a._load_1_32=function(a,b){b.opStack.push(b.locals[1]),b.pc++},a._load_2_32=function(a,b){b.opStack.push(b.locals[2]),b.pc++},a._load_3_32=function(a,b){b.opStack.push(b.locals[3]),b.pc++},a._load_64=function(a,b,c){var d=b.pc;b.opStack.pushWithNull(b.locals[c.readUInt8(d+1)]),b.pc+=2},a._load_0_64=function(a,b){b.opStack.pushWithNull(b.locals[0]),b.pc++},a._load_1_64=function(a,b){b.opStack.pushWithNull(b.locals[1]),b.pc++},a._load_2_64=function(a,b){b.opStack.pushWithNull(b.locals[2]),b.pc++},a._load_3_64=function(a,b){b.opStack.pushWithNull(b.locals[3]),b.pc++},a._store_32=function(a,b,c){var d=b.pc;b.locals[c.readUInt8(d+1)]=b.opStack.pop(),b.pc+=2},a._store_0_32=function(a,b){b.locals[0]=b.opStack.pop(),b.pc++},a._store_1_32=function(a,b){b.locals[1]=b.opStack.pop(),b.pc++},a._store_2_32=function(a,b){b.locals[2]=b.opStack.pop(),b.pc++},a._store_3_32=function(a,b){b.locals[3]=b.opStack.pop(),b.pc++},a._store_64=function(a,b,c){var d=b.pc,e=c.readUInt8(d+1);b.locals[e+1]=b.opStack.pop(),b.locals[e]=b.opStack.pop(),b.pc+=2},a._store_0_64=function(a,b){b.locals[1]=b.opStack.pop(),b.locals[0]=b.opStack.pop(),b.pc++},a._store_1_64=function(a,b){b.locals[2]=b.opStack.pop(),b.locals[1]=b.opStack.pop(),b.pc++},a._store_2_64=function(a,b){b.locals[3]=b.opStack.pop(),b.locals[2]=b.opStack.pop(),b.pc++},a._store_3_64=function(a,b){b.locals[4]=b.opStack.pop(),b.locals[3]=b.opStack.pop(),b.pc++},a.sipush=function(a,b,c){var d=b.pc;b.opStack.push(c.readInt16BE(d+1)),b.pc+=3},a.bipush=function(a,b,c){var d=b.pc;b.opStack.push(c.readInt8(d+1)),b.pc+=2},a.pop=function(a,b){b.opStack.dropFromTop(1),b.pc++},a.pop2=function(a,b){b.opStack.dropFromTop(2),b.pc++},a.dup=function(a,b){b.opStack.dup(),b.pc++},a.dup_x1=function(a,b){b.opStack.dup_x1(),b.pc++},a.dup_x2=function(a,b){b.opStack.dup_x2(),b.pc++},a.dup2=function(a,b){b.opStack.dup2(),b.pc++},a.dup2_x1=function(a,b){b.opStack.dup2_x1(),b.pc++},a.dup2_x2=function(a,b){var c=b.opStack,d=c.pop(),e=c.pop(),f=c.pop(),g=c.pop();c.push6(e,d,g,f,e,d),b.pc++},a.swap=function(a,b){b.opStack.swap(),b.pc++},a.iadd=function(a,b){var c=b.opStack;c.push(c.pop()+c.pop()|0),b.pc++},a.ladd=function(a,b){var c=b.opStack;c.pushWithNull(c.pop2().add(c.pop2())),b.pc++},a.fadd=function(a,b){var c=b.opStack;c.push(util.wrapFloat(c.pop()+c.pop())),b.pc++},a.dadd=function(a,b){var c=b.opStack;c.pushWithNull(c.pop2()+c.pop2()),b.pc++},a.isub=function(a,b){var c=b.opStack;c.push(-c.pop()+c.pop()|0),b.pc++},a.fsub=function(a,b){var c=b.opStack;c.push(util.wrapFloat(-c.pop()+c.pop())),b.pc++},a.dsub=function(a,b){var c=b.opStack;c.pushWithNull(-c.pop2()+c.pop2()),b.pc++},a.lsub=function(a,b){var c=b.opStack;c.pushWithNull(c.pop2().negate().add(c.pop2())),b.pc++},a.imul=function(a,b){var c=b.opStack;c.push(Math.imul(c.pop(),c.pop())),b.pc++},a.lmul=function(a,b){var c=b.opStack;c.pushWithNull(c.pop2().multiply(c.pop2())),b.pc++},a.fmul=function(a,b){var c=b.opStack;c.push(util.wrapFloat(c.pop()*c.pop())),b.pc++},a.dmul=function(a,b){var c=b.opStack;c.pushWithNull(c.pop2()*c.pop2()),b.pc++},a.idiv=function(a,b){var c=b.opStack,d=c.pop(),e=c.pop();0===d?throwException(a,b,"Ljava/lang/ArithmeticException;","/ by zero"):(e===enums.Constants.INT_MIN&&-1===d?c.push(e):c.push(e/d|0),b.pc++)},a.ldiv=function(a,b){var c=b.opStack,d=c.pop2(),e=c.pop2();d.isZero()?throwException(a,b,"Ljava/lang/ArithmeticException;","/ by zero"):(c.pushWithNull(e.div(d)),b.pc++)},a.fdiv=function(a,b){var c=b.opStack,d=c.pop();c.push(util.wrapFloat(c.pop()/d)),b.pc++},a.ddiv=function(a,b){var c=b.opStack,d=c.pop2();c.pushWithNull(c.pop2()/d),b.pc++},a.irem=function(a,b){var c=b.opStack,d=c.pop(),e=c.pop();0===d?throwException(a,b,"Ljava/lang/ArithmeticException;","/ by zero"):(c.push(e%d),b.pc++)},a.lrem=function(a,b){var c=b.opStack,d=c.pop2(),e=c.pop2();d.isZero()?throwException(a,b,"Ljava/lang/ArithmeticException;","/ by zero"):(c.pushWithNull(e.modulo(d)),b.pc++)},a.frem=function(a,b){var c=b.opStack,d=c.pop();c.push(c.pop()%d),b.pc++},a.drem=function(a,b){var c=b.opStack,d=c.pop2();c.pushWithNull(c.pop2()%d),b.pc++},a.ineg=function(a,b){var c=b.opStack;c.push(0|-c.pop()),b.pc++},a.lneg=function(a,b){var c=b.opStack;c.pushWithNull(c.pop2().negate()),b.pc++},a.fneg=function(a,b){var c=b.opStack;c.push(-c.pop()),b.pc++},a.dneg=function(a,b){var c=b.opStack;c.pushWithNull(-c.pop2()),b.pc++},a.ishl=function(a,b){var c=b.opStack,d=c.pop();c.push(c.pop()<<d),b.pc++},a.lshl=function(a,b){var c=b.opStack,d=c.pop();c.pushWithNull(c.pop2().shiftLeft(gLong.fromInt(d))),b.pc++},a.ishr=function(a,b){var c=b.opStack,d=c.pop();c.push(c.pop()>>d),b.pc++},a.lshr=function(a,b){var c=b.opStack,d=c.pop();c.pushWithNull(c.pop2().shiftRight(gLong.fromInt(d))),b.pc++},a.iushr=function(a,b){var c=b.opStack,d=c.pop();c.push(c.pop()>>>d|0),b.pc++},a.lushr=function(a,b){var c=b.opStack,d=c.pop();c.pushWithNull(c.pop2().shiftRightUnsigned(gLong.fromInt(d))),b.pc++},a.iand=function(a,b){var c=b.opStack;c.push(c.pop()&c.pop()),b.pc++},a.land=function(a,b){var c=b.opStack;c.pushWithNull(c.pop2().and(c.pop2())),b.pc++},a.ior=function(a,b){var c=b.opStack;c.push(c.pop()|c.pop()),b.pc++},a.lor=function(a,b){var c=b.opStack;c.pushWithNull(c.pop2().or(c.pop2())),b.pc++},a.ixor=function(a,b){var c=b.opStack;c.push(c.pop()^c.pop()),b.pc++},a.lxor=function(a,b){var c=b.opStack;c.pushWithNull(c.pop2().xor(c.pop2())),b.pc++},a.iinc=function(a,b,c){var d=b.pc,e=c.readUInt8(d+1),f=c.readInt8(d+2);b.locals[e]=b.locals[e]+f|0,b.pc+=3},a.i2l=function(a,b){var c=b.opStack;c.pushWithNull(gLong.fromInt(c.pop())),b.pc++},a.i2f=function(a,b){b.pc++},a.i2d=function(a,b){b.opStack.push(null),b.pc++},a.l2i=function(a,b){var c=b.opStack;c.push(c.pop2().toInt()),b.pc++},a.l2f=function(a,b){var c=b.opStack;c.push(c.pop2().toNumber()),b.pc++},a.l2d=function(a,b){var c=b.opStack;c.pushWithNull(c.pop2().toNumber()),b.pc++},a.f2i=function(a,b){var c=b.opStack;c.push(util.float2int(c.pop())),b.pc++},a.f2l=function(a,b){var c=b.opStack;c.pushWithNull(gLong.fromNumber(c.pop())),b.pc++},a.f2d=function(a,b){b.opStack.push(null),b.pc++},a.d2i=function(a,b){var c=b.opStack;c.push(util.float2int(c.pop2())),b.pc++},a.d2l=function(a,b){var c=b.opStack,d=c.pop2();d===Number.POSITIVE_INFINITY?c.pushWithNull(gLong.MAX_VALUE):d===Number.NEGATIVE_INFINITY?c.pushWithNull(gLong.MIN_VALUE):c.pushWithNull(gLong.fromNumber(d)),b.pc++},a.d2f=function(a,b){var c=b.opStack;c.pop(),c.push(util.wrapFloat(c.pop())),b.pc++},a.i2b=function(a,b){var c=b.opStack;c.push(c.pop()<<24>>24),b.pc++},a.i2c=function(a,b){var c=b.opStack;c.push(65535&c.pop()),b.pc++},a.i2s=function(a,b){var c=b.opStack;c.push(c.pop()<<16>>16),b.pc++},a.lcmp=function(a,b){var c=b.opStack,d=c.pop2();c.push(c.pop2().compare(d)),b.pc++},a.fcmpl=function(a,b){var c=b.opStack,d=c.pop(),e=c.pop();e===d?c.push(0):e>d?c.push(1):c.push(-1),b.pc++},a.fcmpg=function(a,b){var c=b.opStack,d=c.pop(),e=c.pop();e===d?c.push(0):d>e?c.push(-1):c.push(1),b.pc++},a.dcmpl=function(a,b){var c=b.opStack,d=c.pop2(),e=c.pop2();e===d?c.push(0):e>d?c.push(1):c.push(-1),b.pc++},a.dcmpg=function(a,b){var c=b.opStack,d=c.pop2(),e=c.pop2();e===d?c.push(0):d>e?c.push(-1):c.push(1),b.pc++},a.ifeq=function(a,b,c){var d=b.pc;if(0===b.opStack.pop()){var e=c.readInt16BE(d+1);b.pc+=e,0>e&&b.method.incrBBEntries()}else b.pc+=3},a.ifne=function(a,b,c){var d=b.pc;if(0!==b.opStack.pop()){var e=c.readInt16BE(d+1);b.pc+=e,0>e&&b.method.incrBBEntries()}else b.pc+=3},a.iflt=function(a,b,c){var d=b.pc;if(b.opStack.pop()<0){var e=c.readInt16BE(d+1);b.pc+=e,0>e&&b.method.incrBBEntries()}else b.pc+=3},a.ifge=function(a,b,c){var d=b.pc;if(b.opStack.pop()>=0){var e=c.readInt16BE(d+1);b.pc+=e,0>e&&b.method.incrBBEntries()}else b.pc+=3},a.ifgt=function(a,b,c){var d=b.pc;if(b.opStack.pop()>0){var e=c.readInt16BE(d+1);b.pc+=e,0>e&&b.method.incrBBEntries()}else b.pc+=3},a.ifle=function(a,b,c){var d=b.pc;if(b.opStack.pop()<=0){var e=c.readInt16BE(d+1);b.pc+=e,0>e&&b.method.incrBBEntries()}else b.pc+=3},a.if_icmpeq=function(a,b,c){var d=b.pc,e=b.opStack.pop(),f=b.opStack.pop();if(f===e){var g=c.readInt16BE(d+1);b.pc+=g,0>g&&b.method.incrBBEntries()}else b.pc+=3},a.if_icmpne=function(a,b,c){var d=b.pc,e=b.opStack.pop(),f=b.opStack.pop();if(f!==e){var g=c.readInt16BE(d+1);b.pc+=g,0>g&&b.method.incrBBEntries()}else b.pc+=3},a.if_icmplt=function(a,b,c){var d=b.pc,e=b.opStack.pop(),f=b.opStack.pop();if(e>f){var g=c.readInt16BE(d+1);b.pc+=g,0>g&&b.method.incrBBEntries()}else b.pc+=3},a.if_icmpge=function(a,b,c){var d=b.pc,e=b.opStack.pop(),f=b.opStack.pop();if(f>=e){var g=c.readInt16BE(d+1);b.pc+=g,0>g&&b.method.incrBBEntries()}else b.pc+=3},a.if_icmpgt=function(a,b,c){var d=b.pc,e=b.opStack.pop(),f=b.opStack.pop();if(f>e){var g=c.readInt16BE(d+1);b.pc+=g,0>g&&b.method.incrBBEntries()}else b.pc+=3},a.if_icmple=function(a,b,c){var d=b.pc,e=b.opStack.pop(),f=b.opStack.pop();if(e>=f){var g=c.readInt16BE(d+1);b.pc+=g,0>g&&b.method.incrBBEntries()}else b.pc+=3},a.if_acmpeq=function(a,b,c){var d=b.pc,e=b.opStack.pop(),f=b.opStack.pop();if(f===e){var g=c.readInt16BE(d+1);b.pc+=g,0>g&&b.method.incrBBEntries()}else b.pc+=3},a.if_acmpne=function(a,b,c){var d=b.pc,e=b.opStack.pop(),f=b.opStack.pop();if(f!==e){var g=c.readInt16BE(d+1);b.pc+=g,0>g&&b.method.incrBBEntries()}else b.pc+=3},a["goto"]=function(a,b,c){var d=b.pc,e=c.readInt16BE(d+1);b.pc+=e,0>e&&b.method.incrBBEntries()},a.jsr=function(a,b,c){var d=b.pc;b.opStack.push(d+3);var e=c.readInt16BE(d+1);b.pc+=e,0>e&&b.method.incrBBEntries()},a.ret=function(a,b,c){var d=b.pc;b.pc=b.locals[c.readUInt8(d+1)]},a.tableswitch=function(a,b,c){var d=b.pc;d+=(4-(d+1)%4)%4+1;var e=c.readInt32BE(d),f=c.readInt32BE(d+4),g=c.readInt32BE(d+8),h=b.opStack.pop();h>=f&&g>=h?b.pc+=c.readInt32BE(d+12+4*(h-f)):b.pc+=e},a.lookupswitch=function(a,b,c){var d=b.pc;d+=(4-(d+1)%4)%4+1;var e,f=c.readInt32BE(d),g=c.readInt32BE(d+4),h=b.opStack.pop();for(d+=8,e=0;g>e;e++){if(c.readInt32BE(d)===h){var i=c.readInt32BE(d+4);return b.pc+=i,void(0>i&&b.method.incrBBEntries())}d+=8}b.pc+=f},a["return"]=function(a,b){b.returnToThreadLoop=!0,b.method.accessFlags.isSynchronized()&&!b.method.methodLock(a,b).exit(a)||a.asyncReturn()},a._return_32=function(a,b){b.returnToThreadLoop=!0,b.method.accessFlags.isSynchronized()&&!b.method.methodLock(a,b).exit(a)||a.asyncReturn(b.opStack.bottom())},a._return_64=function(a,b){b.returnToThreadLoop=!0,b.method.accessFlags.isSynchronized()&&!b.method.methodLock(a,b).exit(a)||a.asyncReturn(b.opStack.bottom(),null)},a.getstatic=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));if(e.isResolved()){var f=e.field.cls;f.isInitialized(a)?("J"===e.nameAndTypeInfo.descriptor||"D"===e.nameAndTypeInfo.descriptor?c.writeUInt8(enums.OpCode.GETSTATIC_FAST64,d):c.writeUInt8(enums.OpCode.GETSTATIC_FAST32,d),e.fieldOwnerConstructor=f.getConstructor(a)):initializeClassFromClass(a,b,f)}else resolveCPItem(a,b,e)},a.getstatic_fast32=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));b.opStack.push(e.fieldOwnerConstructor[e.fullFieldName]),b.pc+=3},a.getstatic_fast64=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));b.opStack.pushWithNull(e.fieldOwnerConstructor[e.fullFieldName]),b.pc+=3},a.putstatic=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));if(e.isResolved()){var f=e.field.cls;f.isInitialized(a)?("J"===e.nameAndTypeInfo.descriptor||"D"===e.nameAndTypeInfo.descriptor?c.writeUInt8(enums.OpCode.PUTSTATIC_FAST64,d):c.writeUInt8(enums.OpCode.PUTSTATIC_FAST32,d),e.fieldOwnerConstructor=f.getConstructor(a)):initializeClassFromClass(a,b,f)}else resolveCPItem(a,b,e)},a.putstatic_fast32=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));e.fieldOwnerConstructor[e.fullFieldName]=b.opStack.pop(),b.pc+=3},a.putstatic_fast64=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));e.fieldOwnerConstructor[e.fullFieldName]=b.opStack.pop2(),b.pc+=3},a.getfield=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=(b.getLoader(),b.opStack.top());if(!isNull(a,b,f))if(e.isResolved()){var g=e.field;"J"==g.rawDescriptor||"D"==g.rawDescriptor?c.writeUInt8(enums.OpCode.GETFIELD_FAST64,d):c.writeUInt8(enums.OpCode.GETFIELD_FAST32,d)}else resolveCPItem(a,b,e)},a.getfield_fast32=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=b.opStack,g=f.pop();isNull(a,b,g)||(f.push(g[e.fullFieldName]),b.pc+=3)},a.getfield_fast64=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=b.opStack,g=f.pop();isNull(a,b,g)||(f.pushWithNull(g[e.fullFieldName]),b.pc+=3)},a.putfield=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=(b.getLoader(),"J"==e.nameAndTypeInfo.descriptor||"D"==e.nameAndTypeInfo.descriptor),g=b.opStack.fromTop(f?2:1);if(!isNull(a,b,g))if(e.isResolved()){var h=e.field;f?c.writeUInt8(enums.OpCode.PUTFIELD_FAST64,d):c.writeUInt8(enums.OpCode.PUTFIELD_FAST32,d),e.fullFieldName=util.descriptor2typestr(h.cls.getInternalName())+"/"+e.nameAndTypeInfo.name}else resolveCPItem(a,b,e)},a.putfield_fast32=function(a,b,c){var d=b.pc,e=b.opStack,f=e.pop(),g=e.pop(),h=b.method.cls.constantPool.get(c.readUInt16BE(d+1));isNull(a,b,g)||(g[h.fullFieldName]=f,b.pc+=3)},a.putfield_fast64=function(a,b,c){var d=b.pc,e=b.opStack,f=e.pop2(),g=e.pop(),h=b.method.cls.constantPool.get(c.readUInt16BE(d+1));isNull(a,b,g)||(g[h.fullFieldName]=f,b.pc+=3)},a.invokevirtual=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));if(e.isResolved()){var f=e.method;if(f.isSignaturePolymorphic())switch(f.name){case"invokeBasic":c.writeUInt8(enums.OpCode.INVOKEBASIC,d);break;case"invoke":case"invokeExact":c.writeUInt8(enums.OpCode.INVOKEHANDLE,d);break;default:throwException(a,b,"Ljava/lang/AbstractMethodError;","Invalid signature polymorphic method: "+f.cls.getExternalName()+"."+f.name)}else c.writeUInt8(enums.OpCode.INVOKEVIRTUAL_FAST,d)}else resolveCPItem(a,b,e)},a.invokeinterface=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));e.isResolved()?e.method.cls.isInitialized(a)?c.writeUInt8(enums.OpCode.INVOKEINTERFACE_FAST,d):initializeClass(a,b,e.classInfo):resolveCPItem(a,b,e)},a.invokedynamic=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));a.setStatus(enums.ThreadStatus.ASYNC_WAITING),e.constructCallSiteObject(a,b.getLoader(),b.method.cls,d,function(b){b&&(c.writeUInt8(enums.OpCode.INVOKEDYNAMIC_FAST,d),a.setStatus(enums.ThreadStatus.RUNNABLE))}),b.returnToThreadLoop=!0},a.invokespecial=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));e.isResolved()?c.writeUInt8(enums.OpCode.INVOKENONVIRTUAL_FAST,d):resolveCPItem(a,b,e)},a.invokestatic=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));if(e.isResolved()){var f=e.method;if(f.cls.isInitialized(a)){var g=enums.OpCode.INVOKESTATIC_FAST;if(e.method.isSignaturePolymorphic())switch(e.method.name){case"linkToInterface":case"linkToVirtual":g=enums.OpCode.LINKTOVIRTUAL;break;case"linkToStatic":case"linkToSpecial":g=enums.OpCode.LINKTOSPECIAL}c.writeUInt8(g,d)}else initializeClassFromClass(a,b,f.cls)}else resolveCPItem(a,b,e)},a.invokenonvirtual_fast=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=b.opStack,g=e.paramWordSize,h=f.fromTop(g);if(!isNull(a,b,h)){var i=f.sliceFromTop(g);f.dropFromTop(g+1),h[e.fullSignature](a,i),b.returnToThreadLoop=!0}},a.invokestatic_fast=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=b.opStack,g=e.paramWordSize,h=f.sliceAndDropFromTop(g);e.jsConstructor[e.fullSignature](a,h),b.returnToThreadLoop=!0},a.invokevirtual_fast=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=e.paramWordSize,g=b.opStack,h=g.fromTop(f);isNull(a,b,h)||(h[e.signature](a,g.sliceFromTop(f)),g.dropFromTop(f+1),b.returnToThreadLoop=!0)},a.invokedynamic_fast=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=e.getCallSiteObject(d),g=f[1],h=f[0].vmtarget,i=b.opStack,j=e.paramWordSize,k=i.sliceAndDropFromTop(j);null!==g&&k.push(g),h(a,null,k),b.returnToThreadLoop=!0},a.invokehandle=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=b.opStack,g=e.memberName.vmtarget,h=e.paramWordSize+1,i=e.appendix,j=f.sliceFromTop(h);null!==i&&j.push(i),isNull(a,b,j[0])||(f.dropFromTop(h),g(a,null,j),b.returnToThreadLoop=!0)},a.invokebasic=function(a,b,c){var d,e,f=b.pc,g=b.method.cls.constantPool.get(c.readUInt16BE(f+1)),h=g.getParamWordSize(),i=b.opStack,j=i.fromTop(h),k=i.sliceFromTop(h+1);isNull(a,b,j)||(i.dropFromTop(h+1),d=j["java/lang/invoke/MethodHandle/form"],e=d["java/lang/invoke/LambdaForm/vmentry"],e.vmtarget(a,g.nameAndTypeInfo.descriptor,k),b.returnToThreadLoop=!0)},a.linktospecial=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=b.opStack,g=e.paramWordSize,h=f.sliceFromTop(g),i=h.pop(),j=e.nameAndTypeInfo.descriptor;isNull(a,b,i)||(f.dropFromTop(g),i.vmtarget(a,j.replace("Ljava/lang/invoke/MemberName;)",")"),h),b.returnToThreadLoop=!0)},a.linktovirtual=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=e.paramWordSize,g=b.opStack,h=g.sliceFromTop(f),i=h.pop(),j=e.nameAndTypeInfo.descriptor;isNull(a,b,i)||(g.dropFromTop(f),i.vmtarget(a,j.replace("Ljava/lang/invoke/MemberName;)",")"),h),b.returnToThreadLoop=!0)},a.breakpoint=function(a,b){throwException(a,b,"Ljava/lang/Error;","breakpoint not implemented.")},a["new"]=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));if(e.isResolved()){var f=e.cls;f.isInitialized(a)?c.writeUInt8(enums.OpCode.NEW_FAST,d):initializeClassFromClass(a,b,f)}else resolveCPItem(a,b,e)},a.new_fast=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));b.opStack.push(new e.clsConstructor(a)),b.pc+=3},a.newarray=function(a,b,c){var d=b.pc,e=b.opStack,f="["+exports.ArrayTypes[c.readUInt8(d+1)],g=b.getLoader().getInitializedClass(a,f),h=e.pop();h>=0?(e.push(new(g.getConstructor(a))(a,h)),b.pc+=2):throwException(a,b,"Ljava/lang/NegativeArraySizeException;","Tried to init "+f+" array with length "+h)},a.anewarray=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));e.isResolved()?(c.writeUInt8(enums.OpCode.ANEWARRAY_FAST,d),e.arrayClass=b.getLoader().getInitializedClass(a,"["+e.cls.getInternalName()),e.arrayClassConstructor=e.arrayClass.getConstructor(a)):resolveCPItem(a,b,e)},a.anewarray_fast=function(a,b,c){var d=b.pc,e=b.opStack,f=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),g=e.pop();g>=0?(e.push(new f.arrayClassConstructor(a,g)),b.pc+=3):throwException(a,b,"Ljava/lang/NegativeArraySizeException;","Tried to init "+f.arrayClass.getInternalName()+" array with length "+g)},a.arraylength=function(a,b){var c=b.opStack,d=c.pop();isNull(a,b,d)||(c.push(d.array.length),b.pc++)},a.athrow=function(a,b){a.throwException(b.opStack.pop()),b.returnToThreadLoop=!0},a.checkcast=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));e.isResolved()?c.writeUInt8(enums.OpCode.CHECKCAST_FAST,d):resolveCPItem(a,b,e)},a.checkcast_fast=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=e.cls,g=b.opStack,h=g.top();if(null==h||h.getClass().isCastable(f))b.pc+=3;else{var i=f.getExternalName(),j=h.getClass().getExternalName();throwException(a,b,"Ljava/lang/ClassCastException;",j+" cannot be cast to "+i)}},a["instanceof"]=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));e.isResolved()?c.writeUInt8(enums.OpCode.INSTANCEOF_FAST,d):resolveCPItem(a,b,e)},a.instanceof_fast=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1)),f=e.cls,g=b.opStack,h=g.pop();g.push(null!==h&&h.getClass().isCastable(f)?1:0),b.pc+=3},a.monitorenter=function(a,b){var c=b.opStack,d=c.pop(),e=function(){b.pc++};d.getMonitor().enter(a,e)?e():b.returnToThreadLoop=!0},a.monitorexit=function(a,b){var c=b.opStack.pop();c.getMonitor().exit(a)?b.pc++:b.returnToThreadLoop=!0},a.multianewarray=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));e.isResolved()?c.writeUInt8(enums.OpCode.MULTIANEWARRAY_FAST,d):resolveCPItem(a,b,e)},a.multianewarray_fast=function(a,b,c){var d,e,f=b.pc,g=b.method.cls.constantPool.get(c.readUInt16BE(f+1)),h=b.opStack,i=c.readUInt8(f+3),j=new Array(i);for(d=0;i>d;d++)if(e=h.pop(),j[i-d-1]=e,0>e)return void throwException(a,b,"Ljava/lang/NegativeArraySizeException;","Tried to init "+g.cls.getInternalName()+" array with a dimension of length "+e);h.push(new(g.cls.getConstructor(a))(a,j)),b.pc+=4},a.ifnull=function(a,b,c){var d=b.pc;if(null==b.opStack.pop()){var e=c.readInt16BE(d+1);b.pc+=e,0>e&&b.method.incrBBEntries()}else b.pc+=3},a.ifnonnull=function(a,b,c){var d=b.pc;if(null!=b.opStack.pop()){var e=c.readInt16BE(d+1);b.pc+=e,0>e&&b.method.incrBBEntries()}else b.pc+=3},a.goto_w=function(a,b,c){var d=b.pc,e=c.readInt32BE(d+1);b.pc+=e,0>e&&b.method.incrBBEntries()},a.jsr_w=function(a,b,c){var d=b.pc;b.opStack.push(b.pc+5),b.pc+=c.readInt32BE(d+1)},a.nop=function(a,b){b.pc+=1},a.ldc=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt8(d+1));e.isResolved()?(b.opStack.push(e.getConstant(a)),b.pc+=2):resolveCPItem(a,b,e)},a.ldc_w=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));e.isResolved()?(b.opStack.push(e.getConstant(a)),b.pc+=3):resolveCPItem(a,b,e)},a.ldc2_w=function(a,b,c){var d=b.pc,e=b.method.cls.constantPool.get(c.readUInt16BE(d+1));b.opStack.pushWithNull(e.value),b.pc+=3},a.wide=function(a,b,c){var d=b.pc,e=c.readUInt16BE(d+2);switch(b.pc+=4,c.readUInt8(d+1)){case enums.OpCode.ILOAD:case enums.OpCode.FLOAD:case enums.OpCode.ALOAD:b.opStack.push(b.locals[e]);break;case enums.OpCode.LLOAD:case enums.OpCode.DLOAD:b.opStack.pushWithNull(b.locals[e]);break;case enums.OpCode.ISTORE:case enums.OpCode.FSTORE:case enums.OpCode.ASTORE:b.locals[e]=b.opStack.pop();break;case enums.OpCode.LSTORE:case enums.OpCode.DSTORE:b.locals[e+1]=b.opStack.pop(),b.locals[e]=b.opStack.pop();break;case enums.OpCode.RET:b.pc=b.locals[e];break;case enums.OpCode.IINC:var f=c.readInt16BE(d+4);b.locals[e]=b.locals[e]+f|0,b.pc+=2}},a.iaload=a._aload_32,a.faload=a._aload_32,a.aaload=a._aload_32,a.baload=a._aload_32,a.caload=a._aload_32,a.saload=a._aload_32,a.daload=a._aload_64,a.laload=a._aload_64,a.iastore=a._astore_32,a.fastore=a._astore_32,a.aastore=a._astore_32,a.bastore=a._astore_32,a.castore=a._astore_32,a.sastore=a._astore_32,a.lastore=a._astore_64,a.dastore=a._astore_64,a.iconst_0=a._const_0_32,a.iconst_1=a._const_1_32,a.iconst_2=a._const_2_32,a.fconst_0=a._const_0_32,a.fconst_1=a._const_1_32,a.fconst_2=a._const_2_32,a.iload=a._load_32,a.iload_0=a._load_0_32,a.iload_1=a._load_1_32,a.iload_2=a._load_2_32,a.iload_3=a._load_3_32,a.fload=a._load_32,a.fload_0=a._load_0_32,a.fload_1=a._load_1_32,a.fload_2=a._load_2_32,a.fload_3=a._load_3_32,a.aload=a._load_32,a.aload_0=a._load_0_32,a.aload_1=a._load_1_32,a.aload_2=a._load_2_32,a.aload_3=a._load_3_32,a.lload=a._load_64,a.lload_0=a._load_0_64,a.lload_1=a._load_1_64,a.lload_2=a._load_2_64,a.lload_3=a._load_3_64,a.dload=a._load_64,a.dload_0=a._load_0_64,a.dload_1=a._load_1_64,a.dload_2=a._load_2_64,a.dload_3=a._load_3_64,a.istore=a._store_32,a.istore_0=a._store_0_32,a.istore_1=a._store_1_32,a.istore_2=a._store_2_32,a.istore_3=a._store_3_32,a.fstore=a._store_32,a.fstore_0=a._store_0_32,a.fstore_1=a._store_1_32,a.fstore_2=a._store_2_32,a.fstore_3=a._store_3_32,a.astore=a._store_32,a.astore_0=a._store_0_32,a.astore_1=a._store_1_32,a.astore_2=a._store_2_32,a.astore_3=a._store_3_32,a.lstore=a._store_64,a.lstore_0=a._store_0_64,a.lstore_1=a._store_1_64,a.lstore_2=a._store_2_64,a.lstore_3=a._store_3_64,a.dstore=a._store_64,a.dstore_0=a._store_0_64,a.dstore_1=a._store_1_64,a.dstore_2=a._store_2_64,a.dstore_3=a._store_3_64,a.ireturn=a._return_32,a.freturn=a._return_32,a.areturn=a._return_32,a.lreturn=a._return_64,a.dreturn=a._return_64,a.invokeinterface_fast=a.invokevirtual_fast,a}();exports.Opcodes=Opcodes,exports.LookupTable=new Array(255),function(){for(var a=0;255>a;a++)enums.OpCode.hasOwnProperty(""+a)&&(exports.LookupTable[a]=Opcodes[enums.OpCode[a].toLowerCase()])}();


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function debug_var(a){return null===a?"!":void 0===a?"undef":null!=a.ref?"*"+a.ref:a instanceof gLong?a+"L":a}function debug_vars(a){return a.map(debug_var)}function log(a,b){if(a<=exports.log_level){var c=b.join(" ");1==a?console.error(c):console.log(c)}}function vtrace(){for(var a=[],b=0;b<arguments.length;b++)a[b-0]=arguments[b];log(exports.VTRACE,a)}function trace(){for(var a=[],b=0;b<arguments.length;b++)a[b-0]=arguments[b];log(exports.TRACE,a)}function debug(){for(var a=[],b=0;b<arguments.length;b++)a[b-0]=arguments[b];log(exports.DEBUG,a)}function error(){for(var a=[],b=0;b<arguments.length;b++)a[b-0]=arguments[b];log(exports.ERROR,a)}var gLong=__webpack_require__(8);exports.debug_var=debug_var,exports.debug_vars=debug_vars,exports.VTRACE=10,exports.TRACE=9,exports.DEBUG=5,exports.ERROR=1,exports.log_level=exports.ERROR,exports.vtrace=vtrace,exports.trace=trace,exports.debug=debug,exports.error=error;


/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";var StringOutputStream=function(){function a(){this._data=[]}return a.prototype.write=function(a){this._data.push(a)},a.prototype.flush=function(){var a=this._data.join("");return this._data=[],a},a}();module.exports=StringOutputStream;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function makeOnError(a,b){return a.length>0?"f.pc="+b+";f.opStack.pushAll("+a.join(",")+");":"f.pc="+b+";"}var enums=__webpack_require__(9),opcodes=__webpack_require__(16),escapeStringRegEx=/\\/g;exports.opJitInfo=function(){var a=[],b=enums.OpCode;a[b.ACONST_NULL]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=null;"+d}},a[b.ICONST_M1]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=-1;"+d}};var c={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=f.locals[0];"+d}},d={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=f.locals[1];"+d}},e={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=f.locals[2];"+d}},f={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=f.locals[3];"+d}};a[b.ALOAD_0]=c,a[b.ILOAD_0]=c,a[b.FLOAD_0]=c,a[b.ALOAD_1]=d,a[b.ILOAD_1]=d,a[b.FLOAD_1]=d,a[b.ALOAD_2]=e,a[b.ILOAD_2]=e,a[b.FLOAD_2]=e,a[b.ALOAD_3]=f,a[b.ILOAD_3]=f,a[b.FLOAD_3]=f;var g={hasBranch:!1,pops:0,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"=f.locals[0],"+b[1]+"=null;"+d}},h={hasBranch:!1,pops:0,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"=f.locals[1],"+b[1]+"=null;"+d}},i={hasBranch:!1,pops:0,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"=f.locals[2],"+b[1]+"=null;"+d}},j={hasBranch:!1,pops:0,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"=f.locals[3],"+b[1]+"=null;"+d}};a[b.LLOAD_0]=g,a[b.DLOAD_0]=g,a[b.LLOAD_1]=h,a[b.DLOAD_1]=h,a[b.LLOAD_2]=i,a[b.DLOAD_2]=i,a[b.LLOAD_3]=j,a[b.DLOAD_3]=j;var k={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d){return"f.locals[0]="+a[0]+";"+d}},l={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d){return"f.locals[1]="+a[0]+";"+d}},m={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d){return"f.locals[2]="+a[0]+";"+d}},n={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d){return"f.locals[3]="+a[0]+";"+d}};a[b.ASTORE_0]=k,a[b.ISTORE_0]=k,a[b.FSTORE_0]=k,a[b.ASTORE_1]=l,a[b.ISTORE_1]=l,a[b.FSTORE_1]=l,a[b.ASTORE_2]=m,a[b.ISTORE_2]=m,a[b.FSTORE_2]=m,a[b.ASTORE_3]=n,a[b.ISTORE_3]=n,a[b.FSTORE_3]=n;var o={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d,e,f){var g=e.readUInt8(f+1);return"f.locals["+(g+1)+"]="+a[0]+";f.locals["+g+"]="+a[1]+";"+d}},p={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d){return"f.locals[1]="+a[0]+";f.locals[0]="+a[1]+";"+d}},q={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d){return"f.locals[2]="+a[0]+";f.locals[1]="+a[1]+";"+d}},r={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d){return"f.locals[3]="+a[0]+";f.locals[2]="+a[1]+";"+d}},s={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d){return"f.locals[4]="+a[0]+";f.locals[3]="+a[1]+";"+d}};a[b.LSTORE]=o,a[b.DSTORE]=o,a[b.LSTORE_0]=p,a[b.DSTORE_0]=p,a[b.LSTORE_1]=q,a[b.DSTORE_1]=q,a[b.LSTORE_2]=r,a[b.DSTORE_2]=r,a[b.LSTORE_3]=s,a[b.DSTORE_3]=s;var t={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=0;"+d}},u={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=1;"+d}},v={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=2;"+d}};a[b.ICONST_0]=t,a[b.ICONST_1]=u,a[b.ICONST_2]=v,a[b.FCONST_0]=t,a[b.FCONST_1]=u,a[b.FCONST_2]=v,a[b.ICONST_3]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=3;"+d}},a[b.ICONST_4]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=4;"+d}},a[b.ICONST_5]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=5;"+d}},a[b.LCONST_0]={hasBranch:!1,pops:0,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"=u.gLong.ZERO,"+b[1]+"=null;"+d}},a[b.LCONST_1]={hasBranch:!1,pops:0,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"=u.gLong.ONE,"+b[1]+"=null;"+d}},a[b.DCONST_0]={hasBranch:!1,pops:0,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"=0,"+b[1]+"=null;"+d}},a[b.DCONST_1]={hasBranch:!1,pops:0,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"=1,"+b[1]+"=null;"+d}};var w={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d,e,f,g){var h=makeOnError(g,f);return"\nif(!u.isNull(t,f,"+a[1]+")){\nvar len"+c+"="+a[1]+".array.length;\nif("+a[0]+"<0||"+a[0]+">=len"+c+"){\n"+h+"\nu.throwException(t,f,'Ljava/lang/ArrayIndexOutOfBoundsException;',\"\"+"+a[0]+'+" not in length "+len'+c+'+" array of type "+'+a[1]+".getClass().getInternalName());\n}else{var "+b[0]+"="+a[1]+".array["+a[0]+"];"+d+"}\n}else{"+h+"}"}};a[b.IALOAD]=w,a[b.FALOAD]=w,a[b.AALOAD]=w,a[b.BALOAD]=w,a[b.CALOAD]=w,a[b.SALOAD]=w;var x={hasBranch:!1,pops:2,pushes:2,emit:function(a,b,c,d,e,f,g){var h=makeOnError(g,f);return"\nif(!u.isNull(t,f,"+a[1]+")){\nvar len"+c+"="+a[1]+".array.length;\nif("+a[0]+"<0||"+a[0]+">=len"+c+"){\n"+h+"\nu.throwException(t,f,'Ljava/lang/ArrayIndexOutOfBoundsException;',\"\"+"+a[0]+'+" not in length "+len'+c+'+" array of type "+'+a[1]+".getClass().getInternalName());\n}else{var "+b[0]+"="+a[1]+".array["+a[0]+"],"+b[1]+"=null;"+d+"}\n}else{"+h+"}"}};a[b.DALOAD]=x,a[b.LALOAD]=x;var y={hasBranch:!1,pops:3,pushes:0,emit:function(a,b,c,d,e,f,g){var h=makeOnError(g,f);return"\nif(!u.isNull(t,f,"+a[2]+")){\nvar len"+c+"="+a[2]+".array.length;\nif("+a[1]+"<0||"+a[1]+">=len"+c+"){\n"+h+"\nu.throwException(t,f,'Ljava/lang/ArrayIndexOutOfBoundsException;',\"\"+"+a[1]+'+" not in length "+len'+c+'+" array of type "+'+a[2]+".getClass().getInternalName());\n}else{"+a[2]+".array["+a[1]+"]="+a[0]+";"+d+"}\n}else{"+h+"}"}};a[b.IASTORE]=y,a[b.FASTORE]=y,a[b.AASTORE]=y,a[b.BASTORE]=y,a[b.CASTORE]=y,a[b.SASTORE]=y;var z={hasBranch:!1,pops:4,pushes:0,emit:function(a,b,c,d,e,f,g){var h=makeOnError(g,f);return"\nif(!u.isNull(t,f,"+a[3]+")){\nvar len"+c+"="+a[3]+".array.length;\nif("+a[2]+"<0||"+a[2]+">=len"+c+"){\n"+h+"\nu.throwException(t,f,'Ljava/lang/ArrayIndexOutOfBoundsException;',\"\"+"+a[2]+'+" not in length "+len'+c+'+" array of type "+'+a[3]+".getClass().getInternalName());\n}else{"+a[3]+".array["+a[2]+"]="+a[1]+";"+d+"}\n}else{"+h+"}"}};a[b.DASTORE]=z,a[b.LASTORE]=z,a[b.LDC]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d,e,f,g){var h=e.readUInt8(f+1),i=makeOnError(g,f);return"\nvar cnst"+c+"=f.method.cls.constantPool.get("+h+");\nif(cnst"+c+".isResolved()){var "+b[0]+"=cnst"+c+".getConstant(t);"+d+"\n}else{"+i+"u.resolveCPItem(t,f,cnst"+c+");}"}},a[b.LDC_W]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d,e,f,g){var h=e.readUInt16BE(f+1),i=makeOnError(g,f);return"\nvar cnst"+c+"=f.method.cls.constantPool.get("+h+");\nif(cnst"+c+".isResolved()){var "+b[0]+"=cnst"+c+".getConstant(t);"+d+"\n}else{"+i+"u.resolveCPItem(t,f,cnst"+c+");}"}},a[b.LDC2_W]={hasBranch:!1,pops:0,pushes:2,emit:function(a,b,c,d,e,f){var g=e.readUInt16BE(f+1);return"var "+b[0]+"=f.method.cls.constantPool.get("+g+").value,"+b[1]+"=null;"+d}},a[b.GETSTATIC_FAST32]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d,e,f){var g=e.readUInt16BE(f+1);return"var fi"+c+"=f.method.cls.constantPool.get("+g+"),"+b[0]+"=fi"+c+".fieldOwnerConstructor[fi"+c+".fullFieldName];"+d}},a[b.GETSTATIC_FAST64]={hasBranch:!1,pops:0,pushes:2,emit:function(a,b,c,d,e,f){var g=e.readUInt16BE(f+1);return"\nvar fi"+c+"=f.method.cls.constantPool.get("+g+"),"+b[0]+"=fi"+c+".fieldOwnerConstructor[fi"+c+".fullFieldName],\n"+b[1]+"=null;"+d}},a[b.GETFIELD_FAST32]={hasBranch:!1,pops:1,pushes:1,emit:function(a,b,c,d,e,f,g,h){var i=makeOnError(g,f),j=e.readUInt16BE(f+1),k=h.cls.constantPool.get(j),l=k.fullFieldName.replace(escapeStringRegEx,"\\\\");return"if(!u.isNull(t,f,"+a[0]+")){var "+b[0]+"="+a[0]+"['"+l+"'];"+d+"}else{"+i+"}"}},a[b.GETFIELD_FAST64]={hasBranch:!1,pops:1,pushes:2,emit:function(a,b,c,d,e,f,g,h){var i=makeOnError(g,f),j=e.readUInt16BE(f+1),k=h.cls.constantPool.get(j),l=k.fullFieldName.replace(escapeStringRegEx,"\\\\");return"if(!u.isNull(t,f,"+a[0]+")){var "+b[0]+"="+a[0]+"['"+l+"'],"+b[1]+"=null;"+d+"}else{"+i+"}"}},a[b.PUTFIELD_FAST32]={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d,e,f,g,h){var i=makeOnError(g,f),j=e.readUInt16BE(f+1),k=h.cls.constantPool.get(j),l=k.fullFieldName.replace(escapeStringRegEx,"\\\\");return"if(!u.isNull(t,f,"+a[1]+")){"+a[1]+"['"+l+"']="+a[0]+";"+d+"}else{"+i+"}"}},a[b.PUTFIELD_FAST64]={hasBranch:!1,pops:3,pushes:0,emit:function(a,b,c,d,e,f,g,h){var i=makeOnError(g,f),j=e.readUInt16BE(f+1),k=h.cls.constantPool.get(j),l=k.fullFieldName.replace(escapeStringRegEx,"\\\\");return"if(!u.isNull(t,f,"+a[2]+")){"+a[2]+"['"+l+"']="+a[1]+";"+d+"}else{"+i+"}"}},a[b.INSTANCEOF_FAST]={hasBranch:!1,pops:1,pushes:1,emit:function(a,b,c,d,e,f){var g=e.readUInt16BE(f+1);return"var cls"+c+"=f.method.cls.constantPool.get("+g+").cls,"+b[0]+"="+a[0]+"!==null?("+a[0]+".getClass().isCastable(cls"+c+")?1:0):0;"+d}},a[b.CHECKCAST_FAST]={hasBranch:!1,pops:1,pushes:1,emit:function(a,b,c,d,e,f,g,h){var i=e.readUInt16BE(f+1),j=h.cls.constantPool.get(i),k=j.cls.getExternalName();return"var cls"+c+"=f.method.cls.constantPool.get("+i+").cls;\nif(("+a[0]+"!=null)&&!"+a[0]+".getClass().isCastable(cls"+c+")){\nu.throwException(t,f,'Ljava/lang/ClassCastException;',"+a[0]+".getClass().getExternalName()+' cannot be cast to "+k+"');\n}else{var "+b[0]+"="+a[0]+";"+d+"}"}},a[b.ARRAYLENGTH]={hasBranch:!1,pops:1,pushes:1,emit:function(a,b,c,d,e,f,g){var h=makeOnError(g,f);return"if(!u.isNull(t,f,"+a[0]+")){var "+b[0]+"="+a[0]+".array.length;"+d+"}else{"+h+"}"}};var A={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d,e,f){var g=e.readUInt8(f+1);return"var "+b[0]+"=f.locals["+g+"];"+d}};a[b.ILOAD]=A,a[b.ALOAD]=A,a[b.FLOAD]=A;var B={hasBranch:!1,pops:0,pushes:2,emit:function(a,b,c,d,e,f){var g=e.readUInt8(f+1);return"var "+b[0]+"=f.locals["+g+"],"+b[1]+"=null;"+d}};a[b.LLOAD]=B,a[b.DLOAD]=B;var C={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d,e,f){var g=e.readUInt8(f+1);return"f.locals["+g+"]="+a[0]+";"+d}};a[b.ISTORE]=C,a[b.ASTORE]=C,a[b.FSTORE]=C,a[b.BIPUSH]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d,e,f){var g=e.readInt8(f+1);return"var "+b[0]+"="+g+";"+d}},a[b.SIPUSH]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d,e,f){var g=e.readInt16BE(f+1);return"var "+b[0]+"="+g+";"+d}},a[b.IINC]={hasBranch:!1,pops:0,pushes:0,emit:function(a,b,c,d,e,f){var g=e.readUInt8(f+1),h=e.readInt8(f+2);return"f.locals["+g+"]=(f.locals["+g+"]+"+h+")|0;"+d}},a[b.ATHROW]={hasBranch:!0,pops:1,pushes:0,emit:function(a,b,c,d,e,f,g){var h=makeOnError(g,f);return h+"t.throwException("+a[0]+");f.returnToThreadLoop=true;"}},a[b.GOTO]={hasBranch:!0,pops:0,pushes:0,emit:function(a,b,c,d,e,f){var g=e.readInt16BE(f+1);return"f.pc="+(f+g)+";"+d}},a[b.TABLESWITCH]={hasBranch:!0,pops:1,pushes:0,emit:function(a,b,c,d,e,f){var g=f+(4-(f+1)%4)%4+1,h=e.readInt32BE(g),i=e.readInt32BE(g+4),j=e.readInt32BE(g+8);if(8>j-i){for(var k="switch("+a[0]+"){",l=i;j>=l;l++){var m=e.readInt32BE(g+12+4*(l-i));k+="case "+l+":f.pc="+(f+m)+";break;"}return k+="default:f.pc="+(f+h)+"}"+d}return"if("+a[0]+">="+i+"&&"+a[0]+"<="+j+"){f.pc="+f+"+f.method.getCodeAttribute().getCode().readInt32BE("+(g+12)+"+(("+a[0]+"-"+i+")*4))}else{f.pc="+(f+h)+"}"+d}};var D={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[0]+"==="+a[1]+"){"+i+"}else{"+d+"}"}};a[b.IF_ICMPEQ]=D,a[b.IF_ACMPEQ]=D;var E={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[0]+"!=="+a[1]+"){"+i+"}else{"+d+"}"}};a[b.IF_ICMPNE]=E,a[b.IF_ACMPNE]=E,a[b.IF_ICMPGE]={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[1]+">="+a[0]+"){"+i+"}else{"+d+"}"}},a[b.IF_ICMPGT]={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[1]+">"+a[0]+"){"+i+"}else{"+d+"}"}},a[b.IF_ICMPLE]={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[1]+"<="+a[0]+"){"+i+"}else{"+d+"}"}},a[b.IF_ICMPLT]={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[1]+"<"+a[0]+"){"+i+"}else{"+d+"}"}},a[b.IFNULL]={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[0]+"==null){"+i+"}else{"+d+"}"}},a[b.IFNONNULL]={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[0]+"!=null){"+i+"}else{"+d+"}"}},a[b.IFEQ]={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[0]+"===0){"+i+"}else{"+d+"}"}},a[b.IFNE]={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[0]+"!==0){"+i+"}else{"+d+"}"}},a[b.IFGT]={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[0]+">0){"+i+"}else{"+d+"}"}},a[b.IFLT]={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[0]+"<0){"+i+"}else{"+d+"}"}},a[b.IFGE]={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[0]+">=0){"+i+"}else{"+d+"}"}},a[b.IFLE]={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d,e,f,g){var h=e.readInt16BE(f+1),i=makeOnError(g,f+h);return"if("+a[0]+"<=0){"+i+"}else{"+d+"}"}},a[b.LCMP]={hasBranch:!1,pops:4,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"="+a[3]+".compare("+a[1]+");"+d}},a[b.FCMPL]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"="+a[0]+"==="+a[1]+"?0:("+a[1]+">"+a[0]+"?1:-1);"+d}},a[b.DCMPL]={hasBranch:!1,pops:4,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"="+a[3]+"==="+a[1]+"?0:("+a[3]+">"+a[1]+"?1:-1);"+d}},a[b.FCMPG]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"="+a[0]+"==="+a[1]+"?0:("+a[1]+"<"+a[0]+"?-1:1);"+d}},a[b.DCMPG]={hasBranch:!1,pops:4,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"="+a[3]+"==="+a[1]+"?0:("+a[3]+"<"+a[1]+"?-1:1);"+d}},a[b.RETURN]={hasBranch:!0,pops:0,pushes:0,emit:function(a,b,c,d,e,f,g,h){return h.accessFlags.isSynchronized()?"f.pc="+f+";f.returnToThreadLoop=true;if(!f.method.methodLock(t,f).exit(t)){return}t.asyncReturn();":"f.pc="+f+";f.returnToThreadLoop=true;t.asyncReturn();"}};var F={hasBranch:!0,pops:1,pushes:0,emit:function(a,b,c,d,e,f,g,h){return h.accessFlags.isSynchronized()?"f.pc="+f+";f.returnToThreadLoop=true;if(!f.method.methodLock(t,f).exit(t)){return}t.asyncReturn("+a[0]+");":"f.pc="+f+";f.returnToThreadLoop=true;t.asyncReturn("+a[0]+");"}};a[b.IRETURN]=F,a[b.FRETURN]=F,a[b.ARETURN]=F;var G={hasBranch:!0,pops:2,pushes:0,emit:function(a,b,c,d,e,f,g,h){return h.accessFlags.isSynchronized()?"f.pc="+f+";f.returnToThreadLoop=true;if(!f.method.methodLock(t,f).exit(t)){return}t.asyncReturn("+a[1]+",null);":"f.pc="+f+";f.returnToThreadLoop=true;t.asyncReturn("+a[1]+",null);"}};return a[b.LRETURN]=G,a[b.DRETURN]=G,a[b.MONITOREXIT]={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d,e,f,g){var h=makeOnError(g,f);return"if("+a[0]+".getMonitor().exit(t)){"+d+"}else{"+h+"f.returnToThreadLoop=true;}"}},a[b.IXOR]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"="+a[0]+"^"+a[1]+";"+d}},a[b.LXOR]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[1]+".xor("+a[3]+"),"+b[1]+"=null;"+d}},a[b.IOR]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"="+a[0]+"|"+a[1]+";"+d}},a[b.LOR]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[3]+".or("+a[1]+"),"+b[1]+"=null;"+d}},a[b.IAND]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"="+a[0]+"&"+a[1]+";"+d}},a[b.LAND]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[3]+".and("+a[1]+"),"+b[1]+"=null;"+d}},a[b.IADD]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=("+a[0]+"+"+a[1]+")|0;"+d}},a[b.LADD]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[1]+".add("+a[3]+"),"+b[1]+"=null;"+d}},a[b.DADD]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[1]+"+"+a[3]+","+b[1]+"=null;"+d}},a[b.IMUL]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=Math.imul("+a[0]+", "+a[1]+");"+d}},a[b.FMUL]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=u.wrapFloat("+a[0]+"*"+a[1]+");"+d}},a[b.LMUL]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[3]+".multiply("+a[1]+"),"+b[1]+"= null;"+d}},a[b.DMUL]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[3]+"*"+a[1]+","+b[1]+"=null;"+d}},a[b.IDIV]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d,e,f,g){var h=makeOnError(g,f);return"\nif("+a[0]+"===0){"+h+"u.throwException(t,f,'Ljava/lang/ArithmeticException;','/ by zero');\n}else{var "+b[0]+"=("+a[1]+"===u.Constants.INT_MIN&&"+a[0]+"===-1)?"+a[1]+":(("+a[1]+"/"+a[0]+")|0);"+d+"}"}},a[b.LDIV]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d,e,f,g){var h=makeOnError(g,f);return"\nif("+a[1]+".isZero()){"+h+"u.throwException(t,f,'Ljava/lang/ArithmeticException;','/ by zero');\n}else{var "+b[0]+"="+a[3]+".div("+a[1]+"),"+b[1]+"=null;"+d+"}"}},a[b.DDIV]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[3]+"/"+a[1]+","+b[1]+"=null;"+d}},a[b.ISUB]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=("+a[1]+"-"+a[0]+")|0;"+d}},a[b.LSUB]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[1]+".negate().add("+a[3]+"),"+b[1]+"= null;"+d}},a[b.DSUB]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[3]+"-"+a[1]+","+b[1]+"=null;"+d}},a[b.IREM]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d,e,f,g){var h=makeOnError(g,f);return"if("+a[0]+"===0){"+h+"u.throwException(t,f,'Ljava/lang/ArithmeticException;','/ by zero');\n}else{var "+b[0]+"="+a[1]+"%"+a[0]+";"+d+"}"}},a[b.LREM]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d,e,f,g){var h=makeOnError(g,f);return"if("+a[1]+".isZero()){"+h+"u.throwException(t,f,'Ljava/lang/ArithmeticException;','/ by zero');\n}else{var "+b[0]+"="+a[3]+".modulo("+a[1]+"),"+b[1]+"=null;"+d+"}"}},a[b.DREM]={hasBranch:!1,pops:4,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[3]+"%"+a[1]+","+b[1]+"=null;"+d}},a[b.INEG]={hasBranch:!1,pops:1,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=(-"+a[0]+")|0;"+d}},a[b.LNEG]={hasBranch:!1,pops:2,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[1]+".negate(),"+b[1]+"=null;"+d}},a[b.ISHL]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"="+a[1]+"<<"+a[0]+";"+d}},a[b.LSHL]={hasBranch:!1,pops:3,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[2]+".shiftLeft(u.gLong.fromInt("+a[0]+")),"+b[1]+"=null;"+d}},a[b.ISHR]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"="+a[1]+">>"+a[0]+";"+d}},a[b.LSHR]={hasBranch:!1,pops:3,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[2]+".shiftRight(u.gLong.fromInt("+a[0]+")),"+b[1]+"=null;"+d}},a[b.IUSHR]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=("+a[1]+">>>"+a[0]+")|0;"+d}},a[b.LUSHR]={hasBranch:!1,pops:3,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[2]+".shiftRightUnsigned(u.gLong.fromInt("+a[0]+")),"+b[1]+"=null;"+d}},a[b.I2B]={hasBranch:!1,pops:1,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=("+a[0]+"<<24)>>24;"+d}},a[b.I2S]={hasBranch:!1,pops:1,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=("+a[0]+"<<16)>>16;"+d}},a[b.I2C]={hasBranch:!1,pops:1,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"="+a[0]+"&0xFFFF;"+d}},a[b.I2L]={hasBranch:!1,pops:1,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"=u.gLong.fromInt("+a[0]+"),"+b[1]+"=null;"+d}},a[b.I2F]={hasBranch:!1,pops:0,pushes:0,emit:function(a,b,c,d){return""+d}},a[b.I2D]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=null;"+d}},a[b.F2I]={hasBranch:!1,pops:1,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=u.float2int("+a[0]+");"+d}},a[b.F2D]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=null;"+d}},a[b.L2I]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"="+a[1]+".toInt();"+d}},a[b.L2D]={hasBranch:!1,pops:2,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[1]+".toNumber(),"+b[1]+"=null;"+d}},a[b.D2I]={hasBranch:!1,pops:2,pushes:1,emit:function(a,b,c,d){return"var "+b[0]+"=u.float2int("+a[1]+");"+d}},a[b.DUP]={hasBranch:!1,pops:1,pushes:2,emit:function(a,b,c,d){return"var "+b[0]+"="+a[0]+","+b[1]+"="+a[0]+";"+d}},a[b.DUP2]={hasBranch:!1,pops:2,pushes:4,emit:function(a,b,c,d){return"var "+b[0]+"="+a[1]+","+b[1]+"="+a[0]+","+b[2]+"="+a[1]+","+b[3]+"="+a[0]+";"+d}},a[b.DUP_X1]={hasBranch:!1,pops:2,pushes:3,emit:function(a,b,c,d){return"var "+b[0]+"="+a[0]+","+b[1]+"="+a[1]+","+b[2]+"="+a[0]+";"+d}},a[b.DUP_X2]={hasBranch:!1,pops:3,pushes:4,emit:function(a,b,c,d){return"var "+b[0]+"="+a[0]+","+b[1]+"="+a[2]+","+b[2]+"="+a[1]+","+b[3]+"="+a[0]+";"+d}},a[b.DUP2_X1]={hasBranch:!1,pops:3,pushes:5,emit:function(a,b,c,d){return"var "+b[0]+"="+a[1]+","+b[1]+"="+a[0]+","+b[2]+"="+a[2]+","+b[3]+"="+a[1]+","+b[4]+"="+a[0]+";"+d}},a[b.NEW_FAST]={hasBranch:!1,pops:0,pushes:1,emit:function(a,b,c,d,e,f){var g=e.readUInt16BE(f+1);return"var cr"+c+"=f.method.cls.constantPool.get("+g+"),"+b[0]+"=(new cr"+c+".clsConstructor(t));"+d}},a[b.NEWARRAY]={hasBranch:!1,pops:1,pushes:1,emit:function(a,b,c,d,e,f,g){var h=e.readUInt8(f+1),i="["+opcodes.ArrayTypes[h],j=makeOnError(g,f);return"\nvar cls"+c+"=f.getLoader().getInitializedClass(t,'"+i+"');\nif("+a[0]+">=0){var "+b[0]+"=new (cls"+c+".getConstructor(t))(t,"+a[0]+");"+d+"\n}else{"+j+"u.throwException(t,f,'Ljava/lang/NegativeArraySizeException;','Tried to init "+i+" array with length '+"+a[0]+");}"}},a[b.ANEWARRAY_FAST]={hasBranch:!1,pops:1,pushes:1,emit:function(a,b,c,d,e,f,g){var h=e.readUInt16BE(f+1),i=("["+opcodes.ArrayTypes[h],makeOnError(g,f));return"\nvar cr"+c+"=f.method.cls.constantPool.get("+h+");\nif("+a[0]+">=0){var "+b[0]+"=new cr"+c+".arrayClassConstructor(t,"+a[0]+");"+d+"\n}else{"+i+"u.throwException(t,f,'Ljava/lang/NegativeArraySizeException;','Tried to init '+cr"+c+".arrayClass.getInternalName()+' array with length '+"+a[0]+");}"}},a[b.NOP]={hasBranch:!1,pops:0,pushes:0,emit:function(a,b,c,d){return""+d}},a[b.POP]={hasBranch:!1,pops:1,pushes:0,emit:function(a,b,c,d){return""+d}},a[b.POP2]={hasBranch:!1,pops:2,pushes:0,emit:function(a,b,c,d){return""+d}},a}();


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var __extends=this&&this.__extends||function(a,b){function c(){this.constructor=a}for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d]);a.prototype=null===b?Object.create(b):(c.prototype=b.prototype,new c)},ClassData_1=__webpack_require__(21),ClassLock=__webpack_require__(24),classpath_1=__webpack_require__(26),enums_1=__webpack_require__(9),util=__webpack_require__(6),logging=__webpack_require__(17),assert=__webpack_require__(13),debug=logging.debug,ClassLocks=function(){function a(){this.locks={}}return a.prototype.tryLock=function(a,b,c){return"undefined"==typeof this.locks[a]&&(this.locks[a]=new ClassLock),this.locks[a].tryLock(b,c)},a.prototype.unlock=function(a,b){this.locks[a].unlock(b),delete this.locks[a]},a.prototype.getOwner=function(a){return this.locks[a]?this.locks[a].getOwner():null},a}(),ClassLoader=function(){function a(a){this.bootstrap=a,this.loadedClasses={},this.loadClassLocks=new ClassLocks}return a.prototype.getLoadedClassNames=function(){return Object.keys(this.loadedClasses)},a.prototype.addClass=function(a,b){this.loadedClasses[a]=b},a.prototype.getClass=function(a){return this.loadedClasses[a]},a.prototype.defineClass=function(a,b,c,d){try{var e=new ClassData_1.ReferenceClassData(c,d,this);return this.addClass(b,e),e}catch(f){return null===a?(logging.error("JVM initialization failed: "+f),logging.error(f.stack)):a.throwNewException("Ljava/lang/ClassFormatError;",f),null}},a.prototype.defineArrayClass=function(a){var b=new ClassData_1.ArrayClassData(util.get_component_type(a),this);return this.addClass(a,b),b},a.prototype.getLoadedClass=function(a){var b=this.loadedClasses[a];if(null!=b)return b;if(util.is_primitive_type(a))return this.bootstrap.getPrimitiveClass(a);if(util.is_array_type(a)){var c=this.getLoadedClass(util.get_component_type(a));if(null!=c){var d=c.getLoader();return d===this?this.defineArrayClass(a):(b=d.getLoadedClass(a),this.addClass(a,b),b)}}return null},a.prototype.getResolvedClass=function(a){var b=this.getLoadedClass(a);return null!==b&&(b.isResolved()||b.tryToResolve())?b:null},a.prototype.getInitializedClass=function(a,b){var c=this.getLoadedClass(b);return null!==c?c.isInitialized(a)||c.tryToInitialize()?c:null:c},a.prototype.loadClass=function(a,b,c,d){var e=this;void 0===d&&(d=!0);var f=this.getLoadedClass(b);f?setImmediate(function(){c(f)}):this.loadClassLocks.tryLock(b,a,c)&&(util.is_reference_type(b)?this._loadClass(a,b,function(a){e.loadClassLocks.unlock(b,a)},d):this.loadClass(a,util.get_component_type(b),function(a){null!=a&&e.loadClassLocks.unlock(b,e.getLoadedClass(b))},d))},a.prototype.resolveClasses=function(a,b,c){var d=this,e={};util.asyncForEach(b,function(b,c){d.resolveClass(a,b,function(a){null===a?c("Error resolving class: "+b):(e[b]=a,c())})},function(a){c(a?null:e)})},a.prototype.resolveClass=function(a,b,c,d){void 0===d&&(d=!0),this.loadClass(a,b,function(b){null===b||b.isResolved()?setImmediate(function(){c(b)}):b.resolve(a,c,d)},d)},a.prototype.initializeClass=function(a,b,c,d){void 0===d&&(d=!0),this.resolveClass(a,b,function(b){null===b||b.isInitialized(a)?setImmediate(function(){c(b)}):b.initialize(a,c,d)},d)},a.prototype.throwClassNotFoundException=function(a,b,c){a.throwNewException(c?"Ljava/lang/ClassNotFoundException;":"Ljava/lang/NoClassDefFoundError;","Cannot load class: "+util.ext_classname(b))},a}();exports.ClassLoader=ClassLoader;var BootstrapClassLoader=function(a){function b(b,c,d){var e=this;a.call(this,null),this.bootstrap=this,this.classpath=null,this.loadedPackages={},classpath_1.ClasspathFactory(b,c,function(a){e.classpath=a.reverse(),d()})}return __extends(b,a),b.prototype._registerLoadedClass=function(a,b){var c=a.slice(0,a.lastIndexOf("/")),d=this.loadedPackages[c];d?d[0]!==b&&-1===d.indexOf(b)&&d.push(b):this.loadedPackages[c]=[b]},b.prototype.getPackages=function(){var a=this;return Object.keys(this.loadedPackages).map(function(b){return[b,a.loadedPackages[b].map(function(a){return a.getPath()})]})},b.prototype.getPrimitiveClass=function(a){var b=this.getClass(a);return null==b&&(b=new ClassData_1.PrimitiveClassData(a,this),this.addClass(a,b)),b},b.prototype._loadClass=function(a,b,c,d){var e=this;void 0===d&&(d=!0);var f,g=util.descriptor2typestr(b),h=this.classpath.length,i=[];a:for(var j=0;h>j;j++){var k=this.classpath[j];switch(k.hasClass(g)){case enums_1.TriState.INDETERMINATE:i.push(k);break;case enums_1.TriState.TRUE:i.push(k);break a}}util.asyncFind(i,function(a,b){a.loadClass(g,function(a,c){a?b(!1):(f=c,b(!0))})},function(h){if(h){var i=e.defineClass(a,b,f,null);null!==i&&e._registerLoadedClass(g,h),c(i)}else e.throwClassNotFoundException(a,b,d),c(null)})},b.prototype.getLoadedClassFiles=function(){var a=this.getLoadedClassNames();return a.filter(function(a){return util.is_reference_type(a)})},b.prototype.getLoaderObject=function(){return null},b.prototype.getClassPath=function(){for(var a=this.classpath.length,b=new Array(a),c=0;a>c;c++)b[c]=this.classpath[a-c-1].getPath();return b},b.prototype.getClassPathItems=function(){return this.classpath.slice(0)},b}(ClassLoader);exports.BootstrapClassLoader=BootstrapClassLoader;var CustomClassLoader=function(a){function b(b,c){a.call(this,b),this.loaderObj=c}return __extends(b,a),b.prototype._loadClass=function(a,b,c,d){var e=this;void 0===d&&(d=!0),this.loaderObj["loadClass(Ljava/lang/String;)Ljava/lang/Class;"](a,[util.initString(this.bootstrap,util.ext_classname(b))],function(f,g){if(f)e.throwClassNotFoundException(a,b,d),c(null);else{var h=g.$cls;e.addClass(b,h),c(h)}})},b.prototype.getLoaderObject=function(){return this.loaderObj},b}(ClassLoader);exports.CustomClassLoader=CustomClassLoader;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function getRef(){return ref++}function extendClass(a,b){function c(){this.constructor=a}c.prototype=b.prototype,a.prototype=new c}var __extends=this&&this.__extends||function(a,b){function c(){this.constructor=a}for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d]);a.prototype=null===b?Object.create(b):(c.prototype=b.prototype,new c)},util=__webpack_require__(6),ByteStream=__webpack_require__(22),ConstantPool=__webpack_require__(23),attributes=__webpack_require__(12),threading_1=__webpack_require__(15),logging=__webpack_require__(17),methods=__webpack_require__(11),enums=__webpack_require__(9),ClassLock=__webpack_require__(24),assert=__webpack_require__(13),gLong=__webpack_require__(8),StringOutputStream=__webpack_require__(18),ClassState=enums.ClassState,trace=logging.trace,debug=logging.debug,global=__webpack_require__(14),ref=1,injectedFields={"Ljava/lang/invoke/MemberName;":{vmtarget:["(thread: JVMThread, descriptor: string, args: any[], cb?: (e?: JVMTypes.java_lang_Throwable, rv?: any) => void) => void","null"],vmindex:["number","-1"]},"Ljava/lang/Object;":{ref:["number","getRef()"],$monitor:["Monitor","null"]},"Ljava/net/PlainSocketImpl;":{$is_shutdown:["boolean","false"],$ws:["Interfaces.IWebsock","null"]},"Ljava/io/FileDescriptor;":{$pos:["number","-1"]},"Ljava/lang/Class;":{$cls:["ClassData","null"]},"Ljava/lang/ClassLoader;":{$loader:["ClassLoader","new ClassLoader.CustomClassLoader(thread.getBsCl(), this);"]},"Ljava/lang/Thread;":{$thread:["JVMThread","thread ? new thread.constructor(thread.getJVM(), thread.getThreadPool(), this) : null"]}},injectedMethods={"Ljava/lang/Object;":{getClass:["(): ClassData","function() { return this.constructor.cls }"],getMonitor:["(): Monitor","function() {\n  if (this.$monitor === null) {\n    this.$monitor = new Monitor();\n  }\n  return this.$monitor;\n}"]},"Ljava/lang/String;":{toString:["(): string","function() { return util.chars2jsStr(this['java/lang/String/value']); }"]},"Ljava/lang/Byte;":{unbox:["(): number","function() { return this['java/lang/Byte/value']; }"]},"Ljava/lang/Character;":{unbox:["(): number","function() { return this['java/lang/Character/value']; }"]},"Ljava/lang/Double;":{unbox:["(): number","function() { return this['java/lang/Double/value']; }"]},"Ljava/lang/Float;":{unbox:["(): number","function() { return this['java/lang/Float/value']; }"]},"Ljava/lang/Integer;":{unbox:["(): number","function() { return this['java/lang/Integer/value']; }"]},"Ljava/lang/Long;":{unbox:["(): Long","function() { return this['java/lang/Long/value']; }"]},"Ljava/lang/Short;":{unbox:["(): number","function() { return this['java/lang/Short/value']; }"]},"Ljava/lang/Boolean;":{unbox:["(): number","function() { return this['java/lang/Boolean/value']; }"]},"Ljava/lang/Void;":{unbox:["(): number",'function() { throw new Error("Cannot unbox a Void type."); }']},"Ljava/lang/invoke/MethodType;":{toString:["(): string",'function() { return "(" + this[\'java/lang/invoke/MethodType/ptypes\'].array.map(function (type) { return type.$cls.getInternalName(); }).join("") + ")" + this[\'java/lang/invoke/MethodType/rtype\'].$cls.getInternalName(); }']}},injectedStaticMethods={"Ljava/lang/Byte;":{box:["(val: number): java_lang_Byte","function(val) { var rv = new this(null); rv['java/lang/Byte/value'] = val; return rv; }"]},"Ljava/lang/Character;":{box:["(val: number): java_lang_Character","function(val) { var rv = new this(null); rv['java/lang/Character/value'] = val; return rv; }"]},"Ljava/lang/Double;":{box:["(val: number): java_lang_Double","function(val) { var rv = new this(null); rv['java/lang/Double/value'] = val; return rv; }"]},"Ljava/lang/Float;":{box:["(val: number): java_lang_Float","function(val) { var rv = new this(null); rv['java/lang/Float/value'] = val; return rv; }"]},"Ljava/lang/Integer;":{box:["(val: number): java_lang_Integer","function(val) { var rv = new this(null); rv['java/lang/Integer/value'] = val; return rv; }"]},"Ljava/lang/Long;":{box:["(val: Long): java_lang_Long","function(val) { var rv = new this(null); rv['java/lang/Long/value'] = val; return rv; }"]},"Ljava/lang/Short;":{box:["(val: number): java_lang_Short","function(val) { var rv = new this(null); rv['java/lang/Short/value'] = val; return rv; }"]},"Ljava/lang/Boolean;":{box:["(val: number): java_lang_Boolean","function(val) { var rv = new this(null); rv['java/lang/Boolean/value'] = val; return rv; }"]},"Ljava/lang/Void;":{box:["(): java_lang_Void","function() { return new this(null); }"]}},ClassData=function(){function a(a){this.accessFlags=null,this.state=enums.ClassState.LOADED,this.jco=null,this.superClass=null,this.loader=a}return a.prototype.getExternalName=function(){return util.ext_classname(this.className)},a.prototype.getInternalName=function(){return this.className},a.prototype.getPackageName=function(){var a,b=this.getExternalName();for(a=b.length-1;a>=0&&"."!==b[a];a--);return a>=0?b.slice(0,a):""},a.prototype.getLoader=function(){return this.loader},a.prototype.getSuperClass=function(){return this.superClass},a.prototype.getInterfaces=function(){return[]},a.prototype.getInjectedFields=function(){var a={};if(void 0!==injectedFields[this.getInternalName()]){var b=injectedFields[this.getInternalName()];Object.keys(b).forEach(function(c){a[c]=b[c][0]})}return a},a.prototype.getInjectedMethods=function(){var a={},b=this.getInternalName();if("["===b[0]&&(b="["),void 0!==injectedMethods[b]){var c=injectedMethods[b];Object.keys(c).forEach(function(b){a[b]=c[b][0]})}return a},a.prototype.getInjectedStaticMethods=function(){var a={},b=this.getInternalName();if("["===b[0]&&(b="["),void 0!==injectedStaticMethods[b]){var c=injectedStaticMethods[b];Object.keys(c).forEach(function(b){a[b]=c[b][0]})}return a},a.prototype.getClassObject=function(a){return null===this.jco&&(this.jco=new(a.getBsCl().getResolvedClass("Ljava/lang/Class;").getConstructor(a))(a),this.jco.$cls=this,this.jco["java/lang/Class/classLoader"]=this.getLoader().getLoaderObject()),this.jco},a.prototype.getProtectionDomain=function(){return null},a.prototype.getMethod=function(a){return null},a.prototype.getMethods=function(){return[]},a.prototype.getFields=function(){return[]},a.prototype.setState=function(a){this.state=a},a.prototype.getState=function(){if(this.state===ClassState.RESOLVED&&null===this.getMethod("<clinit>()V")){var a=this.getSuperClass();null!==a&&a.getState()===ClassState.INITIALIZED&&(this.state=ClassState.INITIALIZED)}return this.state},a.prototype.isInitialized=function(a){return this.getState()===ClassState.INITIALIZED},a.prototype.isResolved=function(){return this.getState()!==ClassState.LOADED},a.prototype.isSubinterface=function(a){return!1},a.prototype.isSubclass=function(a){return this===a?!0:null===this.getSuperClass()?!1:this.getSuperClass().isSubclass(a)},a.prototype.resolve=function(a,b,c){throw void 0===c&&(c=!0),new Error("Unimplemented.")},a.prototype.initialize=function(a,b,c){throw void 0===c&&(c=!0),new Error("Unimplemented.")},a.prototype.outputInjectedMethods=function(a,b){var c=this.getInternalName();if("["===c[0]&&(c="["),void 0!==injectedMethods[c]){var d=injectedMethods[c];Object.keys(d).forEach(function(c){b.write("  "+a+".prototype."+c+" = "+d[c][1]+";\n")})}if(void 0!==injectedStaticMethods[c]){var e=injectedStaticMethods[c];Object.keys(e).forEach(function(c){b.write("  "+a+"."+c+" = "+e[c][1]+";\n")})}},a}();exports.ClassData=ClassData;var PrimitiveClassData=function(a){function b(b,c){a.call(this,c),this.className=b,this.accessFlags=new util.Flags(1041),this.setState(ClassState.INITIALIZED)}return __extends(b,a),b.prototype.isCastable=function(a){return this.className===a.getInternalName()},b.prototype.boxClassName=function(){return util.boxClassName(this.className)},b.prototype.createWrapperObject=function(a,b){var c=this.boxClassName(),d=a.getBsCl().getInitializedClass(a,c),e=d.getConstructor(a),f=new e(a);return"V"!==c&&(f[util.descriptor2typestr(c)+"/value"]=b),f},b.prototype.tryToResolve=function(){return!0},b.prototype.tryToInitialize=function(){return!0},b.prototype.resolve=function(a,b,c){var d=this;void 0===c&&(c=!0),setImmediate(function(){return b(d)})},b}(ClassData);exports.PrimitiveClassData=PrimitiveClassData;var ArrayClassData=function(a){function b(b,c){a.call(this,c),this._constructor=null,this.className="["+b,this.accessFlags=new util.Flags(1041),this.componentClassName=b}return __extends(b,a),b.prototype.methodLookup=function(a){return this.superClass.methodLookup(a)},b.prototype.fieldLookup=function(a){return this.superClass.fieldLookup(a)},b.prototype.resolve=function(a,b,c){var d=this;return void 0===c&&(c=!0),this.isResolved()?void setImmediate(function(){return b(d)}):void util.asyncForEach(["Ljava/lang/Object;",this.componentClassName],function(b,c){d.loader.resolveClass(a,b,function(a){null!==a?c():c("Failed.")})},function(a){a?b(null):(d.setResolved(d.loader.getResolvedClass("Ljava/lang/Object;"),d.loader.getResolvedClass(d.componentClassName)),b(d))})},b.prototype.getComponentClass=function(){return this.componentClass},b.prototype.setResolved=function(a,b){this.superClass=a,this.componentClass=b,this.setState(ClassState.INITIALIZED)},b.prototype.tryToResolve=function(){var a=this.loader,b=a.getResolvedClass("Ljava/lang/Object;"),c=a.getResolvedClass(this.componentClassName);return null===b||null===c?!1:(this.setResolved(b,c),!0)},b.prototype.tryToInitialize=function(){return this.tryToResolve()},b.prototype.isCastable=function(a){if(!(a instanceof b)){if(a instanceof PrimitiveClassData)return!1;if(a.accessFlags.isInterface()){var c=a.getInternalName();return"Ljava/lang/Cloneable;"===c||"Ljava/io/Serializable;"===c}return"Ljava/lang/Object;"===a.getInternalName()}return this.getComponentClass().isCastable(a.getComponentClass())},b.prototype.initialize=function(a,b,c){void 0===c&&(c=!0),this.resolve(a,b,c)},b.prototype.getJSArrayConstructor=function(){if(!util.typedArraysSupported)return"Array";switch(this.componentClassName){case"B":return"Int8Array";case"C":return"Uint16Array";case"S":return"Int16Array";case"I":return"Int32Array";case"F":return"Float32Array";case"D":return"Float64Array";default:return"Array"}},b.prototype.getJSDefaultArrayElement=function(){switch(this.componentClassName[0]){case"[":return"new (cls.getComponentClass().getConstructor())(thread, otherLengths)";case"L":return"null";case"J":return"gLongZero";default:return"0"}},b.prototype._getSliceMethod=function(){var a=new StringOutputStream,b=this.getJSArrayConstructor();if(a.write("function(start, end) {\n    var newObj = new this.constructor(null, 0);\n"),"Array"===b)a.write("    newObj.array = this.array.slice(start, end);\n");else{var c;switch(b){case"Int8Array":c=1;break;case"Int16Array":case"Uint16Array":c=2;break;case"Int32Array":case"Float32Array":c=4;break;case"Float64Array":c=8}a.write("    if (end === undefined) end = this.array.length;\n      "+(c>1?"start *= "+c+";\nend *= "+c+";":"")+"\n      newObj.array = new "+b+"(this.array.buffer.slice(start, end));\n")}return a.write("    return newObj;\n  }"),a.flush()},b.prototype._constructConstructor=function(a){var b=new StringOutputStream,c=util.jvmName2JSName(this.getInternalName());b.write("extendClass("+c+", superCls.getConstructor(thread));\n  function "+c+"(thread, lengths) {\n"),this.superClass.outputInjectedFields(b),"["!==this.componentClassName[0]?(b.write("    this.array = new "+this.getJSArrayConstructor()+"(lengths);\n"),"Array"===this.getJSArrayConstructor()&&b.write("    for (var i = 0; i < lengths; i++) {\n      this.array[i] = "+this.getJSDefaultArrayElement()+";\n    }\n")):b.write("    if (typeof lengths === 'number') {\n        this.array = new "+this.getJSArrayConstructor()+"(lengths);\n        for (var i = 0; i < length; i++) {\n          this.array[i] = null;\n        }\n      } else {\n        var length = lengths[0], otherLengths = lengths.length > 2 ? lengths.slice(1) : lengths[1];\n        this.array = new "+this.getJSArrayConstructor()+"(length);\n        for (var i = 0; i < length; i++) {\n          this.array[i] = "+this.getJSDefaultArrayElement()+";\n        }\n      }\n"),b.write("  }\n\n  "+c+".prototype.slice = "+this._getSliceMethod()+";\n  "+c+".cls = cls;\n"),this.outputInjectedMethods(c,b),b.write("\n  return "+c+";");var d=new Function("extendClass","cls","superCls","gLongZero","thread","getRef","util",b.flush());return d(extendClass,this,this.superClass,gLong.ZERO,a,getRef,util)},b.prototype.getConstructor=function(a){return null===this._constructor&&(this._constructor=this._constructConstructor(a)),this._constructor},b}(ClassData);exports.ArrayClassData=ArrayClassData;var ReferenceClassData=function(a){function b(b,c,d,e){a.call(this,d),this.interfaceClasses=null,this.superClassRef=null,this.initLock=new ClassLock,this._constructor=null,this._fieldLookup={},this._objectFields=[],this._staticFields=[],this._methodLookup={},this._vmTable=[],this._uninheritedDefaultMethods=[],this._protectionDomain=c?c:null;var f=new ByteStream(b),g=0;if(3405691582!==f.getUint32())throw new Error("Magic number invalid");if(this.minorVersion=f.getUint16(),this.majorVersion=f.getUint16(),!(45<=this.majorVersion&&this.majorVersion<=52))throw new Error("Major version invalid");this.constantPool=new ConstantPool.ConstantPool,this.constantPool.parse(f,e),this.accessFlags=new util.Flags(f.getUint16()),this.className=this.constantPool.get(f.getUint16()).name;var h=f.getUint16();0!==h&&(this.superClassRef=this.constantPool.get(h));var i=f.getUint16();for(this.interfaceRefs=new Array(i),g=0;i>g;++g)this.interfaceRefs[g]=this.constantPool.get(f.getUint16());var j=f.getUint16();for(this.fields=new Array(j),g=0;j>g;++g)this.fields[g]=new methods.Field(this,this.constantPool,g,f);var k=f.getUint16();for(this.methods=new Array(k),g=0;k>g;g++){var l=new methods.Method(this,this.constantPool,g,f);this.methods[g]=l}if(this.attrs=attributes.makeAttributes(f,this.constantPool),f.hasBytes())throw"Leftover bytes in classfile: "+f}return __extends(b,a),b.prototype.getSuperClassReference=function(){return this.superClassRef},b.prototype.getInterfaceClassReferences=function(){return this.interfaceRefs.slice(0)},b.prototype.getInterfaces=function(){return this.interfaceClasses},b.prototype.getFields=function(){return this.fields},b.prototype.getVMTable=function(){return this._vmTable},b.prototype.getVMIndexForMethod=function(a){return this._vmTable.indexOf(this.methodLookup(a.signature))},b.prototype.getMethodFromVMIndex=function(a){return void 0!==this._vmTable[a]?this._vmTable[a]:null},b.prototype.getVMIndexForField=function(a){return a.accessFlags.isStatic()?this._staticFields.indexOf(a):this._objectFields.indexOf(a)},b.prototype.getStaticFieldFromVMIndex=function(a){var b=this._staticFields[a];return void 0!==b?b:null},b.prototype.getObjectFieldFromVMIndex=function(a){var b=this._objectFields[a];return void 0!==b?b:null},b.prototype.getFieldFromSlot=function(a){return this.fields[a]},b.prototype.getMethodFromSlot=function(a){return this.methods[a]},b.prototype.getMethod=function(a){var b=this._methodLookup[a];return b.cls===this?b:null},b.prototype.getSpecificMethod=function(a,b){if(this.getInternalName()===a)return this.getMethod(b);var c,d=this.interfaceClasses.slice(0);this.superClass&&d.push(this.superClass);for(var e=0;e<d.length;e++)if(null!==(c=d[e].getSpecificMethod(a,b)))return c;return null},b.prototype.getMethods=function(){return this.methods},b.prototype.getUninheritedDefaultMethods=function(){return this._uninheritedDefaultMethods},b.prototype.getProtectionDomain=function(){return this._protectionDomain},b.prototype._resolveMethods=function(){var a=this;null!==this.superClass&&(this._vmTable=this._vmTable.concat(this.superClass._vmTable),Object.keys(this.superClass._methodLookup).forEach(function(b){a._methodLookup[b]=a.superClass._methodLookup[b]})),this.methods.forEach(function(b){var c=a._methodLookup[b.signature];b.accessFlags.isStatic()||"<init>"===b.name||(void 0===c?a._vmTable.push(b):a._vmTable[a._vmTable.indexOf(c)]=b),a._methodLookup[b.signature]=b}),this.interfaceClasses.forEach(function(b){Object.keys(b._methodLookup).forEach(function(c){var d=b._methodLookup[c];void 0===a._methodLookup[c]?(d.accessFlags.isStatic()||a._vmTable.push(d),a._methodLookup[c]=d):d.isDefault()&&a._uninheritedDefaultMethods.push(d)})})},b.prototype._resolveFields=function(){var a=this;null!==this.superClass&&(this._objectFields=this._objectFields.concat(this.superClass._objectFields),Object.keys(this.superClass._fieldLookup).forEach(function(b){a._fieldLookup[b]=a.superClass._fieldLookup[b]})),this.interfaceClasses.forEach(function(b){Object.keys(b._fieldLookup).forEach(function(c){var d=b._fieldLookup[c];a._fieldLookup[c]=d})}),this.fields.forEach(function(b){a._fieldLookup[b.name]=b,b.accessFlags.isStatic()?a._staticFields.push(b):a._objectFields.push(b)})},b.prototype.methodLookup=function(a){var b=this._methodLookup[a];return void 0!==b?b:null},b.prototype.signaturePolymorphicAwareMethodLookup=function(a){var b;if(null!==(b=this.methodLookup(a)))return b;if("Ljava/lang/invoke/MethodHandle;"===this.className){var c=a.slice(0,a.indexOf("("))+"([Ljava/lang/Object;)Ljava/lang/Object;",b=this._methodLookup[c];if(void 0!==b&&b.accessFlags.isNative()&&b.accessFlags.isVarArgs()&&b.cls===this)return b}else if(null!==this.superClass)return this.superClass.signaturePolymorphicAwareMethodLookup(a);return null},b.prototype.fieldLookup=function(a){var b=this._fieldLookup[a];return void 0!==b?b:null},b.prototype.getAttribute=function(a){for(var b=this.attrs,c=0;c<b.length;c++){var d=b[c];if(d.getName()===a)return d}return null},b.prototype.getAttributes=function(a){for(var b=this.attrs,c=[],d=0;d<b.length;d++){var e=b[d];e.getName()===a&&c.push(e)}return c},b.prototype.getBootstrapMethod=function(a){var b=this.getAttribute("BootstrapMethods");return b.bootstrapMethods[a]},b.prototype._getInitialStaticFieldValue=function(a,b){var c=this.fieldLookup(b);if(null!==c&&c.accessFlags.isStatic()){var d=c.getAttribute("ConstantValue");if(null===d)return util.initialValue(c.rawDescriptor);switch(d.value.getType()){case enums.ConstantPoolItemType.STRING:var e=d.value;return null===e.value&&(e.value=a.getJVM().internString(e.stringValue)),e.value;default:return d.value.value}}},b.prototype.setResolved=function(a,b){this.superClass=a,this.interfaceClasses=b,this._resolveMethods(),this._resolveFields(),this.setState(ClassState.RESOLVED)},b.prototype.tryToResolve=function(){if(this.getState()===ClassState.LOADED){var a,b,c=this.loader,d=null!==this.superClassRef?this.interfaceRefs.concat(this.superClassRef):this.interfaceRefs,e=[];for(a=0;a<d.length;a++){if(b=d[a],!b.tryResolve(c))return!1;e.push(b.cls)}this.setResolved(null!==this.superClassRef?e.pop():null,e)}return!0},b.prototype.tryToInitialize=function(){if(this.getState()===ClassState.INITIALIZED)return!0;if(this.getState()===ClassState.RESOLVED||this.tryToResolve()){if(null!==this.superClass&&!this.superClass.tryToInitialize())return!1;var a=this.getMethod("<clinit>()V");return null!==a?!1:(this.setState(ClassState.INITIALIZED),!0)}return!1},b.prototype.isCastable=function(a){return a instanceof b?this.accessFlags.isInterface()?a.accessFlags.isInterface()?this.isSubinterface(a):a.accessFlags.isInterface()?void 0:"Ljava/lang/Object;"===a.getInternalName():a.accessFlags.isInterface()?this.isSubinterface(a):this.isSubclass(a):!1},b.prototype.isSubinterface=function(a){if(this.className===a.getInternalName())return!0;for(var b=this.getInterfaces(),c=0;c<b.length;c++){var d=b[c];if(d.isSubinterface(a))return!0}return null==this.getSuperClass()?!1:this.getSuperClass().isSubinterface(a)},b.prototype.initialize=function(a,b,c){var d=this;void 0===c&&(c=!0),this.isResolved()?this.isInitialized(a)?setImmediate(function(){b(d)}):this.initLock.tryLock(a,b)&&(null!=this.superClass?this.superClass.initialize(a,function(b){null==b?d.initLock.unlock(null):d._initialize(a,function(a){d.initLock.unlock(a)})},c):this._initialize(a,function(a){d.initLock.unlock(a)})):this.resolve(a,function(e){null!==e?d.initialize(a,b,c):b(e)},c)},b.prototype._initialize=function(a,b){var c=this,d=this.getConstructor(a);void 0!==d["<clinit>()V"]?d["<clinit>()V"](a,null,function(d){d?(c.setState(enums.ClassState.RESOLVED),d.getClass().isCastable(a.getBsCl().getResolvedClass("Ljava/lang/Error;"))?(a.throwException(d),b(null)):a.getBsCl().initializeClass(a,"Ljava/lang/ExceptionInInitializerError;",function(c){if(null==c)b(null);else{var e=c.getConstructor(a),f=new e(a);f["<init>(Ljava/lang/Throwable;)V"](a,[d],function(c){a.throwException(f),b(null)})}})):(c.setState(enums.ClassState.INITIALIZED),b(c))}):(this.setState(enums.ClassState.INITIALIZED),b(this))},b.prototype.isInitialized=function(a){return this.getState()===ClassState.INITIALIZED||this.initLock.getOwner()===a},b.prototype.resolve=function(a,b,c){var d=this;void 0===c&&(c=!0);var e=this.interfaceRefs.slice(0);null!==this.superClassRef&&e.push(this.superClassRef),e=e.filter(function(a){return!a.isResolved()}),util.asyncForEach(e,function(b,e){b.resolve(a,d.loader,d,function(a){a?e():e("Failed.")},c)},function(a){a?b(null):(d.setResolved(null!==d.superClassRef?d.superClassRef.cls:null,d.interfaceRefs.map(function(a){return a.cls})),b(d))})},b.prototype.getMirandaAndDefaultMethods=function(){var a=this,b=null!==this.superClass?this.superClass.getVMTable():[];return this.getVMTable().slice(b.length).filter(function(b){return b.cls!==a})},b.prototype.outputInjectedFields=function(a){null!==this.superClass&&this.superClass.outputInjectedFields(a);var b=injectedFields[this.getInternalName()];void 0!==b&&Object.keys(b).forEach(function(c){a.write("this."+c+" = "+b[c][1]+";\n")})},b.prototype._constructConstructor=function(a){var b=util.jvmName2JSName(this.getInternalName()),c=new StringOutputStream;c.write("if (cls.superClass !== null) {\n    extendClass("+b+", cls.superClass.getConstructor(thread));\n  }\n  function "+b+"(thread) {\n"),this.outputInjectedFields(c),this._objectFields.forEach(function(a){return a.outputJavaScriptField(b,c)}),c.write("  }\n  "+b+".cls = cls;\n"),this.outputInjectedMethods(b,c),this._staticFields.forEach(function(a){return a.outputJavaScriptField(b,c)}),this.getMethods().forEach(function(a){return a.outputJavaScriptFunction(b,c)}),this.getMirandaAndDefaultMethods().forEach(function(a){return a.outputJavaScriptFunction(b,c)}),this.getUninheritedDefaultMethods().forEach(function(a){return a.outputJavaScriptFunction(b,c,!0)}),c.write("  return "+b+";");var d=c.flush(),e=new Function("extendClass","cls","InternalStackFrame","NativeStackFrame","BytecodeStackFrame","gLongZero","ClassLoader","Monitor","thread","getRef","util",d);return e(extendClass,this,threading_1.InternalStackFrame,threading_1.NativeStackFrame,threading_1.BytecodeStackFrame,gLong.ZERO,__webpack_require__(20),__webpack_require__(25),a,getRef,util)},b.prototype.getConstructor=function(a){return null==this._constructor&&(this._constructor=this._constructConstructor(a)),this._constructor},b}(ClassData);exports.ReferenceClassData=ReferenceClassData;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var gLong=__webpack_require__(8),assert=__webpack_require__(13),ByteStream=function(){function a(a){this.buffer=a,this._index=0}return a.prototype.incIndex=function(a){var b=this._index;return this._index+=a,b},a.prototype.rewind=function(){this._index=0},a.prototype.seek=function(a){this._index=a},a.prototype.pos=function(){return this._index},a.prototype.skip=function(a){this._index+=a},a.prototype.hasBytes=function(){return this._index<this.buffer.length},a.prototype.getFloat=function(){return this.buffer.readFloatBE(this.incIndex(4))},a.prototype.getDouble=function(){return this.buffer.readDoubleBE(this.incIndex(8))},a.prototype.getUint=function(a){switch(a){case 1:return this.getUint8();case 2:return this.getUint16();case 4:return this.getUint32();default:throw new Error("Invalid byte count for getUint: "+a)}},a.prototype.getInt=function(a){switch(a){case 1:return this.getInt8();case 2:return this.getInt16();case 4:return this.getInt32();default:throw new Error("Invalid byte count for getUint: "+a)}},a.prototype.getUint8=function(){return this.buffer.readUInt8(this.incIndex(1))},a.prototype.getUint16=function(){return this.buffer.readUInt16BE(this.incIndex(2))},a.prototype.getUint32=function(){return this.buffer.readUInt32BE(this.incIndex(4))},a.prototype.getInt8=function(){return this.buffer.readInt8(this.incIndex(1))},a.prototype.getInt16=function(){return this.buffer.readInt16BE(this.incIndex(2))},a.prototype.getInt32=function(){return this.buffer.readInt32BE(this.incIndex(4))},a.prototype.getInt64=function(){var a=this.getUint32(),b=this.getUint32();return gLong.fromBits(b,a)},a.prototype.read=function(a){var b=this.buffer.slice(this._index,this._index+a);return this._index+=a,b},a.prototype.peek=function(){return this.buffer.readUInt8(this._index)},a.prototype.size=function(){return this.buffer.length-this._index},a.prototype.slice=function(b){var c=new a(this.buffer.slice(this._index,this._index+b));return this._index+=b,c},a.prototype.getBuffer=function(){return this.buffer},a}();module.exports=ByteStream;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var util=__webpack_require__(6),enums=__webpack_require__(9),assert=__webpack_require__(13),CP_CLASSES={},ConstUTF8=function(){function a(a){this.value=this.bytes2str(a)}return a.prototype.bytes2str=function(a){for(var b,c,d,e,f=0,g="";f<a.length;)d=255&a.readUInt8(f++),127>=d?e=d:223>=d?(b=a.readUInt8(f++),e=((31&d)<<6)+(63&b)):(b=a.readUInt8(f++),c=a.readUInt8(f++),e=((15&d)<<12)+((63&b)<<6)+(63&c)),g+=String.fromCharCode(e);return g},a.prototype.getType=function(){return enums.ConstantPoolItemType.UTF8},a.prototype.getConstant=function(a){return this.value},a.prototype.isResolved=function(){return!0},a.fromBytes=function(a,b){var c=a.getUint16();return new this(a.read(c))},a.size=1,a.infoByteSize=0,a}();exports.ConstUTF8=ConstUTF8,CP_CLASSES[enums.ConstantPoolItemType.UTF8]=ConstUTF8;var ConstInt32=function(){function a(a){this.value=a}return a.prototype.getType=function(){return enums.ConstantPoolItemType.INTEGER},a.prototype.getConstant=function(a){return this.value},a.prototype.isResolved=function(){return!0},a.fromBytes=function(a,b){return new this(a.getInt32())},a.size=1,a.infoByteSize=4,a}();exports.ConstInt32=ConstInt32,CP_CLASSES[enums.ConstantPoolItemType.INTEGER]=ConstInt32;var ConstFloat=function(){function a(a){this.value=a}return a.prototype.getType=function(){return enums.ConstantPoolItemType.FLOAT},a.prototype.getConstant=function(a){return this.value},a.prototype.isResolved=function(){return!0},a.fromBytes=function(a,b){return new this(a.getFloat())},a.size=1,a.infoByteSize=4,a}();exports.ConstFloat=ConstFloat,CP_CLASSES[enums.ConstantPoolItemType.FLOAT]=ConstFloat;var ConstLong=function(){function a(a){this.value=a}return a.prototype.getType=function(){return enums.ConstantPoolItemType.LONG},a.prototype.getConstant=function(a){return this.value},a.prototype.isResolved=function(){return!0},a.fromBytes=function(a,b){return new this(a.getInt64())},a.size=2,a.infoByteSize=8,a}();exports.ConstLong=ConstLong,CP_CLASSES[enums.ConstantPoolItemType.LONG]=ConstLong;var ConstDouble=function(){function a(a){this.value=a}return a.prototype.getType=function(){return enums.ConstantPoolItemType.DOUBLE},a.prototype.getConstant=function(a){return this.value},a.prototype.isResolved=function(){return!0},a.fromBytes=function(a,b){return new this(a.getDouble())},a.size=2,a.infoByteSize=8,a}();exports.ConstDouble=ConstDouble,CP_CLASSES[enums.ConstantPoolItemType.DOUBLE]=ConstDouble;var ClassReference=function(){function a(a){this.cls=null,this.clsConstructor=null,this.arrayClass=null,this.arrayClassConstructor=null,this.name=a}return a.prototype.tryResolve=function(a){return null===this.cls&&(this.cls=a.getResolvedClass(this.name)),null!==this.cls},a.prototype.resolve=function(a,b,c,d,e){var f=this;if(void 0===e&&(e=!0),null!==a){var g=a.currentMethod();if(null!==g&&this.name===g.cls.getInternalName())return this.setResolved(a,a.currentMethod().cls),d(!0)}b.resolveClass(a,this.name,function(b){f.setResolved(a,b),d(null!==b)},e)},a.prototype.setResolved=function(a,b){this.cls=b,null!==b&&(this.clsConstructor=b.getConstructor(a))},a.prototype.getType=function(){return enums.ConstantPoolItemType.CLASS},a.prototype.getConstant=function(a){return this.cls.getClassObject(a)},a.prototype.isResolved=function(){return null!==this.cls},a.fromBytes=function(a,b){var c=a.getUint16(),d=b.get(c);return new this(util.typestr2descriptor(d.value))},a.size=1,a.infoByteSize=2,a}();exports.ClassReference=ClassReference,CP_CLASSES[enums.ConstantPoolItemType.CLASS]=ClassReference;var NameAndTypeInfo=function(){function a(a,b){this.name=a,this.descriptor=b}return a.prototype.getType=function(){return enums.ConstantPoolItemType.NAME_AND_TYPE},a.prototype.isResolved=function(){return!0},a.fromBytes=function(a,b){var c=a.getUint16(),d=a.getUint16(),e=b.get(c),f=b.get(d);return new this(e.value,f.value)},a.size=1,a.infoByteSize=4,a}();exports.NameAndTypeInfo=NameAndTypeInfo,CP_CLASSES[enums.ConstantPoolItemType.NAME_AND_TYPE]=NameAndTypeInfo;var ConstString=function(){function a(a){this.value=null,this.stringValue=a}return a.prototype.getType=function(){return enums.ConstantPoolItemType.STRING},a.prototype.resolve=function(a,b,c,d){this.value=a.getJVM().internString(this.stringValue),setImmediate(function(){return d(!0)})},a.prototype.getConstant=function(a){return this.value},a.prototype.isResolved=function(){return null!==this.value},a.fromBytes=function(a,b){var c=a.getUint16(),d=b.get(c);return new this(d.value)},a.size=1,a.infoByteSize=2,a}();exports.ConstString=ConstString,CP_CLASSES[enums.ConstantPoolItemType.STRING]=ConstString;var MethodType=function(){function a(a){this.methodType=null,this.descriptor=a}return a.prototype.resolve=function(a,b,c,d){var e=this;util.createMethodType(a,b,this.descriptor,function(b,c){b?(a.throwException(b),d(!1)):(e.methodType=c,d(!0))})},a.prototype.getConstant=function(a){return this.methodType},a.prototype.getType=function(){return enums.ConstantPoolItemType.METHOD_TYPE},a.prototype.isResolved=function(){return null!==this.methodType},a.fromBytes=function(a,b){var c=a.getUint16(),d=b.get(c);return new this(d.value)},a.size=1,a.infoByteSize=2,a}();exports.MethodType=MethodType,CP_CLASSES[enums.ConstantPoolItemType.METHOD_TYPE]=MethodType;var MethodReference=function(){function a(a,b){this.method=null,this.fullSignature=null,this.paramWordSize=-1,this.memberName=null,this.appendix=null,this.jsConstructor=null,this.classInfo=a,this.nameAndTypeInfo=b,this.signature=this.nameAndTypeInfo.name+this.nameAndTypeInfo.descriptor}return a.prototype.getType=function(){return enums.ConstantPoolItemType.METHODREF},a.prototype.hasAccess=function(a,b,c){var d=this.method,e=b.method.cls;return d.accessFlags.isStatic()!==c?(a.throwNewException("Ljava/lang/IncompatibleClassChangeError;","Method "+d.name+" from class "+d.cls.getExternalName()+" is "+(c?"not ":"")+"static."),b.returnToThreadLoop=!0,!1):util.checkAccess(e,d.cls,d.accessFlags)?!0:(a.throwNewException("Ljava/lang/IllegalAccessError;",e.getExternalName()+" cannot access "+d.cls.getExternalName()+"."+d.name),b.returnToThreadLoop=!0,!1)},a.prototype.resolveMemberName=function(a,b,c,d,e){var f=this,g=b.getBsCl().getInitializedClass(b,"Ljava/lang/invoke/MethodHandleNatives;").getConstructor(b),h=new(b.getBsCl().getInitializedClass(b,"[Ljava/lang/Object;").getConstructor(b))(b,1);util.createMethodType(b,c,this.nameAndTypeInfo.descriptor,function(a,c){a?(b.throwException(a),e(!1)):g["java/lang/invoke/MethodHandleNatives/linkMethod(Ljava/lang/Class;ILjava/lang/Class;Ljava/lang/String;Ljava/lang/Object;[Ljava/lang/Object;)Ljava/lang/invoke/MemberName;"](b,[d.getClassObject(b),enums.MethodHandleReferenceKind.INVOKEVIRTUAL,f.classInfo.cls.getClassObject(b),b.getJVM().internString(f.nameAndTypeInfo.name),c,h],function(a,c){null!==a?(b.throwException(a),e(!1)):(f.appendix=h.array[0],f.memberName=c,e(!0))})})},a.prototype.resolve=function(a,b,c,d,e){var f=this;if(void 0===e&&(e=!0),this.classInfo.isResolved()){var g=this.classInfo.cls,h=g.methodLookup(this.signature);if(null===h&&util.is_reference_type(g.getInternalName())&&(h=g.signaturePolymorphicAwareMethodLookup(this.signature),null!==h&&("invoke"===h.name||"invokeExact"===h.name)))return this.resolveMemberName(h,a,b,c,function(b){b===!0?f.setResolved(a,h):a.throwNewException("Ljava/lang/NoSuchMethodError;","Method "+f.signature+" does not exist in class "+f.classInfo.cls.getExternalName()+"."),d(b)});null!==h?(this.setResolved(a,h),d(!0)):(a.throwNewException("Ljava/lang/NoSuchMethodError;","Method "+this.signature+" does not exist in class "+this.classInfo.cls.getExternalName()+"."),d(!1))}else this.classInfo.resolve(a,b,c,function(g){g?f.resolve(a,b,c,d,e):d(!1)},e)},a.prototype.setResolved=function(a,b){this.method=b,this.paramWordSize=util.getMethodDescriptorWordSize(this.nameAndTypeInfo.descriptor),this.fullSignature=this.method.fullSignature,this.jsConstructor=this.method.cls.getConstructor(a)},a.prototype.isResolved=function(){return null!==this.method},a.prototype.getParamWordSize=function(){return-1===this.paramWordSize&&(this.paramWordSize=util.getMethodDescriptorWordSize(this.nameAndTypeInfo.descriptor)),this.paramWordSize},a.fromBytes=function(a,b){var c=a.getUint16(),d=a.getUint16(),e=b.get(c),f=b.get(d);return new this(e,f)},a.size=1,a.infoByteSize=4,a}();exports.MethodReference=MethodReference,CP_CLASSES[enums.ConstantPoolItemType.METHODREF]=MethodReference;var InterfaceMethodReference=function(){function a(a,b){this.fullSignature=null,this.method=null,this.paramWordSize=-1,this.jsConstructor=null,this.classInfo=a,this.nameAndTypeInfo=b,this.signature=this.nameAndTypeInfo.name+this.nameAndTypeInfo.descriptor}return a.prototype.getType=function(){return enums.ConstantPoolItemType.INTERFACE_METHODREF},a.prototype.hasAccess=function(a,b,c){var d=this.method,e=b.method.cls;return d.accessFlags.isStatic()!==c?(a.throwNewException("Ljava/lang/IncompatibleClassChangeError;","Method "+d.name+" from class "+d.cls.getExternalName()+" is "+(c?"not ":"")+"static."),b.returnToThreadLoop=!0,!1):util.checkAccess(e,d.cls,d.accessFlags)?!0:(a.throwNewException("Ljava/lang/IllegalAccessError;",e.getExternalName()+" cannot access "+d.cls.getExternalName()+"."+d.name),b.returnToThreadLoop=!0,!1)},a.prototype.resolve=function(a,b,c,d,e){var f=this;if(void 0===e&&(e=!0),this.classInfo.isResolved()){var g=this.classInfo.cls,h=g.methodLookup(this.signature);this.paramWordSize=util.getMethodDescriptorWordSize(this.nameAndTypeInfo.descriptor),null!==h?(this.setResolved(a,h),d(!0)):(a.throwNewException("Ljava/lang/NoSuchMethodError;","Method "+this.signature+" does not exist in class "+this.classInfo.cls.getExternalName()+"."),d(!1))}else this.classInfo.resolve(a,b,c,function(g){g?f.resolve(a,b,c,d,e):d(!1)},e)},a.prototype.setResolved=function(a,b){this.method=b,this.paramWordSize=util.getMethodDescriptorWordSize(this.nameAndTypeInfo.descriptor),this.fullSignature=this.method.fullSignature,this.jsConstructor=this.method.cls.getConstructor(a)},a.prototype.getParamWordSize=function(){return-1===this.paramWordSize&&(this.paramWordSize=util.getMethodDescriptorWordSize(this.nameAndTypeInfo.descriptor)),this.paramWordSize},a.prototype.isResolved=function(){return null!==this.method},a.fromBytes=function(a,b){var c=a.getUint16(),d=a.getUint16(),e=b.get(c),f=b.get(d);return new this(e,f)},a.size=1,a.infoByteSize=4,a}();exports.InterfaceMethodReference=InterfaceMethodReference,CP_CLASSES[enums.ConstantPoolItemType.INTERFACE_METHODREF]=InterfaceMethodReference;var FieldReference=function(){function a(a,b){this.field=null,this.fullFieldName=null,this.fieldOwnerConstructor=null,this.classInfo=a,this.nameAndTypeInfo=b}return a.prototype.getType=function(){return enums.ConstantPoolItemType.FIELDREF},a.prototype.hasAccess=function(a,b,c){var d=this.field,e=b.method.cls;return d.accessFlags.isStatic()!==c?(a.throwNewException("Ljava/lang/IncompatibleClassChangeError;","Field "+name+" from class "+d.cls.getExternalName()+" is "+(c?"not ":"")+"static."),b.returnToThreadLoop=!0,!1):util.checkAccess(e,d.cls,d.accessFlags)?!0:(a.throwNewException("Ljava/lang/IllegalAccessError;",e.getExternalName()+" cannot access "+d.cls.getExternalName()+"."+name),b.returnToThreadLoop=!0,!1)},a.prototype.resolve=function(a,b,c,d,e){var f=this;if(void 0===e&&(e=!0),this.classInfo.isResolved()){var g=this.classInfo.cls,h=g.fieldLookup(this.nameAndTypeInfo.name);null!==h?(this.fullFieldName=util.descriptor2typestr(h.cls.getInternalName())+"/"+h.name,this.field=h,d(!0)):(a.throwNewException("Ljava/lang/NoSuchFieldError;","Field "+this.nameAndTypeInfo.name+" does not exist in class "+this.classInfo.cls.getExternalName()+"."),d(!1))}else this.classInfo.resolve(a,b,c,function(g){g?f.resolve(a,b,c,d,e):d(!1)},e)},a.prototype.isResolved=function(){return null!==this.field},a.fromBytes=function(a,b){var c=a.getUint16(),d=a.getUint16(),e=b.get(c),f=b.get(d);return new this(e,f)},a.size=1,a.infoByteSize=4,a}();exports.FieldReference=FieldReference,CP_CLASSES[enums.ConstantPoolItemType.FIELDREF]=FieldReference;var InvokeDynamic=function(){function a(a,b){this.callSiteObjects={},this.methodType=null,this.bootstrapMethodAttrIndex=a,this.nameAndTypeInfo=b,this.paramWordSize=util.getMethodDescriptorWordSize(this.nameAndTypeInfo.descriptor)}return a.prototype.getType=function(){return enums.ConstantPoolItemType.INVOKE_DYNAMIC},a.prototype.isResolved=function(){return null!==this.methodType},a.prototype.resolve=function(a,b,c,d){var e=this;util.createMethodType(a,b,this.nameAndTypeInfo.descriptor,function(b,c){b?(a.throwException(b),d(!1)):(e.methodType=c,d(!0))})},a.prototype.getCallSiteObject=function(a){var b=this.callSiteObjects[a];return b?b:null},a.prototype.constructCallSiteObject=function(a,b,c,d,e,f){function g(){var c,d,e=i[1],f=new(a.getBsCl().getInitializedClass(a,"[Ljava/lang/Object;").getConstructor(a))(a,e.length),g=f.array;for(c=0;c<e.length;c++)switch(d=e[c],d.getType()){case enums.ConstantPoolItemType.CLASS:g[c]=d.cls.getClassObject(a);break;case enums.ConstantPoolItemType.METHOD_HANDLE:g[c]=d.methodHandle;break;case enums.ConstantPoolItemType.METHOD_TYPE:g[c]=d.methodType;break;case enums.ConstantPoolItemType.STRING:g[c]=d.value;break;case enums.ConstantPoolItemType.UTF8:g[c]=a.getJVM().internString(d.value);break;case enums.ConstantPoolItemType.INTEGER:g[c]=b.getInitializedClass(a,"I").createWrapperObject(a,d.value);break;case enums.ConstantPoolItemType.LONG:g[c]=b.getInitializedClass(a,"J").createWrapperObject(a,d.value);break;case enums.ConstantPoolItemType.FLOAT:g[c]=b.getInitializedClass(a,"F").createWrapperObject(a,d.value);break;case enums.ConstantPoolItemType.DOUBLE:g[c]=b.getInitializedClass(a,"D").createWrapperObject(a,d.value)}return f}var h=this;void 0===f&&(f=!0);var i=c.getBootstrapMethod(this.bootstrapMethodAttrIndex),j=i[1].concat(i[0],this).filter(function(a){return!a.isResolved()});if(j.length>0)return util.asyncForEach(j,function(d,e){d.resolve(a,b,c,function(a){a?e():e("Failed.")},f)},function(g){g?e(!1):h.constructCallSiteObject(a,b,c,d,e,f)});var k=a.getJVM().internString(this.nameAndTypeInfo.name),l=new(b.getInitializedClass(a,"[Ljava/lang/Object;").getConstructor(a))(a,1),m=g(),n=b.getInitializedClass(a,"Ljava/lang/invoke/MethodHandleNatives;").getConstructor(a);n["java/lang/invoke/MethodHandleNatives/linkCallSite(Ljava/lang/Object;Ljava/lang/Object;Ljava/lang/Object;Ljava/lang/Object;Ljava/lang/Object;[Ljava/lang/Object;)Ljava/lang/invoke/MemberName;"](a,[c.getClassObject(a),i[0].methodHandle,k,this.methodType,m,l],function(b,c){b?(a.throwException(b),e(!1)):(h.setResolved(d,[c,l.array[0]]),e(!0))})},a.prototype.setResolved=function(a,b){void 0===this.callSiteObjects[a]&&(this.callSiteObjects[a]=b)},a.fromBytes=function(a,b){var c=a.getUint16(),d=a.getUint16(),e=b.get(d);return new this(c,e)},a.size=1,a.infoByteSize=4,a}();exports.InvokeDynamic=InvokeDynamic,CP_CLASSES[enums.ConstantPoolItemType.INVOKE_DYNAMIC]=InvokeDynamic;var MethodHandle=function(){function a(a,b){this.methodHandle=null,this.reference=a,this.referenceType=b}return a.prototype.getType=function(){return enums.ConstantPoolItemType.METHOD_HANDLE},a.prototype.isResolved=function(){return null!==this.methodHandle},a.prototype.getConstant=function(a){return this.methodHandle},a.prototype.resolve=function(a,b,c,d,e){var f=this;return this.reference.isResolved()?void this.constructMethodHandleType(a,b,function(e){if(null===e)d(!1);else{var g=b.getInitializedClass(a,"Ljava/lang/invoke/MethodHandleNatives;").getConstructor(a);g["linkMethodHandleConstant(Ljava/lang/Class;ILjava/lang/Class;Ljava/lang/String;Ljava/lang/Object;)Ljava/lang/invoke/MethodHandle;"](a,[c.getClassObject(a),f.referenceType,f.getDefiningClassObj(a),a.getJVM().internString(f.reference.nameAndTypeInfo.name),e],function(b,c){b?(a.throwException(b),d(!1)):(f.methodHandle=c,d(!0))})}}):this.reference.resolve(a,b,c,function(g){g?f.resolve(a,b,c,d,e):d(!1)},e)},a.prototype.getDefiningClassObj=function(a){return this.reference.getType()===enums.ConstantPoolItemType.FIELDREF?this.reference.field.cls.getClassObject(a):this.reference.method.cls.getClassObject(a)},a.prototype.constructMethodHandleType=function(a,b,c){if(this.reference.getType()===enums.ConstantPoolItemType.FIELDREF){var d=this.reference.nameAndTypeInfo.descriptor;b.resolveClass(a,d,function(b){c(null!==b?b.getClassObject(a):null)})}else util.createMethodType(a,b,this.reference.nameAndTypeInfo.descriptor,function(b,d){b?(a.throwException(b),c(null)):c(d)})},a.fromBytes=function(a,b){var c=a.getUint8(),d=a.getUint16(),e=b.get(d);return new this(e,c)},a.size=1,a.infoByteSize=3,a}();exports.MethodHandle=MethodHandle,CP_CLASSES[enums.ConstantPoolItemType.METHOD_HANDLE]=MethodHandle;var CONSTANT_POOL_TIER=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];!function(a){a.forEach(function(a,b){a.forEach(function(a){CONSTANT_POOL_TIER[a]=b})})}([[enums.ConstantPoolItemType.UTF8,enums.ConstantPoolItemType.INTEGER,enums.ConstantPoolItemType.FLOAT,enums.ConstantPoolItemType.LONG,enums.ConstantPoolItemType.DOUBLE],[enums.ConstantPoolItemType.CLASS,enums.ConstantPoolItemType.STRING,enums.ConstantPoolItemType.NAME_AND_TYPE,enums.ConstantPoolItemType.METHOD_TYPE],[enums.ConstantPoolItemType.FIELDREF,enums.ConstantPoolItemType.METHODREF,enums.ConstantPoolItemType.INTERFACE_METHODREF,enums.ConstantPoolItemType.INVOKE_DYNAMIC],[enums.ConstantPoolItemType.METHOD_HANDLE]]);var ConstantPool=function(){function a(){}return a.prototype.parse=function(a,b){var c=this;void 0===b&&(b=null);var d=a.getUint16(),e=[[],[],[]],f=0,g=1,h=0,i=0,j=0;for(this.constantPool=new Array(d);d>g;)i=a.pos(),h=a.getUint8(),j=CONSTANT_POOL_TIER[h],j>0?(e[j-1].push({offset:i,index:g}),a.skip(CP_CLASSES[h].infoByteSize)):this.constantPool[g]=CP_CLASSES[h].fromBytes(a,this),g+=CP_CLASSES[h].size;return f=a.pos(),e.forEach(function(d){d.forEach(function(d){if(a.seek(d.offset),h=a.getUint8(),c.constantPool[d.index]=CP_CLASSES[h].fromBytes(a,c),null!==b&&null!==b.array[d.index]&&void 0!==b.array[d.index]){var e=b.array[d.index];switch(e.getClass().getInternalName()){case"Ljava/lang/Integer;":c.constantPool[d.index].value=e["java/lang/Integer/value"];break;case"Ljava/lang/Long;":c.constantPool[d.index].value=e["java/lang/Long/value"];break;case"Ljava/lang/Float;":c.constantPool[d.index].value=e["java/lang/Float/value"];break;case"Ljava/lang/Double;":c.constantPool[d.index].value=e["java/lang/Double/value"];break;case"Ljava/lang/String;":c.constantPool[d.index].value=e.toString();break;case"Ljava/lang/Class;":c.constantPool[d.index].name=e.$cls.getInternalName(),c.constantPool[d.index].cls=e.$cls;break;default:c.constantPool[d.index].stringValue="",c.constantPool[d.index].value=e}}})}),a.seek(f),a},a.prototype.get=function(a){return this.constantPool[a]},a.prototype.each=function(a){this.constantPool.forEach(function(b,c){void 0!==b&&a(c,b)})},a}();exports.ConstantPool=ConstantPool;


/***/ },
/* 24 */
/***/ function(module, exports) {

	"use strict";var ClassLock=function(){function a(){this.queue=[]}return a.prototype.tryLock=function(a,b){return 1===this.queue.push({thread:a,cb:b})},a.prototype.unlock=function(a){var b,c=this.queue.length;for(b=0;c>b;b++)this.queue[b].cb(a);this.queue=[]},a.prototype.getOwner=function(){return this.queue.length>0?this.queue[0].thread:null},a}();module.exports=ClassLock;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var enums=__webpack_require__(9),assert=__webpack_require__(13),Monitor=function(){function a(){this.owner=null,this.count=0,this.blocked={},this.waiting={}}return a.prototype.enter=function(a,b){return this.owner===a?(this.count++,!0):this.contendForLock(a,1,enums.ThreadStatus.BLOCKED,b)},a.prototype.contendForLock=function(a,b,c,d){var e=this.owner;return null===e?(this.owner=a,this.count=b,!0):(this.blocked[a.getRef()]={thread:a,cb:d,count:b},a.setStatus(c,this),!1)},a.prototype.exit=function(a){var b=this.owner;return b===a?0===--this.count&&(this.owner=null,this.appointNewOwner()):a.throwNewException("Ljava/lang/IllegalMonitorStateException;","Cannot exit a monitor that you do not own."),b===a},a.prototype.appointNewOwner=function(){var a=Object.keys(this.blocked);if(a.length>0){var b=a[Math.floor(Math.random()*a.length)],c=this.blocked[b];this.unblock(c.thread,!1)}},a.prototype.wait=function(a,b,c,d){var e=this;return this.getOwner()===a?(this.waiting[a.getRef()]={thread:a,cb:b,count:this.count,isTimed:null!=c&&0!==c},this.owner=null,this.count=0,null!=c&&0!==c?(this.waiting[a.getRef()].timer=setTimeout(function(){e.unwait(a,!0)},c),a.setStatus(enums.ThreadStatus.TIMED_WAITING,this)):a.setStatus(enums.ThreadStatus.WAITING,this),this.appointNewOwner(),!0):(a.throwNewException("Ljava/lang/IllegalMonitorStateException;","Cannot wait on an object that you do not own."),!1)},a.prototype.unwait=function(a,b,c,d){void 0===c&&(c=!1),void 0===d&&(d=null);var e=this.waiting[a.getRef()],f=enums.ThreadStatus.UNINTERRUPTABLY_BLOCKED,g=function(){a.setStatus(enums.ThreadStatus.RUNNABLE),c?d():e.cb(b)};if(delete this.waiting[a.getRef()],a.getStatus()===enums.ThreadStatus.TIMED_WAITING&&!b){var h=e.timer;clearTimeout(h)}this.contendForLock(a,e.count,f,g)&&g()},a.prototype.unblock=function(a,b){void 0===b&&(b=!1);var c=this.blocked[a.getRef()];null!=c&&(delete this.blocked[a.getRef()],a.setStatus(enums.ThreadStatus.RUNNABLE),b||(this.owner=a,this.count=c.count,c.cb()))},a.prototype.notify=function(a){if(this.owner===a){var b=Object.keys(this.waiting);b.length>0&&this.unwait(this.waiting[b[Math.floor(Math.random()*b.length)]].thread,!1)}else a.throwNewException("Ljava/lang/IllegalMonitorStateException;","Cannot notify on a monitor that you do not own.")},a.prototype.notifyAll=function(a){if(this.owner===a){var b,c=Object.keys(this.waiting);for(b=0;b<c.length;b++)this.unwait(this.waiting[c[b]].thread,!1)}else a.throwNewException("Ljava/lang/IllegalMonitorStateException;","Cannot notifyAll on a monitor that you do not own.")},a.prototype.getOwner=function(){return this.owner},a.prototype.isWaiting=function(a){return null!=this.waiting[a.getRef()]&&!this.waiting[a.getRef()].isTimed},a.prototype.isTimedWaiting=function(a){return null!=this.waiting[a.getRef()]&&this.waiting[a.getRef()].isTimed},a.prototype.isBlocked=function(a){return null!=this.blocked[a.getRef()]},a}();module.exports=Monitor;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function win2nix(a){return a.replace(/\\/g,"/")}function parseMetaIndex(a){for(var b=a.split("\n"),c={},d=null,e=0;e<b.length;e++){var f=b[e];if(f.length>0)switch(f[0]){case"%":case"@":continue;case"!":case"#":var g=f.slice(2);c[g]=d={};break;default:"/"===f[f.length-1]&&(f=f.slice(0,f.length-1));var h=f.split("/"),i=d,j=void 0;for(j=0;j<h.length-1;j++){var k=h[j],l=i[k];i=l?i[k]:i[k]={}}i[h[j]]=!0}}return c}function ClasspathFactory(a,b,c){var d=new Array(b.length),e=0;fs.readFile(nodePath.join(a,"lib","meta-index"),function(f,g){var h={};f||(h=parseMetaIndex(g.toString())),util.asyncForEach(b,function(b,c){var f=nodePath.relative(a+"/lib",b);fs.stat(b,function(a,g){var i;i=a?new ClasspathNotFound(b):g.isDirectory()?new ClasspathFolder(b):h[f]?new IndexedClasspathJar(h[f],b):new UnindexedClasspathJar(b),d[e++]=i,i.initialize(c)})},function(a){c(d)})})}var __extends=this&&this.__extends||function(a,b){function c(){this.constructor=a}for(var d in b)b.hasOwnProperty(d)&&(a[d]=b[d]);a.prototype=null===b?Object.create(b):(c.prototype=b.prototype,new c)},enums_1=__webpack_require__(9),assert=__webpack_require__(13),fs=__webpack_require__(27),BrowserFS=__webpack_require__(4),bfsPath=BrowserFS.BFSRequire("path"),nodePath=__webpack_require__(28),util=__webpack_require__(6),BFSFS=BrowserFS.BFSRequire("fs"),ZipFS=BrowserFS.FileSystem.ZipFS,AbstractClasspathJar=function(){function a(a){this._fs=new BFSFS.FS,this._jarRead=enums_1.TriState.INDETERMINATE,this._path=a}return a.prototype.getPath=function(){return this._path},a.prototype.loadJar=function(a){var b=this;this._jarRead!==enums_1.TriState.TRUE?fs.readFile(this._path,function(c,d){if(c)b._jarRead=enums_1.TriState.FALSE,a(c);else try{ZipFS.computeIndex(d,function(c){try{b._fs.initialize(new ZipFS(c,bfsPath.basename(b._path))),b._jarRead=enums_1.TriState.TRUE,a()}catch(d){b._jarRead=enums_1.TriState.FALSE,a(d)}})}catch(c){b._jarRead=enums_1.TriState.FALSE,a(c)}}):setImmediate(function(){return a(b._jarRead===enums_1.TriState.TRUE?null:new Error("Failed to load JAR file."))})},a.prototype.tryLoadClassSync=function(a){if(this._jarRead!==enums_1.TriState.TRUE)return null;if(this.hasClass(a)===enums_1.TriState.FALSE)return null;try{return this._fs.readFileSync("/"+a+".class")}catch(b){return null}},a.prototype._wrapOp=function(a,b){var c=this;switch(this._jarRead){case enums_1.TriState.TRUE:a();break;case enums_1.TriState.FALSE:setImmediate(function(){return b(new Error("Unable to load JAR file."))});break;default:this.loadJar(function(){c._wrapOp(a,b)})}},a.prototype._wrapSyncOp=function(a){if(this._jarRead!==enums_1.TriState.TRUE)return null;try{return a()}catch(b){return null}},a.prototype.loadClass=function(a,b){var c=this;this._wrapOp(function(){c._fs.readFile("/"+a+".class",b)},b)},a.prototype.statResource=function(a,b){var c=this;this._wrapOp(function(){c._fs.stat(a,b)},b)},a.prototype.readdir=function(a,b){var c=this;this._wrapOp(function(){c._fs.readdir(win2nix(a),b)},b)},a.prototype.tryReaddirSync=function(a){var b=this;return this._wrapSyncOp(function(){return b._fs.readdirSync(win2nix(a))})},a.prototype.tryStatSync=function(a){var b=this;return this._wrapSyncOp(function(){return b._fs.statSync(win2nix(a))})},a.prototype.getFS=function(){return this._fs.getRootFS()},a}();exports.AbstractClasspathJar=AbstractClasspathJar;var UnindexedClasspathJar=function(a){function b(b){a.call(this,b),this._classList=null}return __extends(b,a),b.prototype.hasClass=function(a){return this._jarRead===enums_1.TriState.FALSE?enums_1.TriState.FALSE:this._hasClass(a)},b.prototype._hasClass=function(a){return this._classList?this._classList[a]?enums_1.TriState.TRUE:enums_1.TriState.FALSE:enums_1.TriState.INDETERMINATE},b.prototype.initializeWithClasslist=function(a){this._classList={};for(var b=a.length,c=0;b>c;c++)this._classList[a[c]]=!0},b.prototype.initialize=function(a){var b=this;this.loadJar(function(c){if(c)a();else{for(var d=["/"],e=[],f=b._fs;d.length>0;){var g=d.pop();try{var h=f.statSync(g);if(h.isDirectory())for(var i=f.readdirSync(g),j=0;j<i.length;j++)d.push(bfsPath.join(g,i[j]));else".class"===bfsPath.extname(g)&&e.push(g.slice(1,g.length-6))}catch(k){}}b.initializeWithClasslist(e),a()}})},b}(AbstractClasspathJar);exports.UnindexedClasspathJar=UnindexedClasspathJar;var IndexedClasspathJar=function(a){function b(b,c){a.call(this,c),this._metaIndex=b,this._metaName=bfsPath.basename(c)}return __extends(b,a),b.prototype.initialize=function(a){setImmediate(function(){return a()})},b.prototype.hasClass=function(a){if(this._jarRead===enums_1.TriState.FALSE)return enums_1.TriState.FALSE;var b=a.split("/"),c=this._metaIndex;b.pop();for(var d=0;d<b.length;d++){var e=c[b[d]];if(!e)return enums_1.TriState.FALSE;if(e===!0)return enums_1.TriState.INDETERMINATE;c=e}return enums_1.TriState.FALSE},b}(AbstractClasspathJar);exports.IndexedClasspathJar=IndexedClasspathJar;var ClasspathFolder=function(){function a(a){this._path=a}return a.prototype.getPath=function(){return this._path},a.prototype.hasClass=function(a){return enums_1.TriState.INDETERMINATE},a.prototype.initialize=function(a){setImmediate(a)},a.prototype.tryLoadClassSync=function(a){try{return fs.readFileSync(nodePath.resolve(this._path,a+".class"))}catch(b){return null}},a.prototype.loadClass=function(a,b){fs.readFile(nodePath.resolve(this._path,a+".class"),b)},a.prototype.statResource=function(a,b){fs.stat(nodePath.resolve(this._path,a),b)},a.prototype.readdir=function(a,b){fs.readdir(nodePath.resolve(this._path,a),b)},a.prototype.tryReaddirSync=function(a){try{return fs.readdirSync(nodePath.resolve(this._path,a))}catch(b){return null}},a.prototype.tryStatSync=function(a){try{return fs.statSync(nodePath.resolve(this._path,a))}catch(b){return null}},a}();exports.ClasspathFolder=ClasspathFolder;var ClasspathNotFound=function(){function a(a){this._path=a}return a.prototype.getPath=function(){return this._path},a.prototype.hasClass=function(a){return enums_1.TriState.FALSE},a.prototype.initialize=function(a){setImmediate(a)},a.prototype.initializeWithClasslist=function(a){},a.prototype.tryLoadClassSync=function(a){return null},a.prototype._notFoundError=function(a){setImmediate(function(){return a(new Error("Class cannot be found."))})},a.prototype.loadClass=function(a,b){this._notFoundError(b)},a.prototype.statResource=function(a,b){this._notFoundError(b)},a.prototype.readdir=function(a,b){this._notFoundError(b)},a.prototype.tryReaddirSync=function(a){return null},a.prototype.tryStatSync=function(a){return null},a}();exports.ClasspathNotFound=ClasspathNotFound,exports.ClasspathFactory=ClasspathFactory;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var BrowserFS = __webpack_require__(4);module.exports=BrowserFS.BFSRequire('fs');


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var BrowserFS = __webpack_require__(4);module.exports=BrowserFS.BFSRequire('path');


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var BrowserFS = __webpack_require__(4);module.exports=BrowserFS.BFSRequire('buffer');


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";var Heap=function(){function a(b){this.size=b,this._sizeMap={},this._buffer=new Buffer(b),this._remaining=b,this._offset=0,this._freeLists=new Array(a._numSizeClasses);for(var c=0;c<a._numSizeClasses;c++)this._freeLists[c]=[]}return a.prototype.malloc=function(b){if(4>=b&&(b=4),this._remaining<b)throw"out of memory";var c,d;return d=a.size_to_class(b),c=this._freeLists[d].pop(),void 0===c&&(c=this.refill(d)),c},a.prototype.free=function(b){var c=b&~(a._chunkSize-1),d=this._sizeMap[c];this._freeLists[d].push(b)},a.prototype.store_word=function(a,b){this._buffer.writeInt32LE(b,a)},a.prototype.get_byte=function(a){return this._buffer.readUInt8(a)},a.prototype.get_word=function(a){return this._buffer.readInt32LE(a)},a.prototype.get_buffer=function(a,b){return this._buffer.slice(a,a+b)},a.prototype.get_signed_byte=function(a){return this._buffer.readInt8(a)},a.prototype.set_byte=function(a,b){this._buffer.writeUInt8(b,a)},a.prototype.set_signed_byte=function(a,b){this._buffer.writeInt8(b,a)},a.prototype.memcpy=function(a,b,c){this._buffer.copy(this._buffer,b,a,a+c)},a.prototype.refill=function(b){var c=this.cl_to_size(b),d=Math.floor(a._chunkSize/c);1>d&&(d=1);var e=this._offset;this._sizeMap[e]=b;for(var f=0;d>f;f++)this._remaining-=c,e=this._offset,this._freeLists[b].push(e),this._offset+=c;return e},a.ilog2=function(a){for(var b=0,c=1;a>c;)c<<=1,b++;return b},a.size_to_class=function(b){return a.ilog2(b)},a.prototype.cl_to_size=function(a){return 1<<a},a._numSizeClasses=64,a._chunkSize=4096,a}();module.exports=Heap;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var enums_1=__webpack_require__(9),assert=__webpack_require__(13),Parker=function(){function a(){this._parkCounts={},this._parkCallbacks={}}return a.prototype.park=function(a,b){var c=a.getRef();this._parkCallbacks[c]=b,this._mutateParkCount(a,1),this.isParked(a)&&a.setStatus(enums_1.ThreadStatus.PARKED)},a.prototype.unpark=function(a){this._mutateParkCount(a,-1)},a.prototype.completelyUnpark=function(a){var b=a.getRef(),c=this._parkCounts[b];c&&this._mutateParkCount(a,-c)},a.prototype._mutateParkCount=function(a,b){var c,d=a.getRef();this._parkCounts[d]||(this._parkCounts[d]=0),0===(this._parkCounts[d]+=b)&&(c=this._parkCallbacks[d],delete this._parkCounts[d],delete this._parkCallbacks[d],a.getStatus()===enums_1.ThreadStatus.PARKED&&(a.setStatus(enums_1.ThreadStatus.ASYNC_WAITING),c()))},a.prototype.isParked=function(a){return!!this._parkCounts[a.getRef()]},a}();module.exports=Parker;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function isRunnable(a){return a===enums_1.ThreadStatus.RUNNABLE}var enums_1=__webpack_require__(9),assert=__webpack_require__(13),WeightedRoundRobinScheduler=function(){function a(){this._count=0,this._queue=[],this._threadScheduled=!1}return a.prototype.scheduleThread=function(a){this._queue.push(a),1===this._queue.length&&this.runThread()},a.prototype.runThread=function(){var a=this;this._threadScheduled||(this._threadScheduled=!0,setImmediate(function(){var b=a._queue;if(a._threadScheduled=!1,b.length>0){var c=a._queue[0];c.run()}}))},a.prototype.unscheduleThread=function(a){var b=this._queue,c=b[0]===a;c?(b.shift(),this._count=0,this.runThread()):b.splice(b.indexOf(a),1)},a.prototype.getRunningThread=function(){var a=this._queue;return a.length>0?a[0]:null},a.prototype.priorityChange=function(a){},a.prototype.quantumOver=function(a){this._count++,(this._count>=a.getPriority()||a.getStatus()!==enums_1.ThreadStatus.RUNNABLE)&&(this._count=0,this._queue.push(this._queue.shift())),this.runThread()},a}(),ThreadPool=function(){function a(a){this.threads=[],this.scheduler=new WeightedRoundRobinScheduler,this.emptyCallback=a}return a.prototype.getThreads=function(){return this.threads.slice(0)},a.prototype.anyNonDaemonicThreads=function(){for(var a=0;a<this.threads.length;a++){var b=this.threads[a];if(!b.isDaemon()){var c=b.getStatus();if(c!==enums_1.ThreadStatus.NEW&&c!==enums_1.ThreadStatus.TERMINATED)return!0}}return!1},a.prototype.threadTerminated=function(a){var b=this.threads.indexOf(a);if(this.threads.splice(b,1),!this.anyNonDaemonicThreads()){var c=this.emptyCallback();c&&(this.emptyCallback=null)}},a.prototype.statusChange=function(a,b,c){var d=isRunnable(b),e=isRunnable(c);b!==enums_1.ThreadStatus.NEW&&b!==enums_1.ThreadStatus.TERMINATED||-1===this.threads.indexOf(a)&&this.threads.push(a),d!==e&&(d?this.scheduler.unscheduleThread(a):this.scheduler.scheduleThread(a)),c===enums_1.ThreadStatus.TERMINATED&&this.threadTerminated(a)},a.prototype.priorityChange=function(a){this.scheduler.priorityChange(a)},a.prototype.quantumOver=function(a){this.scheduler.quantumOver(a)},a}();exports.__esModule=!0,exports["default"]=ThreadPool;


/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = {
		"url": "https://github.com/plasma-umass/doppio_jcl/releases/download/v3.2/java_home.tar.gz",
		"classpath": [
			"lib/rt.jar",
			"lib/charsets.jar",
			"lib/doppio.jar",
			"lib/dt.jar",
			"lib/jce.jar",
			"lib/jconsole.jar",
			"lib/jsse.jar",
			"lib/management-agent.jar",
			"lib/resources.jar",
			"lib/sa-jdi.jar",
			"lib/tools.jar"
		]
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils   = __webpack_require__(35);
	var trees   = __webpack_require__(36);
	var adler32 = __webpack_require__(37);
	var crc32   = __webpack_require__(38);
	var msg     = __webpack_require__(39);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  s.d_buf = s.lit_bufsize >> 1;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ },
/* 35 */
/***/ function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(35);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ },
/* 37 */
/***/ function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ },
/* 39 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils         = __webpack_require__(35);
	var adler32       = __webpack_require__(37);
	var crc32         = __webpack_require__(38);
	var inflate_fast  = __webpack_require__(41);
	var inflate_table = __webpack_require__(42);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = zswap32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = { bits: state.distbits };
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ },
/* 41 */
/***/ function(module, exports) {

	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(35);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i = 0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ },
/* 43 */
/***/ function(module, exports) {

	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ },
/* 44 */
/***/ function(module, exports) {

	module.exports = {
		"name": "@hrj/doppiojvm-snapshot",
		"version": "0.4.14",
		"engine": "node >= 4.0.0",
		"license": "MIT",
		"main": "dist/release/doppio.js",
		"typings": "dist/typings/src/doppiojvm",
		"dependencies": {
			"async": "^1.5.2",
			"browserfs": "^0.5.12",
			"glob": "^7.0.3",
			"gunzip-maybe": "^1.3.1",
			"optimist": "~0.6",
			"pako": "^1.0.1",
			"rimraf": "^2.5.2",
			"source-map-support": "^0.4.0",
			"tar-fs": "^1.12.0"
		},
		"devDependencies": {
			"bfs-buffer": "^0.1.7",
			"bfs-path": "^0.1.2",
			"bfs-process": "^0.1.6",
			"body-parser": "^1.15.1",
			"cpr": "^1.1.1",
			"detect-browser": "^1.3.1",
			"escodegen": "^1.8.0",
			"esprima": "^2.7.2",
			"estraverse": "^4.2.0",
			"express": "^4.13.4",
			"grunt": "^1.0",
			"grunt-cli": "^1.2",
			"grunt-contrib-compress": "^1.2.0",
			"grunt-contrib-connect": "^1.0",
			"grunt-contrib-copy": "^1.0",
			"grunt-contrib-uglify": "^1.0",
			"grunt-karma": "^1.0",
			"grunt-lineending": "^0.2.4",
			"grunt-merge-source-maps": "^0.1.0",
			"grunt-newer": "^1.2.0",
			"grunt-ts": "^5.5",
			"grunt-webpack": "^1.0.11",
			"imports-loader": "^0.6.5",
			"jasmine-core": "^2.3.4",
			"json-loader": "^0.5.4",
			"karma": "^0.13.22",
			"karma-chrome-launcher": "^1.0",
			"karma-firefox-launcher": "^1.0",
			"karma-ie-launcher": "^1.0",
			"karma-jasmine": "^1.0",
			"karma-opera-launcher": "^1.0",
			"karma-safari-launcher": "^1.0",
			"locate-java-home": "^0.1.4",
			"semver": "^5.1.0",
			"source-map-loader": "^0.1.5",
			"typescript": "^1.8.10",
			"uglify-js": "^2.6.2",
			"underscore": "^1.8.3",
			"webpack": "^1.13.1",
			"webpack-dev-server": "^1.14.1"
		},
		"scripts": {
			"test": "grunt test",
			"prepublish": "node ./prepublish.js",
			"install": "node ./install.js",
			"appveyor-test": "grunt test-browser-appveyor"
		},
		"repository": {
			"type": "git",
			"url": "http://github.com/plasma-umass/doppio.git"
		},
		"bin": {
			"doppio": "./bin/doppio",
			"doppioh": "./bin/doppioh",
			"doppio-dev": "./bin/doppio-dev",
			"doppio-fast-dev": "./bin/doppio-fast-dev"
		}
	};

/***/ },
/* 45 */
/***/ function(module, exports) {

	"use strict";function text_diff(a,b,c){return new SequenceMatcher(a,b).text_diff(c)}function __ntuplecomp(a,b){for(var c=Math.max(a.length,b.length),d=0;c>d;d++){if(a[d]<b[d])return-1;if(a[d]>b[d])return 1}return a.length==b.length?0:a.length<b.length?-1:1}function __dictget(a,b,c){return a.hasOwnProperty(b)?a[b]:c}exports.text_diff=text_diff;var SequenceMatcher=function(){function a(a,b){this.a=a,this.b=b,this.b2j={};for(var c=0;c<b.length;c++){var d=b[c];this.b2j.hasOwnProperty(d)?this.b2j[d].push(c):this.b2j[d]=[c]}}return a.prototype.find_longest_match=function(a,b,c,d){for(var e=this.a,f=this.b,g=this.b2j,h=a,i=c,j=0,k={},l=a;b>l;l++){var m={},n=__dictget(g,e[l],[]);for(var o in n)if(n.hasOwnProperty(o)){var p=n[o];if(c>p)continue;if(p>=d)break;var q=__dictget(k,p-1,0)+1;m[p]=q,q>j&&(h=l-q+1,i=p-q+1,j=q)}k=m}for(;h>a&&i>c&&e[h-1]==f[i-1];)h--,i--,j++;for(;b>h+j&&d>i+j&&e[h+j]==f[i+j];)j++;return[h,i,j]},a.prototype.get_matching_blocks=function(){if(null!=this.matching_blocks)return this.matching_blocks;for(var a=this.a.length,b=this.b.length,c=[[0,a,0,b]],d=[];c.length;){var e=c.pop(),f=e[0],g=e[1],h=e[2],i=e[3],j=this.find_longest_match(f,g,h,i),k=j[0],l=j[1],m=j[2];m&&(d.push(j),k>f&&l>h&&c.push([f,k,h,l]),g>k+m&&i>l+m&&c.push([k+m,g,l+m,i]))}d.sort(__ntuplecomp);for(var n=0,o=0,p=0,q=[],r=0;r<d.length;r++){var s=d[r],t=s[0],u=s[1],v=s[2];n+p==t&&o+p==u?p+=v:(p&&q.push([n,o,p]),n=t,o=u,p=v)}return p&&q.push([n,o,p]),q.push([a,b,0]),this.matching_blocks=q,this.matching_blocks},a.prototype.get_opcodes=function(){if(null!=this.opcodes)return this.opcodes;var a=0,b=0,c=[];this.opcodes=c;for(var d=this.get_matching_blocks(),e=0;e<d.length;e++){var f=d[e],g=f[0],h=f[1],i=f[2],j="";g>a&&h>b?j="replace":g>a?j="delete":h>b&&(j="insert"),j&&c.push([j,a,g,b,h]),a=g+i,b=h+i,i&&c.push(["equal",g,a,h,b])}return c},a.prototype.text_diff=function(a){for(var b=this.get_opcodes(),c=[],d=[],e=[],f=0,g=-1,h=0;h<b.length;h++){var i=b[h];if("equal"!==i[0]){var j=i[1],k=i[3],l=i[2]-1,m=i[4]-1,n=Math.min(j,k),o=Math.max(l,m),p="";switch(i[0]){case"delete":p=" < ";break;case"insert":p=" > ";break;case"replace":p=" | "}for(var q=Math.max(g+1,n-a);n>q;q++){var r=q+": ";q<this.a.length?(d.push(r+this.a[q]),f=Math.max(f,this.a[q].length+r.length)):d.push(r),q<this.b.length?e.push(this.b[q]):e.push(""),c.push("   ")}for(var q=n;o>=q;q++){var r=q+": ";q>=j&&l>=q?(d.push(r+this.a[q]),f=Math.max(f,this.a[q].length+r.length)):d.push(r),q>=k&&m>=q?e.push(this.b[q]):e.push(""),c.push(p)}g=o}}for(var q=0;q<c.length;q++){var s=d[q],t=e[q];s.length<f&&(s+=new Array(f-s.length+1).join(" ")),c[q]=s+c[q]+t}return c},a}();exports.SequenceMatcher=SequenceMatcher;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var JVM=__webpack_require__(5);exports.JVM=JVM;var CLI=__webpack_require__(47);exports.CLI=CLI;var ClassFile=__webpack_require__(49);exports.ClassFile=ClassFile;var Threading=__webpack_require__(15);exports.Threading=Threading;var Long=__webpack_require__(8);exports.Long=Long;var Util=__webpack_require__(6);exports.Util=Util;var Enums=__webpack_require__(9);exports.Enums=Enums;var Interfaces=__webpack_require__(50);exports.Interfaces=Interfaces;var Monitor=__webpack_require__(25);exports.Monitor=Monitor;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";function java(a,b,c,d){void 0===d&&(d=function(a){});var e,f=parser.parse(a),g=f["default"],h=f.X;if(b.properties=g.mapOption("D"),g.flag("help",!1))return printHelp(b.launcherName,parser.help("default"),c,0);if(g.flag("X",!1))return printNonStandardHelp(b.launcherName,parser.help("X"),c,0);var i=h.stringOption("log","ERROR");if(b.intMode=h.flag("int",!1),b.dumpJITStats=h.flag("dump-JIT-stats",!1),/^[0-9]+$/.test(i))logging.log_level=parseInt(i,10);else{var j=logging[i.toUpperCase()];if(null==j)return process.stderr.write("Unrecognized log level: "+i+"."),printHelp(b.launcherName,parser.help("default"),c,1);logging.log_level=j}h.flag("list-class-cache",!1)&&(c=function(a){return function(b){var c=e.getBootstrapClassLoader().getLoadedClassFiles();process.stdout.write(c.join("\n")+"\n"),a(b)}}(c)),g.flag("enablesystemassertions",!1)&&(b.enableSystemAssertions=!0),g.flag("disablesystemassertions",!1)&&(b.enableSystemAssertions=!1),g.flag("enableassertions",!1)?b.enableAssertions=!0:g.stringOption("enableassertions",null)&&(b.enableAssertions=g.stringOption("enableassertions",null).split(":")),g.stringOption("disableassertions",null)&&(b.disableAssertions=g.stringOption("disableassertions",null).split(":"));var k=h.stringOption("bootclasspath",null);null!==k&&(b.bootstrapClasspath=k.split(":"));var l=h.stringOption("bootclasspath/a",null);l&&(b.bootstrapClasspath=b.bootstrapClasspath.concat(l.split(":")));var m=h.stringOption("bootclasspath/p",null);m&&(b.bootstrapClasspath=m.split(":").concat(b.bootstrapClasspath)),b.classpath||(b.classpath=[]),g.stringOption("jar",null)?b.classpath.push(g.stringOption("jar",null)):g.stringOption("classpath",null)?b.classpath=b.classpath.concat(g.stringOption("classpath",null).split(":")):b.classpath.push(process.cwd());var n=g.stringOption("native-classpath",null);n&&(b.nativeClasspath=b.nativeClasspath.concat(n.split(":"))),e=new JVM(b,function(a){a?(process.stderr.write("Error constructing JVM:\n"),process.stderr.write(a.toString()+"\n"),c(1)):launchJvm(g,b,e,c,d)}),e.setPrintJITCompilation(h.flag("X:+PrintCompilation",!1));var o=h.stringOption("vtrace-methods",null);o&&o.split(":").forEach(function(a){return e.vtraceMethod(a)});var p=h.stringOption("dumpCompiledCode",null);p&&e.dumpCompiledCode(p)}function launchJvm(a,b,c,d,e){var f=a.unparsedArgs();if(a.stringOption("jar",null))c.runJar(f,d),e(c);else if(f.length>0){var g=f[0];".class"===g.slice(-6)&&(g=g.slice(0,-6)),-1!==g.indexOf(".")&&(g=util.descriptor2typestr(util.int_classname(g))),c.runClass(g,f.slice(1),d),e(c)}else printHelp(b.launcherName,parser.help("default"),d,0)}function printHelp(a,b,c,d){process.stdout.write("Usage: "+a+" [-options] class [args...]\n        (to execute a class)\nor  "+a+" [-options] -jar jarfile [args...]\n        (to execute a jar file)\nwhere options include:\n"+b),c(d)}function printNonStandardHelp(a,b,c,d){process.stdout.write(b+"\n\nThe -X options are non-standard and subject to change without notice.\n"),c(d)}var option_parser_1=__webpack_require__(48),JVM=__webpack_require__(5),util=__webpack_require__(6),logging=__webpack_require__(17),parser=new option_parser_1.OptionParser({"default":{classpath:{type:3,alias:"cp",optDesc:" <class search path of directories and zip/jar files>",desc:"A : separated list of directories, JAR archives, and ZIP archives to search for class files."},D:{type:4,optDesc:"<name>=<value>",desc:"set a system property"},jar:{type:3,stopParsing:!0},help:{alias:"?",desc:"print this help message"},X:{desc:"print help on non-standard options"},enableassertions:{type:2,optDesc:"[:<packagename>...|:<classname>]",alias:"ea",desc:"enable assertions with specified granularity"},disableassertions:{type:2,optDesc:"[:<packagename>...|:<classname>]",alias:"da",desc:"disable assertions with specified granularity"},enablesystemassertions:{alias:"esa",desc:"enable system assertions"},disablesystemassertions:{alias:"dsa",desc:"disable system assertions "}},X:{"int":{desc:"interpreted mode execution only"},"dump-JIT-stats":{desc:"dump JIT statistics"},log:{desc:"log level, [0-10]|vtrace|trace|debug|error",type:3},"vtrace-methods":{type:3,optDesc:" <java/lang/Object/getHashCode()I:...>",desc:"specify particular methods to vtrace separated by colons"},"list-class-cache":{desc:"list all of the bootstrap loaded classes after execution"},"dump-compiled-code":{type:3,optDesc:" <directory>",desc:"location to dump compiled object definitions"},"native-classpath":{type:3,optDesc:" <class search path of directories>",desc:"A : separated list of directories to search for native mathods in JS files."},"bootclasspath/a":{type:1,optDesc:":<directories and zip/jar files separated by :>",desc:"append to end of bootstrap class path"},"bootclasspath/p":{type:1,optDesc:":<directories and zip/jar files separated by :>",desc:"prepend in front of bootstrap class path"},bootclasspath:{type:1,optDesc:":<directories and zip/jar files separated by :>",desc:"set search path for bootstrap classes and resources"},"X:+PrintCompilation":{desc:"Print JIT compilation details"}}});module.exports=java;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ },
/* 48 */
/***/ function(module, exports) {

	"use strict";function getOptName(a,b){return"default"!==a?""+a+b:b}function printCol(a,b){for(var c=a,d=b-a.length;d-- >0;)c+=" ";return c}function _showHelp(a,b){var c={},d=13;return Object.keys(a).forEach(function(d){var e=a[d];if(!e.stopParsing){var f=[d];null!=e.alias&&f.push(e.alias);var g;g=e.optDesc?f.map(function(a){return"-"+b+a+e.optDesc}).join("\n"):f.map(function(a){return"-"+b+a}).join(" | "),c[g]=e}}),Object.keys(c).map(function(a){var b=c[a];if(b.optDesc){var e=a.split("\n"),f=e.map(function(a){return"    "+a});return f.join("\n")+"\n                  "+b.desc}var g=printCol(a,d);return g.length===d?"    "+g+" "+b.desc:"    "+g+"\n                  "+b.desc}).join("\n")+"\n"}var PrefixParseResult=function(){function a(a,b){void 0===b&&(b=[]),this._result=a,this._unparsedArgs=b}return a.prototype.unparsedArgs=function(){return this._unparsedArgs},a.prototype.flag=function(a,b){var c=this._result[a];return"boolean"==typeof c?c:b},a.prototype.stringOption=function(a,b){var c=this._result[a];return"string"==typeof c?c:b},a.prototype.mapOption=function(a){var b=this._result[a];return"object"==typeof b?b:{}},a}();exports.PrefixParseResult=PrefixParseResult;var OptionParser=function(){function a(a){var b=this;this._parseMap={},this._prefixes=[],this._mapArgs=[],this._rawDesc=a,this._prefixes=Object.keys(a),this._prefixes.forEach(function(c){var d=a[c],e=Object.keys(d);e.slice(0).forEach(function(a){var f=d[a];f.type||(f.type=0),4===f.type&&b._mapArgs.push(a),f.prefix=c,f.name=a,b._parseMap[getOptName(c,a)]=f,f.alias&&(e.push(f.alias),b._parseMap[getOptName(c,f.alias)]=f)})})}return a.prototype.parse=function(a){var b,c=this,d={},e=0;for(this._prefixes.forEach(function(a){return d[a]={}}),a=a.map(function(a){return a.trim()}).filter(function(a){return""!==a}),b=a.length;b>e;){var f=a[e];if("-"!==f[0])break;f=f.slice(1);var g;if(g=this._parseMap[f])switch(g.type){case 0:case 2:d[g.prefix][g.name]=!0;break;case 3:case 1:if(e++,!(b>e))throw new Error("-"+f+" requires an argument.");d[g.prefix][g.name]=a[e];break;case 4:break;default:throw new Error("INTERNAL ERROR: Invalid parse type for -"+f+".")}else if(this._mapArgs.filter(function(a){return f.slice(0,a.length)===a?(g=c._parseMap[a],!0):!1}).length>0){var h=f.slice(g.name.length),i=d[g.prefix][g.name];i||(i=d[g.prefix][g.name]={});var j=h.indexOf("=");-1!==j?i[h.slice(0,j)]=h.slice(j+1):i[h]=""}else{if(-1===f.indexOf(":")||!(g=this._parseMap[f.slice(0,f.indexOf(":"))]))throw new Error("Unrecognized option: -"+f);if(1!==g.type&&2!==g.type)throw new Error("Unrecognized option: -"+f);d[g.prefix][g.name]=f.slice(f.indexOf(":")+1)}if(g.stopParsing){e++;break}e++}var k=a.slice(e),l={};return Object.keys(d).forEach(function(a){l[a]=new PrefixParseResult(d[a],k)}),l},a.prototype.help=function(a){return _showHelp(this._rawDesc[a],"default"===a?"":a)},a}();exports.OptionParser=OptionParser;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function __export(a){for(var b in a)exports.hasOwnProperty(b)||(exports[b]=a[b])}var ConstantPool=__webpack_require__(23);exports.ConstantPool=ConstantPool;var Attributes=__webpack_require__(12);exports.Attributes=Attributes,__export(__webpack_require__(21)),__export(__webpack_require__(11)),__export(__webpack_require__(20)),__export(__webpack_require__(26));


/***/ },
/* 50 */
/***/ function(module, exports) {

	"use strict";


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";var Assert=__webpack_require__(13);exports.Assert=Assert;var Logging=__webpack_require__(17);exports.Logging=Logging;var Difflib=__webpack_require__(45);exports.Difflib=Difflib;


/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** release/doppio.js
 **/